
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0b56"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0b56"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dk7qG", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "registerRuntimeCompiler", () => (parcelRequire("TusQn")).registerRuntimeCompiler);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("eeJ70")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("8POXm");

var $3HHJ3 = parcelRequire("3HHJ3");

var $8POXm = parcelRequire("8POXm");
function $9b32e7f566245c4e$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $9b32e7f566245c4e$var$compileCache = /* @__PURE__ */ Object.create(null);
function $9b32e7f566245c4e$export$ef7acd7185315e22(template, options) {
    if (!(0, $8POXm.isString)(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return 0, $8POXm.NOOP;
    }
    const key = (0, $8POXm.genCacheKey)(template, options);
    const cached = $9b32e7f566245c4e$var$compileCache[key];
    if (cached) return cached;
    if (template[0] === "#") {
        const el = document.querySelector(template);
        template = el ? el.innerHTML : ``;
    }
    const opts = (0, $8POXm.extend)({
        hoistStatic: true,
        onError: void 0,
        onWarn: (0, $8POXm.NOOP)
    }, options);
    if (!opts.isCustomElement && typeof customElements !== "undefined") opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code: code } = (0, $3HHJ3.compile)(template, opts);
    function onError(err, asWarning = false) {
        const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc && (0, $8POXm.generateCodeFrame)(template, err.loc.start.offset, err.loc.end.offset);
        (0, $TusQn.warn)(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render = new Function("Vue", code)($9b32e7f566245c4e$import$4f81359071792c76);
    render._rc = true;
    return $9b32e7f566245c4e$var$compileCache[key] = render;
}
(0, $TusQn.registerRuntimeCompiler)($9b32e7f566245c4e$export$ef7acd7185315e22);

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0a6cc4ba868319ae$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb[i]);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$0a6cc4ba868319ae$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$setHmrUpdating = (v1)=>{
    try {
        return $0a6cc4ba868319ae$var$isHmrUpdating;
    } finally{
        $0a6cc4ba868319ae$var$isHmrUpdating = v1;
    }
};
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $0a6cc4ba868319ae$var$isHmrUpdating = true;
                instance.parent.update();
                $0a6cc4ba868319ae$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $0a6cc4ba868319ae$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $0a6cc4ba868319ae$var$blockStack.length; i > prevStackSize; i--)$0a6cc4ba868319ae$var$closeBlock();
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if ($0a6cc4ba868319ae$var$currentInstance) {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$export$f13e630aa3915748() || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $0a6cc4ba868319ae$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $0a6cc4ba868319ae$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($0a6cc4ba868319ae$var$pendingMounts.get(vnode) !== mountJob) return;
                $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
                if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $0a6cc4ba868319ae$var$pendingMounts.set(vnode, mountJob);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $0a6cc4ba868319ae$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$0a6cc4ba868319ae$var$pendingMounts.has(vnode) && (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $0a6cc4ba868319ae$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $0a6cc4ba868319ae$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(oldInnerChild, innerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$0a6cc4ba868319ae$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            const done = el[$0a6cc4ba868319ae$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $0a6cc4ba868319ae$export$7770a22486565649($0a6cc4ba868319ae$var$isTeleport(subTree.type) ? $0a6cc4ba868319ae$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $0a6cc4ba868319ae$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? (0, $8POXm.NO) : (key)=>{
        if ($0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $0a6cc4ba868319ae$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $0a6cc4ba868319ae$var$pendingSetRefMap.set(rawRef, job);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $0a6cc4ba868319ae$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $8POXm.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($0a6cc4ba868319ae$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $0a6cc4ba868319ae$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $0a6cc4ba868319ae$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$0a6cc4ba868319ae$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $0a6cc4ba868319ae$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $0a6cc4ba868319ae$var$normalizeHiddenValue(clientValue);
        } else if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$normalizeHiddenValue(value) {
    if (!(0, $8POXm.isRenderableAttrValue)(value)) return false;
    if ((0, $8POXm.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $8POXm.includeBooleanAttr)(value) ? "" : false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $8POXm.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    return $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr), allowedType);
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
function $0a6cc4ba868319ae$var$isNodeMismatchAllowed(node, vnode) {
    return $0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $0a6cc4ba868319ae$var$isMismatchAllowedByNode(node) || $0a6cc4ba868319ae$var$isMismatchAllowedByVNode(vnode);
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(node.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$0a6cc4ba868319ae$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $8POXm.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $0a6cc4ba868319ae$var$blockStack.length;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $0a6cc4ba868319ae$var$blockStack.length; i > prevStackSize; i--)$0a6cc4ba868319ae$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $8POXm.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && key[0] !== "$" && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (0, $8POXm.hasOwn)(props, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext("useSlots").slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext("useAttrs").attrs;
}
function $0a6cc4ba868319ae$var$getContext(calledFunctionName) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const inSSRSetup = $0a6cc4ba868319ae$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    const restore = ()=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($0a6cc4ba868319ae$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    };
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, prevSetValue) && ((0, $8POXm.hasChanged)(value, emittedValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $8POXm.EMPTY_OBJ) && !(0, $8POXm.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $0a6cc4ba868319ae$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $0a6cc4ba868319ae$var$isTeleport(root.type) ? $0a6cc4ba868319ae$var$getInnerChild$1(root) || root : root;
        $0a6cc4ba868319ae$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $8POXm.isObject)(nextProp) && (0, $8POXm.isObject)(prevProp)) return !(0, $8POXm.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && $0a6cc4ba868319ae$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if ((0, $8POXm.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(measureName, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMeasures(measureName);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0a6cc4ba868319ae$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$0a6cc4ba868319ae$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$0a6cc4ba868319ae$var$leaveCbKey];
                    if (el._isLeaving) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $0a6cc4ba868319ae$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$var$hasContentChildren(children) {
    if ((0, $8POXm.isString)(children)) return children !== "";
    if ((0, $8POXm.isArray)(children)) return children.length > 0;
    return false;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        if (shapeFlag & 65) {
            $0a6cc4ba868319ae$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $8POXm.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$setInSSRSetupState(true);
                try {
                    $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $0a6cc4ba868319ae$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])\w/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
                if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.41";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) {
            if ($005d1fb7704e278c$var$activeEffectScope.active) {
                this.parent = $005d1fb7704e278c$var$activeEffectScope;
                this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($005d1fb7704e278c$var$activeEffectScope === this) $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            else {
                let current = $005d1fb7704e278c$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope) {
            if ($005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
function $005d1fb7704e278c$var$toWrapped(target, item) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return $005d1fb7704e278c$export$352205f445242f02(target) ? $005d1fb7704e278c$export$4a78e7a2a4fb689f($005d1fb7704e278c$export$45c769cf449a508c(item)) : $005d1fb7704e278c$export$4a78e7a2a4fb689f(item);
    return $005d1fb7704e278c$export$45c769cf449a508c(item);
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$005d1fb7704e278c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $005d1fb7704e278c$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $005d1fb7704e278c$var$toWrapped(self, result) : result;
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return (0, $8POXm.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const rawValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $8POXm.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $8POXm.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(value)) return /* @__PURE__ */ $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $8POXm.isSymbol)(key) ? key : String(key);
        this._raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $8POXm.isArray)(_object) || (0, $8POXm.isSymbol)(this._key) || !(0, $8POXm.isIntegerKey)(this._key)) do shallow = !$005d1fb7704e278c$export$5f3ca29d057519b3(obj) || $005d1fb7704e278c$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $005d1fb7704e278c$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive(this._raw, this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    return new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            const res = _cb(...args);
            watchHandle();
            return res;
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "genCacheKey", () => $66ea9d0aaa418c4d$export$abc5374c10a73a04);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "generateCodeFrame", () => $66ea9d0aaa418c4d$export$f9c0d8b6684a279b);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "parseStringStyle", () => $66ea9d0aaa418c4d$export$76a205ce979d066a);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isVoidTag", () => $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-\w/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "registerRuntimeCompiler", () => (parcelRequire("TusQn")).registerRuntimeCompiler);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow(el);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow(el);
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $8POXm.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(?:^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$a5d55dc64ccb07cf$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $8POXm.isString)(prev) && prev ? prev[key] : void 0, value)) $a5d55dc64ccb07cf$var$setStyle(style, key, value);
            } else $a5d55dc64ccb07cf$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $a5d55dc64ccb07cf$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $8POXm.isString)(next) && prev === next;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $a5d55dc64ccb07cf$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)) && !$a5d55dc64ccb07cf$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $8POXm.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $TusQn.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $TusQn.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue)))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
function $a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $8POXm.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $8POXm.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $8POXm.camelize)(prop) === camelKey);
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) Comp = (0, $8POXm.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $8POXm.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$a5d55dc64ccb07cf$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, $a5d55dc64ccb07cf$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, $a5d55dc64ccb07cf$var$getPosition(c.el));
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $a5d55dc64ccb07cf$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $a5d55dc64ccb07cf$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $8POXm.looseToNumber)(value);
    return value;
}
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$a5d55dc64ccb07cf$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$a5d55dc64ccb07cf$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = $a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$a5d55dc64ccb07cf$var$initialValueKey];
        delete el[$a5d55dc64ccb07cf$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? (0, $8POXm.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$export$cd4aa0842d13df8b
}, $a5d55dc64ccb07cf$export$de4fb7f5030605d3);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});

parcelRegister("3HHJ3", function(module, exports) {

$parcel$export(module.exports, "compile", () => $2b274e48783ce38c$export$ef7acd7185315e22);
/**
* @vue/compiler-dom v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $6rMDr = parcelRequire("6rMDr");

var $8POXm = parcelRequire("8POXm");
const $2b274e48783ce38c$export$840cf4d687fa64bf = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$228d0b64761291c1 = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$9f97e65b6f78b584 = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$19eac69b46d09cfc = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$334590174a9e57a1 = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$5c621dc1b9e655a = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$94febfb27c95c3cd = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$be7d85494bd6f37b = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$f2127cf693ff3edc = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$bb9790ed494aa172 = /* @__PURE__ */ Symbol(``);
(0, $6rMDr.registerRuntimeHelpers)({
    [$2b274e48783ce38c$export$840cf4d687fa64bf]: `vModelRadio`,
    [$2b274e48783ce38c$export$228d0b64761291c1]: `vModelCheckbox`,
    [$2b274e48783ce38c$export$9f97e65b6f78b584]: `vModelText`,
    [$2b274e48783ce38c$export$19eac69b46d09cfc]: `vModelSelect`,
    [$2b274e48783ce38c$export$334590174a9e57a1]: `vModelDynamic`,
    [$2b274e48783ce38c$export$5c621dc1b9e655a]: `withModifiers`,
    [$2b274e48783ce38c$export$94febfb27c95c3cd]: `withKeys`,
    [$2b274e48783ce38c$export$be7d85494bd6f37b]: `vShow`,
    [$2b274e48783ce38c$export$f2127cf693ff3edc]: `Transition`,
    [$2b274e48783ce38c$export$bb9790ed494aa172]: `TransitionGroup`
});
let $2b274e48783ce38c$var$decoder;
function $2b274e48783ce38c$var$decodeHtmlBrowser(raw, asAttr = false) {
    if (!$2b274e48783ce38c$var$decoder) $2b274e48783ce38c$var$decoder = document.createElement("div");
    if (asAttr) {
        $2b274e48783ce38c$var$decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
        return $2b274e48783ce38c$var$decoder.children[0].getAttribute("foo");
    } else {
        $2b274e48783ce38c$var$decoder.innerHTML = raw;
        return $2b274e48783ce38c$var$decoder.textContent;
    }
}
const $2b274e48783ce38c$export$f3377f1c03a3aebd = {
    parseMode: "html",
    isVoidTag: $8POXm.isVoidTag,
    isNativeTag: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
    isPreTag: (tag)=>tag === "pre",
    isIgnoreNewlineTag: (tag)=>tag === "pre" || tag === "textarea",
    decodeEntities: $2b274e48783ce38c$var$decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if (tag === "Transition" || tag === "transition") return $2b274e48783ce38c$export$f2127cf693ff3edc;
        else if (tag === "TransitionGroup" || tag === "transition-group") return $2b274e48783ce38c$export$bb9790ed494aa172;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent, rootNamespace) {
        let ns = parent ? parent.ns : rootNamespace;
        if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
                if (tag === "svg") return 1;
                if (parent.props.some((a)=>a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml"))) ns = 0;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") ns = 0;
        } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") ns = 0;
        }
        if (ns === 0) {
            if (tag === "svg") return 1;
            if (tag === "math") return 2;
        }
        return ns;
    }
};
const $2b274e48783ce38c$export$8dfeb887a12dd97a = (node)=>{
    if (node.type === 1) node.props.forEach((p, i)=>{
        if (p.type === 6 && p.name === "style" && p.value) node.props[i] = {
            type: 7,
            name: `bind`,
            arg: (0, $6rMDr.createSimpleExpression)(`style`, true, p.loc),
            exp: $2b274e48783ce38c$var$parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const $2b274e48783ce38c$var$parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, $8POXm.parseStringStyle)(cssText);
    return (0, $6rMDr.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3);
};
function $2b274e48783ce38c$export$c2fa14fc707a7d94(code, loc) {
    return (0, $6rMDr.createCompilerError)(code, loc, void 0);
}
const $2b274e48783ce38c$export$3f0f75fff33734b3 = {
    "X_V_HTML_NO_EXPRESSION": 54,
    "54": "X_V_HTML_NO_EXPRESSION",
    "X_V_HTML_WITH_CHILDREN": 55,
    "55": "X_V_HTML_WITH_CHILDREN",
    "X_V_TEXT_NO_EXPRESSION": 56,
    "56": "X_V_TEXT_NO_EXPRESSION",
    "X_V_TEXT_WITH_CHILDREN": 57,
    "57": "X_V_TEXT_WITH_CHILDREN",
    "X_V_MODEL_ON_INVALID_ELEMENT": 58,
    "58": "X_V_MODEL_ON_INVALID_ELEMENT",
    "X_V_MODEL_ARG_ON_ELEMENT": 59,
    "59": "X_V_MODEL_ARG_ON_ELEMENT",
    "X_V_MODEL_ON_FILE_INPUT_ELEMENT": 60,
    "60": "X_V_MODEL_ON_FILE_INPUT_ELEMENT",
    "X_V_MODEL_UNNECESSARY_VALUE": 61,
    "61": "X_V_MODEL_UNNECESSARY_VALUE",
    "X_V_SHOW_NO_EXPRESSION": 62,
    "62": "X_V_SHOW_NO_EXPRESSION",
    "X_TRANSITION_INVALID_CHILDREN": 63,
    "63": "X_TRANSITION_INVALID_CHILDREN",
    "X_IGNORED_SIDE_EFFECT_TAG": 64,
    "64": "X_IGNORED_SIDE_EFFECT_TAG",
    "__EXTEND_POINT__": 65,
    "65": "__EXTEND_POINT__"
};
const $2b274e48783ce38c$export$b1db1c803eda55f9 = {
    [54]: `v-html is missing expression.`,
    [55]: `v-html will override element children.`,
    [56]: `v-text is missing expression.`,
    [57]: `v-text will override element children.`,
    [58]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [59]: `v-model argument is not supported on plain elements.`,
    [60]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [61]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [62]: `v-show is missing expression.`,
    [63]: `<Transition> expects exactly one child element or component.`,
    [64]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const $2b274e48783ce38c$var$transformVHtml = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(54, loc));
    if (node.children.length) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(55, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $6rMDr.createObjectProperty)((0, $6rMDr.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, $6rMDr.createSimpleExpression)("", true))
        ]
    };
};
const $2b274e48783ce38c$var$transformVText = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(56, loc));
    if (node.children.length) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(57, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $6rMDr.createObjectProperty)((0, $6rMDr.createSimpleExpression)(`textContent`, true), exp ? (0, $6rMDr.getConstantType)(exp, context) > 0 ? exp : (0, $6rMDr.createCallExpression)(context.helperString((0, $6rMDr.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, $6rMDr.createSimpleExpression)("", true))
        ]
    };
};
const $2b274e48783ce38c$var$transformModel = (dir, node, context)=>{
    const baseResult = (0, $6rMDr.transformModel)(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) return baseResult;
    if (dir.arg) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(59, dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, $6rMDr.findDir)(node, "bind");
        if (value && (0, $6rMDr.isStaticArgOf)(value.arg, "value")) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(61, value.loc));
    }
    const { tag: tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
        let directiveToUse = $2b274e48783ce38c$export$9f97e65b6f78b584;
        let isInvalidType = false;
        if (tag === "input" || isCustomElement) {
            const type = (0, $6rMDr.findProp)(node, `type`);
            if (type) {
                if (type.type === 7) directiveToUse = $2b274e48783ce38c$export$334590174a9e57a1;
                else if (type.value) switch(type.value.content){
                    case "radio":
                        directiveToUse = $2b274e48783ce38c$export$840cf4d687fa64bf;
                        break;
                    case "checkbox":
                        directiveToUse = $2b274e48783ce38c$export$228d0b64761291c1;
                        break;
                    case "file":
                        isInvalidType = true;
                        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(60, dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, $6rMDr.hasDynamicKeyVBind)(node)) directiveToUse = $2b274e48783ce38c$export$334590174a9e57a1;
        } else if (tag === "select") directiveToUse = $2b274e48783ce38c$export$19eac69b46d09cfc;
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(58, dir.loc));
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 && p.key.content === "modelValue"));
    return baseResult;
};
const $2b274e48783ce38c$var$isEventOptionModifier = /* @__PURE__ */ (0, $8POXm.makeMap)(`passive,once,capture`);
const $2b274e48783ce38c$var$isNonKeyModifier = /* @__PURE__ */ (0, $8POXm.makeMap)(// event propagation management
`stop,prevent,self,ctrl,shift,alt,meta,exact,middle`);
const $2b274e48783ce38c$var$maybeKeyModifier = /* @__PURE__ */ (0, $8POXm.makeMap)("left,right");
const $2b274e48783ce38c$var$isKeyboardEvent = /* @__PURE__ */ (0, $8POXm.makeMap)(`onkeyup,onkeydown,onkeypress`);
const $2b274e48783ce38c$var$resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i].content;
        if (modifier === "native" && (0, $6rMDr.checkCompatEnabled)("COMPILER_V_ON_NATIVE", context, loc)) eventOptionModifiers.push(modifier);
        else if ($2b274e48783ce38c$var$isEventOptionModifier(modifier)) eventOptionModifiers.push(modifier);
        else {
            if ($2b274e48783ce38c$var$maybeKeyModifier(modifier)) {
                if ((0, $6rMDr.isStaticExp)(key)) {
                    if ($2b274e48783ce38c$var$isKeyboardEvent(key.content.toLowerCase())) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if ($2b274e48783ce38c$var$isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers: keyModifiers,
        nonKeyModifiers: nonKeyModifiers,
        eventOptionModifiers: eventOptionModifiers
    };
};
const $2b274e48783ce38c$var$transformClick = (key, event)=>{
    const isStaticClick = (0, $6rMDr.isStaticExp)(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? (0, $6rMDr.createSimpleExpression)(event, true) : key.type !== 4 ? (0, $6rMDr.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const $2b274e48783ce38c$var$transformOn = (dir, node, context)=>{
    return (0, $6rMDr.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers: modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key: key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers: keyModifiers, nonKeyModifiers: nonKeyModifiers, eventOptionModifiers: eventOptionModifiers } = $2b274e48783ce38c$var$resolveModifiers(key, modifiers, context, dir.loc);
        if (nonKeyModifiers.includes("right")) key = $2b274e48783ce38c$var$transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes("middle")) key = $2b274e48783ce38c$var$transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, $6rMDr.createCallExpression)(context.helper($2b274e48783ce38c$export$5c621dc1b9e655a), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, $6rMDr.isStaticExp)(key) || $2b274e48783ce38c$var$isKeyboardEvent(key.content.toLowerCase()))) handlerExp = (0, $6rMDr.createCallExpression)(context.helper($2b274e48783ce38c$export$94febfb27c95c3cd), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, $8POXm.capitalize)).join("");
            key = (0, $6rMDr.isStaticExp)(key) ? (0, $6rMDr.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, $6rMDr.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, $6rMDr.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const $2b274e48783ce38c$var$transformShow = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(62, loc));
    return {
        props: [],
        needRuntime: context.helper($2b274e48783ce38c$export$be7d85494bd6f37b)
    };
};
const $2b274e48783ce38c$var$transformTransition = (node, context)=>{
    if (node.type === 1 && node.tagType === 1) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === $2b274e48783ce38c$export$f2127cf693ff3edc) return ()=>{
            if (!node.children.length) return;
            if ($2b274e48783ce38c$var$hasMultipleChildren(node)) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(63, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
            }));
            const child = node.children[0];
            if (child.type === 1) {
                for (const p of child.props)if (p.type === 7 && p.name === "show") node.props.push({
                    type: 6,
                    name: "persisted",
                    nameLoc: node.loc,
                    value: void 0,
                    loc: node.loc
                });
            }
        };
    }
};
function $2b274e48783ce38c$var$hasMultipleChildren(node) {
    const children = node.children = node.children.filter((c)=>!(0, $6rMDr.isCommentOrWhitespace)(c));
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some($2b274e48783ce38c$var$hasMultipleChildren);
}
const $2b274e48783ce38c$var$ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) context.removeNode();
};
function $2b274e48783ce38c$var$isValidHTMLNesting(parent, child) {
    if (parent === "template") return true;
    if (parent in $2b274e48783ce38c$var$onlyValidChildren) return $2b274e48783ce38c$var$onlyValidChildren[parent].has(child);
    if (child in $2b274e48783ce38c$var$onlyValidParents) return $2b274e48783ce38c$var$onlyValidParents[child].has(parent);
    if (parent in $2b274e48783ce38c$var$knownInvalidChildren) {
        if ($2b274e48783ce38c$var$knownInvalidChildren[parent].has(child)) return false;
    }
    if (child in $2b274e48783ce38c$var$knownInvalidParents) {
        if ($2b274e48783ce38c$var$knownInvalidParents[child].has(parent)) return false;
    }
    return true;
}
const $2b274e48783ce38c$var$headings = /* @__PURE__ */ new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
const $2b274e48783ce38c$var$emptySet = /* @__PURE__ */ new Set([]);
const $2b274e48783ce38c$var$onlyValidChildren = {
    head: /* @__PURE__ */ new Set([
        "base",
        "basefront",
        "bgsound",
        "link",
        "meta",
        "title",
        "noscript",
        "noframes",
        "style",
        "script",
        "template"
    ]),
    optgroup: /* @__PURE__ */ new Set([
        "option"
    ]),
    select: /* @__PURE__ */ new Set([
        "optgroup",
        "option",
        "hr"
    ]),
    // table
    table: /* @__PURE__ */ new Set([
        "caption",
        "colgroup",
        "tbody",
        "tfoot",
        "thead"
    ]),
    tr: /* @__PURE__ */ new Set([
        "td",
        "th"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "col"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "tr"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "tr"
    ]),
    // these elements can not have any children elements
    script: $2b274e48783ce38c$var$emptySet,
    iframe: $2b274e48783ce38c$var$emptySet,
    option: $2b274e48783ce38c$var$emptySet,
    textarea: $2b274e48783ce38c$var$emptySet,
    style: $2b274e48783ce38c$var$emptySet,
    title: $2b274e48783ce38c$var$emptySet
};
const $2b274e48783ce38c$var$onlyValidParents = {
    // sections
    html: $2b274e48783ce38c$var$emptySet,
    body: /* @__PURE__ */ new Set([
        "html"
    ]),
    head: /* @__PURE__ */ new Set([
        "html"
    ]),
    // table
    td: /* @__PURE__ */ new Set([
        "tr"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "table"
    ]),
    caption: /* @__PURE__ */ new Set([
        "table"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "table"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "table"
    ]),
    col: /* @__PURE__ */ new Set([
        "colgroup"
    ]),
    th: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "table"
    ]),
    tr: /* @__PURE__ */ new Set([
        "tbody",
        "thead",
        "tfoot"
    ]),
    // data list
    dd: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    // other
    figcaption: /* @__PURE__ */ new Set([
        "figure"
    ]),
    // li: new Set(["ul", "ol"]),
    summary: /* @__PURE__ */ new Set([
        "details"
    ]),
    area: /* @__PURE__ */ new Set([
        "map"
    ])
};
const $2b274e48783ce38c$var$knownInvalidChildren = {
    p: /* @__PURE__ */ new Set([
        "address",
        "article",
        "aside",
        "blockquote",
        "center",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "fieldset",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "menu",
        "ol",
        "p",
        "pre",
        "section",
        "table",
        "ul"
    ]),
    svg: /* @__PURE__ */ new Set([
        "b",
        "blockquote",
        "br",
        "code",
        "dd",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        "li",
        "menu",
        "meta",
        "ol",
        "p",
        "pre",
        "ruby",
        "s",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "table",
        "u",
        "ul",
        "var"
    ])
};
const $2b274e48783ce38c$var$knownInvalidParents = {
    a: /* @__PURE__ */ new Set([
        "a"
    ]),
    button: /* @__PURE__ */ new Set([
        "button"
    ]),
    dd: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    form: /* @__PURE__ */ new Set([
        "form"
    ]),
    li: /* @__PURE__ */ new Set([
        "li"
    ]),
    h1: $2b274e48783ce38c$var$headings,
    h2: $2b274e48783ce38c$var$headings,
    h3: $2b274e48783ce38c$var$headings,
    h4: $2b274e48783ce38c$var$headings,
    h5: $2b274e48783ce38c$var$headings,
    h6: $2b274e48783ce38c$var$headings
};
const $2b274e48783ce38c$var$validateHtmlNesting = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !$2b274e48783ce38c$var$isValidHTMLNesting(context.parent.tag, node.tag)) {
        const error = new SyntaxError(`<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`);
        error.loc = node.loc;
        context.onWarn(error);
    }
};
const $2b274e48783ce38c$export$e801dc6012e0c348 = [
    $2b274e48783ce38c$export$8dfeb887a12dd97a
];
const $2b274e48783ce38c$export$2257f60ebb1a11be = {
    cloak: (0, $6rMDr.noopDirectiveTransform),
    html: $2b274e48783ce38c$var$transformVHtml,
    text: $2b274e48783ce38c$var$transformVText,
    model: $2b274e48783ce38c$var$transformModel,
    // override compiler-core
    on: $2b274e48783ce38c$var$transformOn,
    // override compiler-core
    show: $2b274e48783ce38c$var$transformShow
};
function $2b274e48783ce38c$export$ef7acd7185315e22(src, options = {}) {
    return (0, $6rMDr.baseCompile)(src, (0, $8POXm.extend)({}, $2b274e48783ce38c$export$f3377f1c03a3aebd, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            $2b274e48783ce38c$var$ignoreSideEffectTags,
            ...$2b274e48783ce38c$export$e801dc6012e0c348,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $8POXm.extend)({}, $2b274e48783ce38c$export$2257f60ebb1a11be, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function $2b274e48783ce38c$export$98e6a39c04603d36(template, options = {}) {
    return (0, $6rMDr.baseParse)(template, (0, $8POXm.extend)({}, $2b274e48783ce38c$export$f3377f1c03a3aebd, options));
}

});
parcelRegister("6rMDr", function(module, exports) {

$parcel$export(module.exports, "TO_DISPLAY_STRING", () => $4b1afda415637ecc$export$68f5914cce0a5680);
$parcel$export(module.exports, "registerRuntimeHelpers", () => $4b1afda415637ecc$export$8c4e724519c87f31);
$parcel$export(module.exports, "createObjectProperty", () => $4b1afda415637ecc$export$45231d90c148ea74);
$parcel$export(module.exports, "createSimpleExpression", () => $4b1afda415637ecc$export$ac2aa689b44cdd23);
$parcel$export(module.exports, "createCompoundExpression", () => $4b1afda415637ecc$export$60ad01cd5cde5e50);
$parcel$export(module.exports, "createCallExpression", () => $4b1afda415637ecc$export$2cdf8617f9d8e39d);
$parcel$export(module.exports, "checkCompatEnabled", () => $4b1afda415637ecc$export$1b1c14b93fcc0fe4);
$parcel$export(module.exports, "createCompilerError", () => $4b1afda415637ecc$export$57c5a5dc5aa19bdf);
$parcel$export(module.exports, "isStaticExp", () => $4b1afda415637ecc$export$43d387e2d68b51dc);
$parcel$export(module.exports, "findDir", () => $4b1afda415637ecc$export$1199bc2a2b648c8c);
$parcel$export(module.exports, "findProp", () => $4b1afda415637ecc$export$4ae65475e3513615);
$parcel$export(module.exports, "isStaticArgOf", () => $4b1afda415637ecc$export$45cac5109adb5e55);
$parcel$export(module.exports, "hasDynamicKeyVBind", () => $4b1afda415637ecc$export$4e1f112c75b8dafc);
$parcel$export(module.exports, "isCommentOrWhitespace", () => $4b1afda415637ecc$export$6d8f8b0d7fdfb5b0);
$parcel$export(module.exports, "baseParse", () => $4b1afda415637ecc$export$f5f219d5f09c81b5);
$parcel$export(module.exports, "getConstantType", () => $4b1afda415637ecc$export$7967f5197c38d72a);
$parcel$export(module.exports, "transformOn", () => $4b1afda415637ecc$export$ff060d152244ee7b);
$parcel$export(module.exports, "transformModel", () => $4b1afda415637ecc$export$567db1f69abf4dcb);
$parcel$export(module.exports, "baseCompile", () => $4b1afda415637ecc$export$3243579822c486a0);
$parcel$export(module.exports, "noopDirectiveTransform", () => $4b1afda415637ecc$export$eb34aa2b2065da17);
/**
* @vue/compiler-core v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
const $4b1afda415637ecc$export$4bebefc40c8513e8 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e74e82bc14ac4f98 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$2237d737f4a10705 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e9ff5bb5c39478ed = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b357ae9fe0a3685a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$59578e14f90a15eb = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$37ddf5a12480514c = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$f87906340c78a650 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$6db5bf2474139178 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b22e7e78da20c982 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b2aae42fb0a19db3 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$8890896270dfc293 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$1a493e4b98fdcf3 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$28c52e95383d270 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$582a2287b73d3265 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$7f3ccc2ef793ecce = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$2c190751e09c3969 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$a5e4c1729e50ed6d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$3da0e5cd78c1870 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$a91e32c6b04aa348 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$6a6b6a5c860c238d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$68f5914cce0a5680 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$825e32c0f842262a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$6382e3ed89de4e2a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b9d3780a9ab822b4 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$78c34c869683dd86 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$7046bb8d3c918928 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$4bdbf33367525856 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$3ebbf6981763e181 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e3e7f5f6c22384b5 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$8687eaac3cd39ddd = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$37cf1f9ab937c10d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$d8e039410dcfa57d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$4266498fbffc3354 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$141e17a2b5200090 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e0f3ad8c273cc513 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$cf2c1c7bc34dc87e = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$a0fd71f0f7cd2781 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$ae18cf0dc81df35a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$7dc1fc5a07bc9b35 = {
    [$4b1afda415637ecc$export$4bebefc40c8513e8]: `Fragment`,
    [$4b1afda415637ecc$export$e74e82bc14ac4f98]: `Teleport`,
    [$4b1afda415637ecc$export$2237d737f4a10705]: `Suspense`,
    [$4b1afda415637ecc$export$e9ff5bb5c39478ed]: `KeepAlive`,
    [$4b1afda415637ecc$export$b357ae9fe0a3685a]: `BaseTransition`,
    [$4b1afda415637ecc$export$59578e14f90a15eb]: `openBlock`,
    [$4b1afda415637ecc$export$37ddf5a12480514c]: `createBlock`,
    [$4b1afda415637ecc$export$f87906340c78a650]: `createElementBlock`,
    [$4b1afda415637ecc$export$6db5bf2474139178]: `createVNode`,
    [$4b1afda415637ecc$export$b22e7e78da20c982]: `createElementVNode`,
    [$4b1afda415637ecc$export$b2aae42fb0a19db3]: `createCommentVNode`,
    [$4b1afda415637ecc$export$8890896270dfc293]: `createTextVNode`,
    [$4b1afda415637ecc$export$1a493e4b98fdcf3]: `createStaticVNode`,
    [$4b1afda415637ecc$export$28c52e95383d270]: `resolveComponent`,
    [$4b1afda415637ecc$export$582a2287b73d3265]: `resolveDynamicComponent`,
    [$4b1afda415637ecc$export$7f3ccc2ef793ecce]: `resolveDirective`,
    [$4b1afda415637ecc$export$2c190751e09c3969]: `resolveFilter`,
    [$4b1afda415637ecc$export$a5e4c1729e50ed6d]: `withDirectives`,
    [$4b1afda415637ecc$export$3da0e5cd78c1870]: `renderList`,
    [$4b1afda415637ecc$export$a91e32c6b04aa348]: `renderSlot`,
    [$4b1afda415637ecc$export$6a6b6a5c860c238d]: `createSlots`,
    [$4b1afda415637ecc$export$68f5914cce0a5680]: `toDisplayString`,
    [$4b1afda415637ecc$export$825e32c0f842262a]: `mergeProps`,
    [$4b1afda415637ecc$export$6382e3ed89de4e2a]: `normalizeClass`,
    [$4b1afda415637ecc$export$b9d3780a9ab822b4]: `normalizeStyle`,
    [$4b1afda415637ecc$export$78c34c869683dd86]: `normalizeProps`,
    [$4b1afda415637ecc$export$7046bb8d3c918928]: `guardReactiveProps`,
    [$4b1afda415637ecc$export$4bdbf33367525856]: `toHandlers`,
    [$4b1afda415637ecc$export$3ebbf6981763e181]: `camelize`,
    [$4b1afda415637ecc$export$e3e7f5f6c22384b5]: `capitalize`,
    [$4b1afda415637ecc$export$8687eaac3cd39ddd]: `toHandlerKey`,
    [$4b1afda415637ecc$export$37cf1f9ab937c10d]: `setBlockTracking`,
    [$4b1afda415637ecc$export$d8e039410dcfa57d]: `pushScopeId`,
    [$4b1afda415637ecc$export$4266498fbffc3354]: `popScopeId`,
    [$4b1afda415637ecc$export$141e17a2b5200090]: `withCtx`,
    [$4b1afda415637ecc$export$e0f3ad8c273cc513]: `unref`,
    [$4b1afda415637ecc$export$cf2c1c7bc34dc87e]: `isRef`,
    [$4b1afda415637ecc$export$a0fd71f0f7cd2781]: `withMemo`,
    [$4b1afda415637ecc$export$ae18cf0dc81df35a]: `isMemoSame`
};
function $4b1afda415637ecc$export$8c4e724519c87f31(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        $4b1afda415637ecc$export$7dc1fc5a07bc9b35[s] = helpers[s];
    });
}
const $4b1afda415637ecc$export$2f21297dc8e7cb72 = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
const $4b1afda415637ecc$export$2ed9472effad1b70 = {
    "ROOT": 0,
    "0": "ROOT",
    "ELEMENT": 1,
    "1": "ELEMENT",
    "TEXT": 2,
    "2": "TEXT",
    "COMMENT": 3,
    "3": "COMMENT",
    "SIMPLE_EXPRESSION": 4,
    "4": "SIMPLE_EXPRESSION",
    "INTERPOLATION": 5,
    "5": "INTERPOLATION",
    "ATTRIBUTE": 6,
    "6": "ATTRIBUTE",
    "DIRECTIVE": 7,
    "7": "DIRECTIVE",
    "COMPOUND_EXPRESSION": 8,
    "8": "COMPOUND_EXPRESSION",
    "IF": 9,
    "9": "IF",
    "IF_BRANCH": 10,
    "10": "IF_BRANCH",
    "FOR": 11,
    "11": "FOR",
    "TEXT_CALL": 12,
    "12": "TEXT_CALL",
    "VNODE_CALL": 13,
    "13": "VNODE_CALL",
    "JS_CALL_EXPRESSION": 14,
    "14": "JS_CALL_EXPRESSION",
    "JS_OBJECT_EXPRESSION": 15,
    "15": "JS_OBJECT_EXPRESSION",
    "JS_PROPERTY": 16,
    "16": "JS_PROPERTY",
    "JS_ARRAY_EXPRESSION": 17,
    "17": "JS_ARRAY_EXPRESSION",
    "JS_FUNCTION_EXPRESSION": 18,
    "18": "JS_FUNCTION_EXPRESSION",
    "JS_CONDITIONAL_EXPRESSION": 19,
    "19": "JS_CONDITIONAL_EXPRESSION",
    "JS_CACHE_EXPRESSION": 20,
    "20": "JS_CACHE_EXPRESSION",
    "JS_BLOCK_STATEMENT": 21,
    "21": "JS_BLOCK_STATEMENT",
    "JS_TEMPLATE_LITERAL": 22,
    "22": "JS_TEMPLATE_LITERAL",
    "JS_IF_STATEMENT": 23,
    "23": "JS_IF_STATEMENT",
    "JS_ASSIGNMENT_EXPRESSION": 24,
    "24": "JS_ASSIGNMENT_EXPRESSION",
    "JS_SEQUENCE_EXPRESSION": 25,
    "25": "JS_SEQUENCE_EXPRESSION",
    "JS_RETURN_STATEMENT": 26,
    "26": "JS_RETURN_STATEMENT"
};
const $4b1afda415637ecc$export$6d501ccfb21c5e10 = {
    "ELEMENT": 0,
    "0": "ELEMENT",
    "COMPONENT": 1,
    "1": "COMPONENT",
    "SLOT": 2,
    "2": "SLOT",
    "TEMPLATE": 3,
    "3": "TEMPLATE"
};
const $4b1afda415637ecc$export$537bd56c9a924c51 = {
    "NOT_CONSTANT": 0,
    "0": "NOT_CONSTANT",
    "CAN_SKIP_PATCH": 1,
    "1": "CAN_SKIP_PATCH",
    "CAN_CACHE": 2,
    "2": "CAN_CACHE",
    "CAN_STRINGIFY": 3,
    "3": "CAN_STRINGIFY"
};
const $4b1afda415637ecc$export$6c4f24c93c3e8659 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function $4b1afda415637ecc$export$882461b6382ed46c(children, source = "") {
    return {
        type: 0,
        source: source,
        children: children,
        helpers: /* @__PURE__ */ new Set(),
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: [],
        temps: 0,
        codegenNode: void 0,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$d1cb722ac2a8b632(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    if (context) {
        if (isBlock) {
            context.helper($4b1afda415637ecc$export$59578e14f90a15eb);
            context.helper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, isComponent));
        } else context.helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, isComponent));
        if (directives) context.helper($4b1afda415637ecc$export$a5e4c1729e50ed6d);
    }
    return {
        type: 13,
        tag: tag,
        props: props,
        children: children,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        directives: directives,
        isBlock: isBlock,
        disableTracking: disableTracking,
        isComponent: isComponent,
        loc: loc
    };
}
function $4b1afda415637ecc$export$c887713da9895dbb(elements, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 17,
        loc: loc,
        elements: elements
    };
}
function $4b1afda415637ecc$export$ccb2e514379853a7(properties, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 15,
        loc: loc,
        properties: properties
    };
}
function $4b1afda415637ecc$export$45231d90c148ea74(key, value) {
    return {
        type: 16,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659,
        key: (0, $8POXm.isString)(key) ? $4b1afda415637ecc$export$ac2aa689b44cdd23(key, true) : key,
        value: value
    };
}
function $4b1afda415637ecc$export$ac2aa689b44cdd23(content, isStatic = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659, constType = 0) {
    return {
        type: 4,
        loc: loc,
        content: content,
        isStatic: isStatic,
        constType: isStatic ? 3 : constType
    };
}
function $4b1afda415637ecc$export$96ca1dcf947302d0(content, loc) {
    return {
        type: 5,
        loc: loc,
        content: (0, $8POXm.isString)(content) ? $4b1afda415637ecc$export$ac2aa689b44cdd23(content, false, loc) : content
    };
}
function $4b1afda415637ecc$export$60ad01cd5cde5e50(children, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 8,
        loc: loc,
        children: children
    };
}
function $4b1afda415637ecc$export$2cdf8617f9d8e39d(callee, args = [], loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 14,
        loc: loc,
        callee: callee,
        arguments: args
    };
}
function $4b1afda415637ecc$export$253e05bfd5b6c4c6(params, returns, newline = false, isSlot = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 18,
        params: params,
        returns: returns,
        newline: newline,
        isSlot: isSlot,
        loc: loc
    };
}
function $4b1afda415637ecc$export$374e02fb5bd90a4e(test, consequent, alternate, newline = true) {
    return {
        type: 19,
        test: test,
        consequent: consequent,
        alternate: alternate,
        newline: newline,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$4abd162ddf919697(index, value, needPauseTracking = false, inVOnce = false) {
    return {
        type: 20,
        index: index,
        value: value,
        needPauseTracking: needPauseTracking,
        inVOnce: inVOnce,
        needArraySpread: false,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$c3ad9e28586f1d07(body) {
    return {
        type: 21,
        body: body,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$242433d85418a087(elements) {
    return {
        type: 22,
        elements: elements,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$71ff4dcc047b6a4e(test, consequent, alternate) {
    return {
        type: 23,
        test: test,
        consequent: consequent,
        alternate: alternate,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$f6cfc415b0df5d79(left, right) {
    return {
        type: 24,
        left: left,
        right: right,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$42d3d4c35b19948b(expressions) {
    return {
        type: 25,
        expressions: expressions,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$746323a443188826(returns) {
    return {
        type: 26,
        returns: returns,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$3b9fc44425f495a6(ssr, isComponent) {
    return ssr || isComponent ? $4b1afda415637ecc$export$6db5bf2474139178 : $4b1afda415637ecc$export$b22e7e78da20c982;
}
function $4b1afda415637ecc$export$74fb204a6eba800d(ssr, isComponent) {
    return ssr || isComponent ? $4b1afda415637ecc$export$37ddf5a12480514c : $4b1afda415637ecc$export$f87906340c78a650;
}
function $4b1afda415637ecc$export$dc00c05f515bd739(node, { helper: helper, removeHelper: removeHelper, inSSR: inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper($4b1afda415637ecc$export$3b9fc44425f495a6(inSSR, node.isComponent));
        helper($4b1afda415637ecc$export$59578e14f90a15eb);
        helper($4b1afda415637ecc$export$74fb204a6eba800d(inSSR, node.isComponent));
    }
}
const $4b1afda415637ecc$var$defaultDelimitersOpen = new Uint8Array([
    123,
    123
]);
const $4b1afda415637ecc$var$defaultDelimitersClose = new Uint8Array([
    125,
    125
]);
function $4b1afda415637ecc$var$isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
}
function $4b1afda415637ecc$var$isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
}
function $4b1afda415637ecc$var$isEndOfTagSection(c) {
    return c === 47 || c === 62 || $4b1afda415637ecc$var$isWhitespace(c);
}
function $4b1afda415637ecc$var$toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)ret[i] = str.charCodeAt(i);
    return ret;
}
const $4b1afda415637ecc$var$Sequences = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    // CDATA[
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    // ]]>
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    // `-->`
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    // `<\/script`
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    // `</style`
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    // `</title`
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
class $4b1afda415637ecc$var$Tokenizer {
    constructor(stack, cbs){
        this.stack = stack;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = 1;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1;
        /** For special parsing behavior inside of script and style tags. */ this.inRCDATA = false;
        /** For disabling RCDATA tags handling */ this.inXML = false;
        /** For disabling interpolation parsing in v-pre */ this.inVPre = false;
        /** Record newline positions for fast line / column calculation */ this.newlines = [];
        this.mode = 0;
        this.delimiterOpen = $4b1afda415637ecc$var$defaultDelimitersOpen;
        this.delimiterClose = $4b1afda415637ecc$var$defaultDelimitersClose;
        this.delimiterIndex = -1;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
        this.state = 1;
        this.mode = 0;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = 1;
        this.inRCDATA = false;
        this.currentSequence = void 0;
        this.newlines.length = 0;
        this.delimiterOpen = $4b1afda415637ecc$var$defaultDelimitersOpen;
        this.delimiterClose = $4b1afda415637ecc$var$defaultDelimitersClose;
    }
    /**
   * Generate Position object with line / column information using recorded
   * newline positions. We know the index is always going to be an already
   * processed index, so all the newlines up to this index should have been
   * recorded.
   */ getPos(index) {
        let line = 1;
        let column = index + 1;
        const length = this.newlines.length;
        let j = -1;
        if (length > 100) {
            let l = -1;
            let r = length;
            while(l + 1 < r){
                const m = l + r >>> 1;
                this.newlines[m] < index ? l = m : r = m;
            }
            j = l;
        } else {
            for(let i = length - 1; i >= 0; i--)if (index > this.newlines[i]) {
                j = i;
                break;
            }
        }
        if (j >= 0) {
            line = j + 2;
            column = index - this.newlines[j];
        }
        return {
            column: column,
            line: line,
            offset: index
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
        if (c === 60) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
        }
    }
    stateInterpolationOpen(c) {
        if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                const start = this.index + 1 - this.delimiterOpen.length;
                if (start > this.sectionStart) this.cbs.ontext(this.sectionStart, start);
                this.state = 3;
                this.sectionStart = start;
            } else this.delimiterIndex++;
        } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
        } else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInterpolation(c) {
        if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
        }
    }
    stateInterpolationClose(c) {
        if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
                this.cbs.oninterpolation(this.sectionStart, this.index + 1);
                if (this.inRCDATA) this.state = 32;
                else this.state = 1;
                this.sectionStart = this.index + 1;
            } else this.delimiterIndex++;
        } else {
            this.state = 3;
            this.stateInterpolation(c);
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
        $4b1afda415637ecc$var$isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.inRCDATA = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = 6;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */ stateInRCDATA(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || $4b1afda415637ecc$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                this.inRCDATA = false;
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $4b1afda415637ecc$var$Sequences.TitleEnd || this.currentSequence === $4b1afda415637ecc$var$Sequences.TextareaEnd && !this.inSFCRoot) {
                if (!this.inVPre && c === this.delimiterOpen[0]) {
                    this.state = 2;
                    this.delimiterIndex = 0;
                    this.stateInterpolationOpen(c);
                }
            } else if (this.fastForwardTo(60)) this.sequenceIndex = 1;
        } else this.sequenceIndex = Number(c === 60);
    }
    stateCDATASequence(c) {
        if (c === $4b1afda415637ecc$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $4b1afda415637ecc$var$Sequences.Cdata.length) {
                this.state = 28;
                this.currentSequence = $4b1afda415637ecc$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
        }
    }
    /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */ fastForwardTo(c) {
        while(++this.index < this.buffer.length){
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) this.newlines.push(this.index);
            if (cc === c) return true;
        }
        this.index = this.buffer.length - 1;
        return false;
    }
    /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $4b1afda415637ecc$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index - 2);
                else this.cbs.oncomment(this.sectionStart, this.index - 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = 1;
            }
        } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) this.sequenceIndex = 0;
    }
    startSpecial(sequence, offset) {
        this.enterRCDATA(sequence, offset);
        this.state = 31;
    }
    enterRCDATA(sequence, offset) {
        this.inRCDATA = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
        if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
        } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
        } else if ($4b1afda415637ecc$var$isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) this.state = 6;
            else if (this.inSFCRoot) this.state = 34;
            else if (!this.inXML) {
                if (c === 116) this.state = 30;
                else this.state = c === 115 ? 29 : 6;
            } else this.state = 6;
        } else if (c === 47) this.state = 8;
        else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($4b1afda415637ecc$var$isEndOfTagSection(c)) this.handleTagName(c);
    }
    stateInSFCRootTagName(c) {
        if ($4b1afda415637ecc$var$isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") this.enterRCDATA($4b1afda415637ecc$var$toCharCodes(`</` + tag), 0);
            this.handleTagName(c);
        }
    }
    handleTagName(c) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
        if ($4b1afda415637ecc$var$isWhitespace(c)) ;
        else if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        } else {
            this.state = $4b1afda415637ecc$var$isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === 62 || $4b1afda415637ecc$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttrName(c) {
        if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) this.state = 32;
            else this.state = 1;
            this.sectionStart = this.index + 1;
        } else if (c === 47) this.state = 7;
        else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) this.handleAttrStart(c);
    }
    handleAttrStart(c) {
        if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
        } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else {
            this.state = 12;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
        }
    }
    stateInAttrName(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirName(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDirArg(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 91) this.state = 15;
        else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDynamicDirArg(c) {
        if (c === 93) this.state = 14;
        else if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirModifier(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
        }
    }
    handleAttrNameEnd(c) {
        this.sectionStart = this.index;
        this.state = 17;
        this.cbs.onattribnameend(this.index);
        this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
        if (c === 61) this.state = 18;
        else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
        }
    }
    stateBeforeAttrValue(c) {
        if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
        } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
        }
    }
    handleInAttrValue(c, quote) {
        if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === 34 ? 3 : 2, this.index + 1);
            this.state = 11;
        }
    }
    stateInAttrValueDoubleQuotes(c) {
        this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
        this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
        if ($4b1afda415637ecc$var$isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (c === 39 || c === 60 || c === 61 || c === 96) this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(c) {
        if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
        } else this.state = c === 45 ? 25 : 23;
    }
    stateInDeclaration(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === 45) {
            this.state = 28;
            this.currentSequence = $4b1afda415637ecc$var$Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = 23;
    }
    stateInSpecialComment(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        if (c === $4b1afda415637ecc$var$Sequences.ScriptEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.ScriptEnd, 4);
        else if (c === $4b1afda415637ecc$var$Sequences.StyleEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.StyleEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    stateBeforeSpecialT(c) {
        if (c === $4b1afda415637ecc$var$Sequences.TitleEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.TitleEnd, 4);
        else if (c === $4b1afda415637ecc$var$Sequences.TextareaEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.TextareaEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    startEntity() {}
    stateInEntity() {}
    /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */ parse(input) {
        this.buffer = input;
        while(this.index < this.buffer.length){
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10 && this.state !== 33) this.newlines.push(this.index);
            switch(this.state){
                case 1:
                    this.stateText(c);
                    break;
                case 2:
                    this.stateInterpolationOpen(c);
                    break;
                case 3:
                    this.stateInterpolation(c);
                    break;
                case 4:
                    this.stateInterpolationClose(c);
                    break;
                case 31:
                    this.stateSpecialStartSequence(c);
                    break;
                case 32:
                    this.stateInRCDATA(c);
                    break;
                case 26:
                    this.stateCDATASequence(c);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(c);
                    break;
                case 12:
                    this.stateInAttrName(c);
                    break;
                case 13:
                    this.stateInDirName(c);
                    break;
                case 14:
                    this.stateInDirArg(c);
                    break;
                case 15:
                    this.stateInDynamicDirArg(c);
                    break;
                case 16:
                    this.stateInDirModifier(c);
                    break;
                case 28:
                    this.stateInCommentLike(c);
                    break;
                case 27:
                    this.stateInSpecialComment(c);
                    break;
                case 11:
                    this.stateBeforeAttrName(c);
                    break;
                case 6:
                    this.stateInTagName(c);
                    break;
                case 34:
                    this.stateInSFCRootTagName(c);
                    break;
                case 9:
                    this.stateInClosingTagName(c);
                    break;
                case 5:
                    this.stateBeforeTagName(c);
                    break;
                case 17:
                    this.stateAfterAttrName(c);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(c);
                    break;
                case 18:
                    this.stateBeforeAttrValue(c);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(c);
                    break;
                case 10:
                    this.stateAfterClosingTagName(c);
                    break;
                case 29:
                    this.stateBeforeSpecialS(c);
                    break;
                case 30:
                    this.stateBeforeSpecialT(c);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(c);
                    break;
                case 7:
                    this.stateInSelfClosingTag(c);
                    break;
                case 23:
                    this.stateInDeclaration(c);
                    break;
                case 22:
                    this.stateBeforeDeclaration(c);
                    break;
                case 25:
                    this.stateBeforeComment(c);
                    break;
                case 24:
                    this.stateInProcessingInstruction(c);
                    break;
                case 33:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
        this.finish();
    }
    /**
   * Remove data that has already been consumed from the buffer.
   */ cleanup() {
        if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    finish() {
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length;
        if (this.sectionStart >= endIndex) return;
        if (this.state === 28) {
            if (this.currentSequence === $4b1afda415637ecc$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex);
            else this.cbs.oncomment(this.sectionStart, endIndex);
        } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {}
}
const $4b1afda415637ecc$export$9354a9698ba2ae26 = {
    "COMPILER_IS_ON_ELEMENT": "COMPILER_IS_ON_ELEMENT",
    "COMPILER_V_BIND_SYNC": "COMPILER_V_BIND_SYNC",
    "COMPILER_V_BIND_OBJECT_ORDER": "COMPILER_V_BIND_OBJECT_ORDER",
    "COMPILER_V_ON_NATIVE": "COMPILER_V_ON_NATIVE",
    "COMPILER_V_IF_V_FOR_PRECEDENCE": "COMPILER_V_IF_V_FOR_PRECEDENCE",
    "COMPILER_NATIVE_TEMPLATE": "COMPILER_NATIVE_TEMPLATE",
    "COMPILER_INLINE_TEMPLATE": "COMPILER_INLINE_TEMPLATE",
    "COMPILER_FILTERS": "COMPILER_FILTERS"
};
const $4b1afda415637ecc$var$deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
        message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
        message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
        message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
        message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function $4b1afda415637ecc$var$getCompatValue(key, { compatConfig: compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") return value || 3;
    else return value;
}
function $4b1afda415637ecc$var$isCompatEnabled(key, context) {
    const mode = $4b1afda415637ecc$var$getCompatValue("MODE", context);
    const value = $4b1afda415637ecc$var$getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
}
function $4b1afda415637ecc$export$1b1c14b93fcc0fe4(key, context, loc, ...args) {
    const enabled = $4b1afda415637ecc$var$isCompatEnabled(key, context);
    return enabled;
}
function $4b1afda415637ecc$export$1c4d39b152e0f791(key, context, loc, ...args) {
    const val = $4b1afda415637ecc$var$getCompatValue(key, context);
    if (val === "suppress-warning") return;
    const { message: message, link: link } = $4b1afda415637ecc$var$deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
function $4b1afda415637ecc$var$defaultOnError(error) {
    throw error;
}
function $4b1afda415637ecc$var$defaultOnWarn(msg) {}
function $4b1afda415637ecc$export$57c5a5dc5aa19bdf(code, loc, messages, additionalMessage) {
    const msg = `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const $4b1afda415637ecc$export$10e8e1cf990558d7 = {
    "ABRUPT_CLOSING_OF_EMPTY_COMMENT": 0,
    "0": "ABRUPT_CLOSING_OF_EMPTY_COMMENT",
    "CDATA_IN_HTML_CONTENT": 1,
    "1": "CDATA_IN_HTML_CONTENT",
    "DUPLICATE_ATTRIBUTE": 2,
    "2": "DUPLICATE_ATTRIBUTE",
    "END_TAG_WITH_ATTRIBUTES": 3,
    "3": "END_TAG_WITH_ATTRIBUTES",
    "END_TAG_WITH_TRAILING_SOLIDUS": 4,
    "4": "END_TAG_WITH_TRAILING_SOLIDUS",
    "EOF_BEFORE_TAG_NAME": 5,
    "5": "EOF_BEFORE_TAG_NAME",
    "EOF_IN_CDATA": 6,
    "6": "EOF_IN_CDATA",
    "EOF_IN_COMMENT": 7,
    "7": "EOF_IN_COMMENT",
    "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT": 8,
    "8": "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT",
    "EOF_IN_TAG": 9,
    "9": "EOF_IN_TAG",
    "INCORRECTLY_CLOSED_COMMENT": 10,
    "10": "INCORRECTLY_CLOSED_COMMENT",
    "INCORRECTLY_OPENED_COMMENT": 11,
    "11": "INCORRECTLY_OPENED_COMMENT",
    "INVALID_FIRST_CHARACTER_OF_TAG_NAME": 12,
    "12": "INVALID_FIRST_CHARACTER_OF_TAG_NAME",
    "MISSING_ATTRIBUTE_VALUE": 13,
    "13": "MISSING_ATTRIBUTE_VALUE",
    "MISSING_END_TAG_NAME": 14,
    "14": "MISSING_END_TAG_NAME",
    "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES": 15,
    "15": "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES",
    "NESTED_COMMENT": 16,
    "16": "NESTED_COMMENT",
    "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME": 17,
    "17": "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME",
    "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE": 18,
    "18": "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE",
    "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME": 19,
    "19": "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME",
    "UNEXPECTED_NULL_CHARACTER": 20,
    "20": "UNEXPECTED_NULL_CHARACTER",
    "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME": 21,
    "21": "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME",
    "UNEXPECTED_SOLIDUS_IN_TAG": 22,
    "22": "UNEXPECTED_SOLIDUS_IN_TAG",
    "X_INVALID_END_TAG": 23,
    "23": "X_INVALID_END_TAG",
    "X_MISSING_END_TAG": 24,
    "24": "X_MISSING_END_TAG",
    "X_MISSING_INTERPOLATION_END": 25,
    "25": "X_MISSING_INTERPOLATION_END",
    "X_MISSING_DIRECTIVE_NAME": 26,
    "26": "X_MISSING_DIRECTIVE_NAME",
    "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END": 27,
    "27": "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END",
    "X_V_IF_NO_EXPRESSION": 28,
    "28": "X_V_IF_NO_EXPRESSION",
    "X_V_IF_SAME_KEY": 29,
    "29": "X_V_IF_SAME_KEY",
    "X_V_ELSE_NO_ADJACENT_IF": 30,
    "30": "X_V_ELSE_NO_ADJACENT_IF",
    "X_V_FOR_NO_EXPRESSION": 31,
    "31": "X_V_FOR_NO_EXPRESSION",
    "X_V_FOR_MALFORMED_EXPRESSION": 32,
    "32": "X_V_FOR_MALFORMED_EXPRESSION",
    "X_V_FOR_TEMPLATE_KEY_PLACEMENT": 33,
    "33": "X_V_FOR_TEMPLATE_KEY_PLACEMENT",
    "X_V_BIND_NO_EXPRESSION": 34,
    "34": "X_V_BIND_NO_EXPRESSION",
    "X_V_ON_NO_EXPRESSION": 35,
    "35": "X_V_ON_NO_EXPRESSION",
    "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET": 36,
    "36": "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET",
    "X_V_SLOT_MIXED_SLOT_USAGE": 37,
    "37": "X_V_SLOT_MIXED_SLOT_USAGE",
    "X_V_SLOT_DUPLICATE_SLOT_NAMES": 38,
    "38": "X_V_SLOT_DUPLICATE_SLOT_NAMES",
    "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN": 39,
    "39": "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN",
    "X_V_SLOT_MISPLACED": 40,
    "40": "X_V_SLOT_MISPLACED",
    "X_V_MODEL_NO_EXPRESSION": 41,
    "41": "X_V_MODEL_NO_EXPRESSION",
    "X_V_MODEL_MALFORMED_EXPRESSION": 42,
    "42": "X_V_MODEL_MALFORMED_EXPRESSION",
    "X_V_MODEL_ON_SCOPE_VARIABLE": 43,
    "43": "X_V_MODEL_ON_SCOPE_VARIABLE",
    "X_V_MODEL_ON_PROPS": 44,
    "44": "X_V_MODEL_ON_PROPS",
    "X_V_MODEL_ON_CONST": 45,
    "45": "X_V_MODEL_ON_CONST",
    "X_INVALID_EXPRESSION": 46,
    "46": "X_INVALID_EXPRESSION",
    "X_KEEP_ALIVE_INVALID_CHILDREN": 47,
    "47": "X_KEEP_ALIVE_INVALID_CHILDREN",
    "X_PREFIX_ID_NOT_SUPPORTED": 48,
    "48": "X_PREFIX_ID_NOT_SUPPORTED",
    "X_MODULE_MODE_NOT_SUPPORTED": 49,
    "49": "X_MODULE_MODE_NOT_SUPPORTED",
    "X_CACHE_HANDLER_NOT_SUPPORTED": 50,
    "50": "X_CACHE_HANDLER_NOT_SUPPORTED",
    "X_SCOPE_ID_NOT_SUPPORTED": 51,
    "51": "X_SCOPE_ID_NOT_SUPPORTED",
    "X_VNODE_HOOKS": 52,
    "52": "X_VNODE_HOOKS",
    "X_V_BIND_INVALID_SAME_NAME_ARGUMENT": 53,
    "53": "X_V_BIND_INVALID_SAME_NAME_ARGUMENT",
    "__EXTEND_POINT__": 54,
    "54": "__EXTEND_POINT__"
};
const $4b1afda415637ecc$export$d8bd0967cb58683 = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [53]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `v-model cannot be used on a const binding because it is not writable.`,
    [46]: `Error parsing JavaScript expression: `,
    [47]: `<KeepAlive> expects exactly one child component.`,
    [52]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [48]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [49]: `ES module mode is not supported in this build of compiler.`,
    [50]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [51]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [54]: ``
};
function $4b1afda415637ecc$export$1f18e145724205f0(root, onIdentifier, includeAll = false, parentStack = [], knownIds = /* @__PURE__ */ Object.create(null)) {
    return;
}
function $4b1afda415637ecc$export$a351a8c8c66104d7(id, parent, parentStack) {
    return false;
}
function $4b1afda415637ecc$export$b1c677096ee1f9ce(parent, parentStack) {
    if (parent && (parent.type === "ObjectProperty" || parent.type === "ArrayPattern")) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === "AssignmentExpression") return true;
            else if (p.type !== "ObjectProperty" && !p.type.endsWith("Pattern")) break;
        }
    }
    return false;
}
function $4b1afda415637ecc$export$6fdc7720591bc1f7(parentStack) {
    let i = parentStack.length;
    while(i--){
        const p = parentStack[i];
        if (p.type === "NewExpression") return true;
        else if (p.type !== "MemberExpression") break;
    }
    return false;
}
function $4b1afda415637ecc$export$d41514e9f2f5bb4d(node, onIdent) {
    for (const p of node.params)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(p))onIdent(id);
}
function $4b1afda415637ecc$export$3e47780ecfa08385(block, onIdent) {
    const body = block.type === "SwitchCase" ? block.consequent : block.body;
    for (const stmt of body){
        if (stmt.type === "VariableDeclaration") {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
        } else if (stmt.type === "FunctionDeclaration" || stmt.type === "ClassDeclaration") {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        } else if ($4b1afda415637ecc$var$isForStatement(stmt)) $4b1afda415637ecc$var$walkForStatement(stmt, true, onIdent);
        else if (stmt.type === "SwitchStatement") $4b1afda415637ecc$var$walkSwitchStatement(stmt, true, onIdent);
    }
}
function $4b1afda415637ecc$var$isForStatement(stmt) {
    return stmt.type === "ForOfStatement" || stmt.type === "ForInStatement" || stmt.type === "ForStatement";
}
function $4b1afda415637ecc$var$walkForStatement(stmt, isVar, onIdent) {
    const variable = stmt.type === "ForStatement" ? stmt.init : stmt.left;
    if (variable && variable.type === "VariableDeclaration" && (variable.kind === "var" ? isVar : !isVar)) {
        for (const decl of variable.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
    }
}
function $4b1afda415637ecc$var$walkSwitchStatement(stmt, isVar, onIdent) {
    for (const cs of stmt.cases){
        for (const stmt2 of cs.consequent)if (stmt2.type === "VariableDeclaration" && (stmt2.kind === "var" ? isVar : !isVar)) {
            for (const decl of stmt2.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
        }
        $4b1afda415637ecc$export$3e47780ecfa08385(cs, onIdent);
    }
}
function $4b1afda415637ecc$export$31e5048ec55fc20d(param, nodes = []) {
    switch(param.type){
        case "Identifier":
            nodes.push(param);
            break;
        case "MemberExpression":
            let object = param;
            while(object.type === "MemberExpression")object = object.object;
            nodes.push(object);
            break;
        case "ObjectPattern":
            for (const prop of param.properties)if (prop.type === "RestElement") $4b1afda415637ecc$export$31e5048ec55fc20d(prop.argument, nodes);
            else $4b1afda415637ecc$export$31e5048ec55fc20d(prop.value, nodes);
            break;
        case "ArrayPattern":
            param.elements.forEach((element)=>{
                if (element) $4b1afda415637ecc$export$31e5048ec55fc20d(element, nodes);
            });
            break;
        case "RestElement":
            $4b1afda415637ecc$export$31e5048ec55fc20d(param.argument, nodes);
            break;
        case "AssignmentPattern":
            $4b1afda415637ecc$export$31e5048ec55fc20d(param.left, nodes);
            break;
    }
    return nodes;
}
const $4b1afda415637ecc$export$8af909612acebc9b = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const $4b1afda415637ecc$export$f6ddf7e7b08e8e00 = (node)=>node && (node.type === "ObjectProperty" || node.type === "ObjectMethod") && !node.computed;
const $4b1afda415637ecc$export$644dbfd5b3d2f87f = (node, parent)=>$4b1afda415637ecc$export$f6ddf7e7b08e8e00(parent) && parent.key === node;
const $4b1afda415637ecc$export$d40f31ccee2489f = [
    "TSAsExpression",
    // foo as number
    "TSTypeAssertion",
    // (<number>foo)
    "TSNonNullExpression",
    // foo!
    "TSInstantiationExpression",
    // foo<string>
    "TSSatisfiesExpression"
];
function $4b1afda415637ecc$export$4bc65b30e69d96a9(node) {
    if ($4b1afda415637ecc$export$d40f31ccee2489f.includes(node.type)) return $4b1afda415637ecc$export$4bc65b30e69d96a9(node.expression);
    else return node;
}
const $4b1afda415637ecc$export$43d387e2d68b51dc = (p)=>p.type === 4 && p.isStatic;
function $4b1afda415637ecc$export$69768c9b514a01e9(tag) {
    switch(tag){
        case "Teleport":
        case "teleport":
            return $4b1afda415637ecc$export$e74e82bc14ac4f98;
        case "Suspense":
        case "suspense":
            return $4b1afda415637ecc$export$2237d737f4a10705;
        case "KeepAlive":
        case "keep-alive":
            return $4b1afda415637ecc$export$e9ff5bb5c39478ed;
        case "BaseTransition":
        case "base-transition":
            return $4b1afda415637ecc$export$b357ae9fe0a3685a;
    }
}
const $4b1afda415637ecc$var$nonIdentifierRE = /^$|^\d|[^\$\w\xA0-\uFFFF]/;
const $4b1afda415637ecc$export$3cb8486ad206c65 = (name)=>!$4b1afda415637ecc$var$nonIdentifierRE.test(name);
const $4b1afda415637ecc$export$187a93453b63d7b5 = /[A-Za-z_$\xA0-\uFFFF]/;
const $4b1afda415637ecc$var$validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const $4b1afda415637ecc$var$whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
const $4b1afda415637ecc$var$getExpSource = (exp)=>exp.type === 4 ? exp.content : exp.loc.source;
const $4b1afda415637ecc$export$fc15bf43a5359adf = (exp)=>{
    const path = $4b1afda415637ecc$var$getExpSource(exp).trim().replace($4b1afda415637ecc$var$whitespaceRE, (s)=>s.trim());
    let state = 0 /* inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* inMemberExp */ :
                if (char === "[") {
                    stateStack.push(state);
                    state = 1 /* inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === "(") {
                    stateStack.push(state);
                    state = 2 /* inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? $4b1afda415637ecc$export$187a93453b63d7b5 : $4b1afda415637ecc$var$validIdentCharRE).test(char)) return false;
                break;
            case 1 /* inBrackets */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* inParens */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const $4b1afda415637ecc$export$380d727799fbcdda = (0, $8POXm.NOOP);
const $4b1afda415637ecc$export$9c8bdf9fab617ce4 = $4b1afda415637ecc$export$fc15bf43a5359adf;
const $4b1afda415637ecc$var$fnExpRE = /^\s*(?:async\s*)?(?:\([^)]*?\)|[\w$_]+)\s*(?::[^=]+)?=>|^\s*(?:async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const $4b1afda415637ecc$export$aaa41f84da434bf1 = (exp)=>$4b1afda415637ecc$var$fnExpRE.test($4b1afda415637ecc$var$getExpSource(exp));
const $4b1afda415637ecc$export$d64efa2398fbfc9d = (0, $8POXm.NOOP);
const $4b1afda415637ecc$export$482164e6e5517986 = $4b1afda415637ecc$export$aaa41f84da434bf1;
function $4b1afda415637ecc$export$1cdf554524c0924f(pos, source, numberOfCharacters = source.length) {
    return $4b1afda415637ecc$export$c57ab60b0c6308ea({
        offset: pos.offset,
        line: pos.line,
        column: pos.column
    }, source, numberOfCharacters);
}
function $4b1afda415637ecc$export$c57ab60b0c6308ea(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function $4b1afda415637ecc$export$a7a9523472993e97(condition, msg) {
    if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function $4b1afda415637ecc$export$1199bc2a2b648c8c(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 && (allowEmpty || p.exp) && ((0, $8POXm.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function $4b1afda415637ecc$export$4ae65475e3513615(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === "bind" && (p.exp || allowEmpty) && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, name)) return p;
    }
}
function $4b1afda415637ecc$export$45cac5109adb5e55(arg, name) {
    return !!(arg && $4b1afda415637ecc$export$43d387e2d68b51dc(arg) && arg.content === name);
}
function $4b1afda415637ecc$export$4e1f112c75b8dafc(node) {
    return node.props.some((p)=>p.type === 7 && p.name === "bind" && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 || // v-bind:[_ctx.foo]
        !p.arg.isStatic));
}
function $4b1afda415637ecc$export$1879817ac5c922b7(node) {
    return node.type === 5 || node.type === 2;
}
function $4b1afda415637ecc$export$bd191120df7729f2(p) {
    return p.type === 7 && p.name === "pre";
}
function $4b1afda415637ecc$export$eaf8991bb8af8cbb(p) {
    return p.type === 7 && p.name === "slot";
}
function $4b1afda415637ecc$export$f125a8a2b402ed89(node) {
    return node.type === 1 && node.tagType === 3;
}
function $4b1afda415637ecc$export$45f38ad7fffc9b53(node) {
    return node.type === 1 && node.tagType === 2;
}
const $4b1afda415637ecc$var$propsHelperSet = /* @__PURE__ */ new Set([
    $4b1afda415637ecc$export$78c34c869683dd86,
    $4b1afda415637ecc$export$7046bb8d3c918928
]);
function $4b1afda415637ecc$var$getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, $8POXm.isString)(props) && props.type === 14) {
        const callee = props.callee;
        if (!(0, $8POXm.isString)(callee) && $4b1afda415637ecc$var$propsHelperSet.has(callee)) return $4b1afda415637ecc$var$getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function $4b1afda415637ecc$export$ec34add3fb2185f8(node, prop, context) {
    if (node.type !== 13 && $4b1afda415637ecc$var$injectSlotKey(node, prop)) return;
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, $8POXm.isString)(props) && props.type === 14) {
        const ret = $4b1afda415637ecc$var$getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, $8POXm.isString)(props)) propsWithInjection = $4b1afda415637ecc$export$ccb2e514379853a7([
        prop
    ]);
    else if (props.type === 14) {
        const first = props.arguments[0];
        if (!(0, $8POXm.isString)(first) && first.type === 15) {
            if (!$4b1afda415637ecc$var$hasProp(prop, first)) first.properties.unshift(prop);
        } else if (props.callee === $4b1afda415637ecc$export$4bdbf33367525856) propsWithInjection = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), [
            $4b1afda415637ecc$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift($4b1afda415637ecc$export$ccb2e514379853a7([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
        if (!$4b1afda415637ecc$var$hasProp(prop, props)) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        propsWithInjection = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), [
            $4b1afda415637ecc$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        if (parentCall && parentCall.callee === $4b1afda415637ecc$export$7046bb8d3c918928) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function $4b1afda415637ecc$var$injectSlotKey(node, prop) {
    var _a, _b, _c;
    if (prop.key.type !== 4 || prop.key.content !== "key") return false;
    const props = node.arguments[2];
    if (props && !(0, $8POXm.isString)(props)) {
        const [unnormalizedProps] = $4b1afda415637ecc$var$getUnnormalizedProps(props);
        if (unnormalizedProps && !(0, $8POXm.isString)(unnormalizedProps) && unnormalizedProps.type === 15 && $4b1afda415637ecc$var$hasProp(prop, unnormalizedProps)) return true;
    }
    (_a = node.arguments)[2] || (_a[2] = "{}");
    (_b = node.arguments)[3] || (_b[3] = "undefined");
    (_c = node.arguments)[4] || (_c[4] = "undefined");
    node.arguments[5] = prop.value;
    return true;
}
function $4b1afda415637ecc$var$hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
        const propKeyName = prop.key.content;
        result = props.properties.some((p)=>p.key.type === 4 && p.key.content === propKeyName);
    }
    return result;
}
function $4b1afda415637ecc$export$80505c1072df544f(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
}
function $4b1afda415637ecc$export$587b5ad66ebfa843(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1:
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 && ($4b1afda415637ecc$export$587b5ad66ebfa843(p.arg, ids) || $4b1afda415637ecc$export$587b5ad66ebfa843(p.exp, ids))) return true;
            }
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 11:
            if ($4b1afda415637ecc$export$587b5ad66ebfa843(node.source, ids)) return true;
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 9:
            return node.branches.some((b)=>$4b1afda415637ecc$export$587b5ad66ebfa843(b, ids));
        case 10:
            if ($4b1afda415637ecc$export$587b5ad66ebfa843(node.condition, ids)) return true;
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 4:
            return !node.isStatic && $4b1afda415637ecc$export$3cb8486ad206c65(node.content) && !!ids[node.content];
        case 8:
            return node.children.some((c)=>(0, $8POXm.isObject)(c) && $4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 5:
        case 12:
            return $4b1afda415637ecc$export$587b5ad66ebfa843(node.content, ids);
        case 2:
        case 3:
        case 20:
            return false;
        default:
            return false;
    }
}
function $4b1afda415637ecc$export$39e241985cd3e673(node) {
    if (node.type === 14 && node.callee === $4b1afda415637ecc$export$a0fd71f0f7cd2781) return node.arguments[1].returns;
    else return node;
}
const $4b1afda415637ecc$export$a81a10be31983be5 = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
function $4b1afda415637ecc$export$bf5a08668a401ef9(str) {
    for(let i = 0; i < str.length; i++){
        if (!$4b1afda415637ecc$var$isWhitespace(str.charCodeAt(i))) return false;
    }
    return true;
}
function $4b1afda415637ecc$export$e27743005f03840(node) {
    return node.type === 2 && $4b1afda415637ecc$export$bf5a08668a401ef9(node.content) || node.type === 12 && $4b1afda415637ecc$export$e27743005f03840(node.content);
}
function $4b1afda415637ecc$export$6d8f8b0d7fdfb5b0(node) {
    return node.type === 3 || $4b1afda415637ecc$export$e27743005f03840(node);
}
const $4b1afda415637ecc$var$defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0,
    isVoidTag: (0, $8POXm.NO),
    isPreTag: (0, $8POXm.NO),
    isIgnoreNewlineTag: (0, $8POXm.NO),
    isCustomElement: (0, $8POXm.NO),
    onError: $4b1afda415637ecc$var$defaultOnError,
    onWarn: $4b1afda415637ecc$var$defaultOnWarn,
    comments: false,
    prefixIdentifiers: false
};
let $4b1afda415637ecc$var$currentOptions = $4b1afda415637ecc$var$defaultParserOptions;
let $4b1afda415637ecc$var$currentRoot = null;
let $4b1afda415637ecc$var$currentInput = "";
let $4b1afda415637ecc$var$currentOpenTag = null;
let $4b1afda415637ecc$var$currentProp = null;
let $4b1afda415637ecc$var$currentAttrValue = "";
let $4b1afda415637ecc$var$currentAttrStartIndex = -1;
let $4b1afda415637ecc$var$currentAttrEndIndex = -1;
let $4b1afda415637ecc$var$inPre = 0;
let $4b1afda415637ecc$var$inVPre = false;
let $4b1afda415637ecc$var$currentVPreBoundary = null;
const $4b1afda415637ecc$var$stack = [];
const $4b1afda415637ecc$var$tokenizer = new $4b1afda415637ecc$var$Tokenizer($4b1afda415637ecc$var$stack, {
    onerr: $4b1afda415637ecc$var$emitError,
    ontext (start, end) {
        $4b1afda415637ecc$var$onText($4b1afda415637ecc$var$getSlice(start, end), start, end);
    },
    ontextentity (char, start, end) {
        $4b1afda415637ecc$var$onText(char, start, end);
    },
    oninterpolation (start, end) {
        if ($4b1afda415637ecc$var$inVPre) return $4b1afda415637ecc$var$onText($4b1afda415637ecc$var$getSlice(start, end), start, end);
        let innerStart = start + $4b1afda415637ecc$var$tokenizer.delimiterOpen.length;
        let innerEnd = end - $4b1afda415637ecc$var$tokenizer.delimiterClose.length;
        while($4b1afda415637ecc$var$isWhitespace($4b1afda415637ecc$var$currentInput.charCodeAt(innerStart)))innerStart++;
        while($4b1afda415637ecc$var$isWhitespace($4b1afda415637ecc$var$currentInput.charCodeAt(innerEnd - 1)))innerEnd--;
        let exp = $4b1afda415637ecc$var$getSlice(innerStart, innerEnd);
        if (exp.includes("&")) exp = $4b1afda415637ecc$var$currentOptions.decodeEntities(exp, false);
        $4b1afda415637ecc$var$addNode({
            type: 5,
            content: $4b1afda415637ecc$var$createExp(exp, false, $4b1afda415637ecc$var$getLoc(innerStart, innerEnd)),
            loc: $4b1afda415637ecc$var$getLoc(start, end)
        });
    },
    onopentagname (start, end) {
        const name = $4b1afda415637ecc$var$getSlice(start, end);
        $4b1afda415637ecc$var$currentOpenTag = {
            type: 1,
            tag: name,
            ns: $4b1afda415637ecc$var$currentOptions.getNamespace(name, $4b1afda415637ecc$var$stack[0], $4b1afda415637ecc$var$currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: $4b1afda415637ecc$var$getLoc(start - 1, end),
            codegenNode: void 0
        };
    },
    onopentagend (end) {
        $4b1afda415637ecc$var$endOpenTag(end);
    },
    onclosetag (start, end) {
        const name = $4b1afda415637ecc$var$getSlice(start, end);
        if (!$4b1afda415637ecc$var$currentOptions.isVoidTag(name)) {
            let found = false;
            for(let i = 0; i < $4b1afda415637ecc$var$stack.length; i++){
                const e = $4b1afda415637ecc$var$stack[i];
                if (e.tag.toLowerCase() === name.toLowerCase()) {
                    found = true;
                    if (i > 0) $4b1afda415637ecc$var$emitError(24, $4b1afda415637ecc$var$stack[0].loc.start.offset);
                    for(let j = 0; j <= i; j++){
                        const el = $4b1afda415637ecc$var$stack.shift();
                        $4b1afda415637ecc$var$onCloseTag(el, end, j < i);
                    }
                    break;
                }
            }
            if (!found) $4b1afda415637ecc$var$emitError(23, $4b1afda415637ecc$var$backTrack(start, 60));
        }
    },
    onselfclosingtag (end) {
        const name = $4b1afda415637ecc$var$currentOpenTag.tag;
        $4b1afda415637ecc$var$currentOpenTag.isSelfClosing = true;
        $4b1afda415637ecc$var$endOpenTag(end);
        if ($4b1afda415637ecc$var$stack[0] && $4b1afda415637ecc$var$stack[0].tag === name) $4b1afda415637ecc$var$onCloseTag($4b1afda415637ecc$var$stack.shift(), end);
    },
    onattribname (start, end) {
        $4b1afda415637ecc$var$currentProp = {
            type: 6,
            name: $4b1afda415637ecc$var$getSlice(start, end),
            nameLoc: $4b1afda415637ecc$var$getLoc(start, end),
            value: void 0,
            loc: $4b1afda415637ecc$var$getLoc(start)
        };
    },
    ondirname (start, end) {
        const raw = $4b1afda415637ecc$var$getSlice(start, end);
        const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
        if (!$4b1afda415637ecc$var$inVPre && name === "") $4b1afda415637ecc$var$emitError(26, start);
        if ($4b1afda415637ecc$var$inVPre || name === "") $4b1afda415637ecc$var$currentProp = {
            type: 6,
            name: raw,
            nameLoc: $4b1afda415637ecc$var$getLoc(start, end),
            value: void 0,
            loc: $4b1afda415637ecc$var$getLoc(start)
        };
        else {
            $4b1afda415637ecc$var$currentProp = {
                type: 7,
                name: name,
                rawName: raw,
                exp: void 0,
                arg: void 0,
                modifiers: raw === "." ? [
                    $4b1afda415637ecc$export$ac2aa689b44cdd23("prop")
                ] : [],
                loc: $4b1afda415637ecc$var$getLoc(start)
            };
            if (name === "pre") {
                $4b1afda415637ecc$var$inVPre = $4b1afda415637ecc$var$tokenizer.inVPre = true;
                $4b1afda415637ecc$var$currentVPreBoundary = $4b1afda415637ecc$var$currentOpenTag;
                const props = $4b1afda415637ecc$var$currentOpenTag.props;
                for(let i = 0; i < props.length; i++)if (props[i].type === 7) props[i] = $4b1afda415637ecc$var$dirToAttr(props[i]);
            }
        }
    },
    ondirarg (start, end) {
        if (start === end) return;
        const arg = $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$inVPre && !$4b1afda415637ecc$export$bd191120df7729f2($4b1afda415637ecc$var$currentProp)) {
            $4b1afda415637ecc$var$currentProp.name += arg;
            $4b1afda415637ecc$var$setLocEnd($4b1afda415637ecc$var$currentProp.nameLoc, end);
        } else {
            const isStatic = arg[0] !== `[`;
            $4b1afda415637ecc$var$currentProp.arg = $4b1afda415637ecc$var$createExp(isStatic ? arg : arg.slice(1, -1), isStatic, $4b1afda415637ecc$var$getLoc(start, end), isStatic ? 3 : 0);
        }
    },
    ondirmodifier (start, end) {
        const mod = $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$inVPre && !$4b1afda415637ecc$export$bd191120df7729f2($4b1afda415637ecc$var$currentProp)) {
            $4b1afda415637ecc$var$currentProp.name += "." + mod;
            $4b1afda415637ecc$var$setLocEnd($4b1afda415637ecc$var$currentProp.nameLoc, end);
        } else if ($4b1afda415637ecc$var$currentProp.name === "slot") {
            const arg = $4b1afda415637ecc$var$currentProp.arg;
            if (arg) {
                arg.content += "." + mod;
                $4b1afda415637ecc$var$setLocEnd(arg.loc, end);
            }
        } else {
            const exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(mod, true, $4b1afda415637ecc$var$getLoc(start, end));
            $4b1afda415637ecc$var$currentProp.modifiers.push(exp);
        }
    },
    onattribdata (start, end) {
        $4b1afda415637ecc$var$currentAttrValue += $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$currentAttrStartIndex < 0) $4b1afda415637ecc$var$currentAttrStartIndex = start;
        $4b1afda415637ecc$var$currentAttrEndIndex = end;
    },
    onattribentity (char, start, end) {
        $4b1afda415637ecc$var$currentAttrValue += char;
        if ($4b1afda415637ecc$var$currentAttrStartIndex < 0) $4b1afda415637ecc$var$currentAttrStartIndex = start;
        $4b1afda415637ecc$var$currentAttrEndIndex = end;
    },
    onattribnameend (end) {
        const start = $4b1afda415637ecc$var$currentProp.loc.start.offset;
        const name = $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$currentProp.type === 7) $4b1afda415637ecc$var$currentProp.rawName = name;
        if ($4b1afda415637ecc$var$currentOpenTag.props.some((p)=>(p.type === 7 ? p.rawName : p.name) === name)) $4b1afda415637ecc$var$emitError(2, start);
    },
    onattribend (quote, end) {
        if ($4b1afda415637ecc$var$currentOpenTag && $4b1afda415637ecc$var$currentProp) {
            $4b1afda415637ecc$var$setLocEnd($4b1afda415637ecc$var$currentProp.loc, end);
            if (quote !== 0) {
                if ($4b1afda415637ecc$var$currentAttrValue.includes("&")) $4b1afda415637ecc$var$currentAttrValue = $4b1afda415637ecc$var$currentOptions.decodeEntities($4b1afda415637ecc$var$currentAttrValue, true);
                if ($4b1afda415637ecc$var$currentProp.type === 6) {
                    if ($4b1afda415637ecc$var$currentProp.name === "class") $4b1afda415637ecc$var$currentAttrValue = $4b1afda415637ecc$var$condense($4b1afda415637ecc$var$currentAttrValue).trim();
                    if (quote === 1 && !$4b1afda415637ecc$var$currentAttrValue) $4b1afda415637ecc$var$emitError(13, end);
                    $4b1afda415637ecc$var$currentProp.value = {
                        type: 2,
                        content: $4b1afda415637ecc$var$currentAttrValue,
                        loc: quote === 1 ? $4b1afda415637ecc$var$getLoc($4b1afda415637ecc$var$currentAttrStartIndex, $4b1afda415637ecc$var$currentAttrEndIndex) : $4b1afda415637ecc$var$getLoc($4b1afda415637ecc$var$currentAttrStartIndex - 1, $4b1afda415637ecc$var$currentAttrEndIndex + 1)
                    };
                    if ($4b1afda415637ecc$var$tokenizer.inSFCRoot && $4b1afda415637ecc$var$currentOpenTag.tag === "template" && $4b1afda415637ecc$var$currentProp.name === "lang" && $4b1afda415637ecc$var$currentAttrValue && $4b1afda415637ecc$var$currentAttrValue !== "html") $4b1afda415637ecc$var$tokenizer.enterRCDATA($4b1afda415637ecc$var$toCharCodes(`</template`), 0);
                } else {
                    let expParseMode = 0 /* Normal */ ;
                    $4b1afda415637ecc$var$currentProp.exp = $4b1afda415637ecc$var$createExp($4b1afda415637ecc$var$currentAttrValue, false, $4b1afda415637ecc$var$getLoc($4b1afda415637ecc$var$currentAttrStartIndex, $4b1afda415637ecc$var$currentAttrEndIndex), 0, expParseMode);
                    if ($4b1afda415637ecc$var$currentProp.name === "for") $4b1afda415637ecc$var$currentProp.forParseResult = $4b1afda415637ecc$var$parseForExpression($4b1afda415637ecc$var$currentProp.exp);
                    let syncIndex = -1;
                    if ($4b1afda415637ecc$var$currentProp.name === "bind" && (syncIndex = $4b1afda415637ecc$var$currentProp.modifiers.findIndex((mod)=>mod.content === "sync")) > -1 && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_V_BIND_SYNC", $4b1afda415637ecc$var$currentOptions, $4b1afda415637ecc$var$currentProp.loc, $4b1afda415637ecc$var$currentProp.arg.loc.source)) {
                        $4b1afda415637ecc$var$currentProp.name = "model";
                        $4b1afda415637ecc$var$currentProp.modifiers.splice(syncIndex, 1);
                    }
                }
            }
            if ($4b1afda415637ecc$var$currentProp.type !== 7 || $4b1afda415637ecc$var$currentProp.name !== "pre") $4b1afda415637ecc$var$currentOpenTag.props.push($4b1afda415637ecc$var$currentProp);
        }
        $4b1afda415637ecc$var$currentAttrValue = "";
        $4b1afda415637ecc$var$currentAttrStartIndex = $4b1afda415637ecc$var$currentAttrEndIndex = -1;
    },
    oncomment (start, end) {
        if ($4b1afda415637ecc$var$currentOptions.comments) $4b1afda415637ecc$var$addNode({
            type: 3,
            content: $4b1afda415637ecc$var$getSlice(start, end),
            loc: $4b1afda415637ecc$var$getLoc(start - 4, end + 3)
        });
    },
    onend () {
        const end = $4b1afda415637ecc$var$currentInput.length;
        for(let index = 0; index < $4b1afda415637ecc$var$stack.length; index++){
            $4b1afda415637ecc$var$onCloseTag($4b1afda415637ecc$var$stack[index], end - 1);
            $4b1afda415637ecc$var$emitError(24, $4b1afda415637ecc$var$stack[index].loc.start.offset);
        }
    },
    oncdata (start, end) {
        if (($4b1afda415637ecc$var$stack[0] ? $4b1afda415637ecc$var$stack[0].ns : $4b1afda415637ecc$var$currentOptions.ns) !== 0) $4b1afda415637ecc$var$onText($4b1afda415637ecc$var$getSlice(start, end), start, end);
        else $4b1afda415637ecc$var$emitError(1, start - 9);
    },
    onprocessinginstruction (start) {
        if (($4b1afda415637ecc$var$stack[0] ? $4b1afda415637ecc$var$stack[0].ns : $4b1afda415637ecc$var$currentOptions.ns) === 0) $4b1afda415637ecc$var$emitError(21, start - 1);
    }
});
const $4b1afda415637ecc$var$forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const $4b1afda415637ecc$var$stripParensRE = /^\(|\)$/g;
function $4b1afda415637ecc$var$parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match($4b1afda415637ecc$export$a81a10be31983be5);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false)=>{
        const start = loc.start.offset + offset;
        const end = start + content.length;
        return $4b1afda415637ecc$var$createExp(content, false, $4b1afda415637ecc$var$getLoc(start, end), 0, asParam ? 1 /* Params */  : 0 /* Normal */ );
    };
    const result = {
        source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: void 0,
        key: void 0,
        index: void 0,
        finalized: false
    };
    let valueContent = LHS.trim().replace($4b1afda415637ecc$var$stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match($4b1afda415637ecc$var$forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace($4b1afda415637ecc$var$forIteratorRE, "").trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(keyContent, keyOffset, true);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = createAliasExpression(indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length), true);
        }
    }
    if (valueContent) result.value = createAliasExpression(valueContent, trimmedOffset, true);
    return result;
}
function $4b1afda415637ecc$var$getSlice(start, end) {
    return $4b1afda415637ecc$var$currentInput.slice(start, end);
}
function $4b1afda415637ecc$var$endOpenTag(end) {
    if ($4b1afda415637ecc$var$tokenizer.inSFCRoot) $4b1afda415637ecc$var$currentOpenTag.innerLoc = $4b1afda415637ecc$var$getLoc(end + 1, end + 1);
    $4b1afda415637ecc$var$addNode($4b1afda415637ecc$var$currentOpenTag);
    const { tag: tag, ns: ns } = $4b1afda415637ecc$var$currentOpenTag;
    if (ns === 0 && $4b1afda415637ecc$var$currentOptions.isPreTag(tag)) $4b1afda415637ecc$var$inPre++;
    if ($4b1afda415637ecc$var$currentOptions.isVoidTag(tag)) $4b1afda415637ecc$var$onCloseTag($4b1afda415637ecc$var$currentOpenTag, end);
    else {
        $4b1afda415637ecc$var$stack.unshift($4b1afda415637ecc$var$currentOpenTag);
        if (ns === 1 || ns === 2) $4b1afda415637ecc$var$tokenizer.inXML = true;
    }
    $4b1afda415637ecc$var$currentOpenTag = null;
}
function $4b1afda415637ecc$var$onText(content, start, end) {
    {
        const tag = $4b1afda415637ecc$var$stack[0] && $4b1afda415637ecc$var$stack[0].tag;
        if (tag !== "script" && tag !== "style" && content.includes("&")) content = $4b1afda415637ecc$var$currentOptions.decodeEntities(content, false);
    }
    const parent = $4b1afda415637ecc$var$stack[0] || $4b1afda415637ecc$var$currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
        lastNode.content += content;
        $4b1afda415637ecc$var$setLocEnd(lastNode.loc, end);
    } else parent.children.push({
        type: 2,
        content: content,
        loc: $4b1afda415637ecc$var$getLoc(start, end)
    });
}
function $4b1afda415637ecc$var$onCloseTag(el, end, isImplied = false) {
    if (isImplied) $4b1afda415637ecc$var$setLocEnd(el.loc, $4b1afda415637ecc$var$backTrack(end, 60));
    else $4b1afda415637ecc$var$setLocEnd(el.loc, $4b1afda415637ecc$var$lookAhead(end, 62) + 1);
    if ($4b1afda415637ecc$var$tokenizer.inSFCRoot) {
        if (el.children.length) el.innerLoc.end = (0, $8POXm.extend)({}, el.children[el.children.length - 1].loc.end);
        else el.innerLoc.end = (0, $8POXm.extend)({}, el.innerLoc.start);
        el.innerLoc.source = $4b1afda415637ecc$var$getSlice(el.innerLoc.start.offset, el.innerLoc.end.offset);
    }
    const { tag: tag, ns: ns, children: children } = el;
    if (!$4b1afda415637ecc$var$inVPre) {
        if (tag === "slot") el.tagType = 2;
        else if ($4b1afda415637ecc$var$isFragmentTemplate(el)) el.tagType = 3;
        else if ($4b1afda415637ecc$var$isComponent(el)) el.tagType = 1;
    }
    if (!$4b1afda415637ecc$var$tokenizer.inRCDATA) el.children = $4b1afda415637ecc$var$condenseWhitespace(children);
    if (ns === 0 && $4b1afda415637ecc$var$currentOptions.isIgnoreNewlineTag(tag)) {
        const first = children[0];
        if (first && first.type === 2) first.content = first.content.replace(/^\r?\n/, "");
    }
    if (ns === 0 && $4b1afda415637ecc$var$currentOptions.isPreTag(tag)) $4b1afda415637ecc$var$inPre--;
    if ($4b1afda415637ecc$var$currentVPreBoundary === el) {
        $4b1afda415637ecc$var$inVPre = $4b1afda415637ecc$var$tokenizer.inVPre = false;
        $4b1afda415637ecc$var$currentVPreBoundary = null;
    }
    if ($4b1afda415637ecc$var$tokenizer.inXML && ($4b1afda415637ecc$var$stack[0] ? $4b1afda415637ecc$var$stack[0].ns : $4b1afda415637ecc$var$currentOptions.ns) === 0) $4b1afda415637ecc$var$tokenizer.inXML = false;
    {
        const props = el.props;
        if (!$4b1afda415637ecc$var$tokenizer.inSFCRoot && $4b1afda415637ecc$var$isCompatEnabled("COMPILER_NATIVE_TEMPLATE", $4b1afda415637ecc$var$currentOptions) && el.tag === "template" && !$4b1afda415637ecc$var$isFragmentTemplate(el)) {
            const parent = $4b1afda415637ecc$var$stack[0] || $4b1afda415637ecc$var$currentRoot;
            const index = parent.children.indexOf(el);
            parent.children.splice(index, 1, ...el.children);
        }
        const inlineTemplateProp = props.find((p)=>p.type === 6 && p.name === "inline-template");
        if (inlineTemplateProp && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_INLINE_TEMPLATE", $4b1afda415637ecc$var$currentOptions, inlineTemplateProp.loc) && el.children.length) inlineTemplateProp.value = {
            type: 2,
            content: $4b1afda415637ecc$var$getSlice(el.children[0].loc.start.offset, el.children[el.children.length - 1].loc.end.offset),
            loc: inlineTemplateProp.loc
        };
    }
}
function $4b1afda415637ecc$var$lookAhead(index, c) {
    let i = index;
    while($4b1afda415637ecc$var$currentInput.charCodeAt(i) !== c && i < $4b1afda415637ecc$var$currentInput.length - 1)i++;
    return i;
}
function $4b1afda415637ecc$var$backTrack(index, c) {
    let i = index;
    while($4b1afda415637ecc$var$currentInput.charCodeAt(i) !== c && i >= 0)i--;
    return i;
}
const $4b1afda415637ecc$var$specialTemplateDir = /* @__PURE__ */ new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]);
function $4b1afda415637ecc$var$isFragmentTemplate({ tag: tag, props: props }) {
    if (tag === "template") for(let i = 0; i < props.length; i++){
        if (props[i].type === 7 && $4b1afda415637ecc$var$specialTemplateDir.has(props[i].name)) return true;
    }
    return false;
}
function $4b1afda415637ecc$var$isComponent({ tag: tag, props: props }) {
    if ($4b1afda415637ecc$var$currentOptions.isCustomElement(tag)) return false;
    if (tag === "component" || $4b1afda415637ecc$var$isUpperCase(tag.charCodeAt(0)) || $4b1afda415637ecc$export$69768c9b514a01e9(tag) || $4b1afda415637ecc$var$currentOptions.isBuiltInComponent && $4b1afda415637ecc$var$currentOptions.isBuiltInComponent(tag) || $4b1afda415637ecc$var$currentOptions.isNativeTag && !$4b1afda415637ecc$var$currentOptions.isNativeTag(tag)) return true;
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6) {
            if (p.name === "is" && p.value) {
                if (p.value.content.startsWith("vue:")) return true;
                else if ($4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT", $4b1afda415637ecc$var$currentOptions, p.loc)) return true;
            }
        } else if (p.name === "bind" && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, "is") && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT", $4b1afda415637ecc$var$currentOptions, p.loc)) return true;
    }
    return false;
}
function $4b1afda415637ecc$var$isUpperCase(c) {
    return c > 64 && c < 91;
}
const $4b1afda415637ecc$var$windowsNewlineRE = /\r\n/g;
function $4b1afda415637ecc$var$condenseWhitespace(nodes) {
    const shouldCondense = $4b1afda415637ecc$var$currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.type === 2) {
            if (!$4b1afda415637ecc$var$inPre) {
                if ($4b1afda415637ecc$export$bf5a08668a401ef9(node.content)) {
                    const prev = nodes[i - 1] && nodes[i - 1].type;
                    const next = nodes[i + 1] && nodes[i + 1].type;
                    if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && $4b1afda415637ecc$var$hasNewlineChar(node.content)))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else node.content = " ";
                } else if (shouldCondense) node.content = $4b1afda415637ecc$var$condense(node.content);
            } else node.content = node.content.replace($4b1afda415637ecc$var$windowsNewlineRE, "\n");
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function $4b1afda415637ecc$var$hasNewlineChar(str) {
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c === 10 || c === 13) return true;
    }
    return false;
}
function $4b1afda415637ecc$var$condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for(let i = 0; i < str.length; i++){
        if ($4b1afda415637ecc$var$isWhitespace(str.charCodeAt(i))) {
            if (!prevCharIsWhitespace) {
                ret += " ";
                prevCharIsWhitespace = true;
            }
        } else {
            ret += str[i];
            prevCharIsWhitespace = false;
        }
    }
    return ret;
}
function $4b1afda415637ecc$var$addNode(node) {
    ($4b1afda415637ecc$var$stack[0] || $4b1afda415637ecc$var$currentRoot).children.push(node);
}
function $4b1afda415637ecc$var$getLoc(start, end) {
    return {
        start: $4b1afda415637ecc$var$tokenizer.getPos(start),
        // @ts-expect-error allow late attachment
        end: end == null ? end : $4b1afda415637ecc$var$tokenizer.getPos(end),
        // @ts-expect-error allow late attachment
        source: end == null ? end : $4b1afda415637ecc$var$getSlice(start, end)
    };
}
function $4b1afda415637ecc$var$cloneLoc(loc) {
    return $4b1afda415637ecc$var$getLoc(loc.start.offset, loc.end.offset);
}
function $4b1afda415637ecc$var$setLocEnd(loc, end) {
    loc.end = $4b1afda415637ecc$var$tokenizer.getPos(end);
    loc.source = $4b1afda415637ecc$var$getSlice(loc.start.offset, end);
}
function $4b1afda415637ecc$var$dirToAttr(dir) {
    const attr = {
        type: 6,
        name: dir.rawName,
        nameLoc: $4b1afda415637ecc$var$getLoc(dir.loc.start.offset, dir.loc.start.offset + dir.rawName.length),
        value: void 0,
        loc: dir.loc
    };
    if (dir.exp) {
        const loc = dir.exp.loc;
        if (loc.end.offset < dir.loc.end.offset) {
            loc.start.offset--;
            loc.start.column--;
            loc.end.offset++;
            loc.end.column++;
        }
        attr.value = {
            type: 2,
            content: dir.exp.content,
            loc: loc
        };
    }
    return attr;
}
function $4b1afda415637ecc$var$createExp(content, isStatic = false, loc, constType = 0, parseMode = 0 /* Normal */ ) {
    const exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(content, isStatic, loc, constType);
    return exp;
}
function $4b1afda415637ecc$var$emitError(code, index, message) {
    $4b1afda415637ecc$var$currentOptions.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(code, $4b1afda415637ecc$var$getLoc(index, index), void 0, message));
}
function $4b1afda415637ecc$var$reset() {
    $4b1afda415637ecc$var$tokenizer.reset();
    $4b1afda415637ecc$var$currentOpenTag = null;
    $4b1afda415637ecc$var$currentProp = null;
    $4b1afda415637ecc$var$currentAttrValue = "";
    $4b1afda415637ecc$var$currentAttrStartIndex = -1;
    $4b1afda415637ecc$var$currentAttrEndIndex = -1;
    $4b1afda415637ecc$var$stack.length = 0;
}
function $4b1afda415637ecc$export$f5f219d5f09c81b5(input, options) {
    $4b1afda415637ecc$var$reset();
    $4b1afda415637ecc$var$currentInput = input;
    $4b1afda415637ecc$var$currentOptions = (0, $8POXm.extend)({}, $4b1afda415637ecc$var$defaultParserOptions);
    if (options) {
        let key;
        for(key in options)if (options[key] != null) $4b1afda415637ecc$var$currentOptions[key] = options[key];
    }
    $4b1afda415637ecc$var$tokenizer.mode = $4b1afda415637ecc$var$currentOptions.parseMode === "html" ? 1 : $4b1afda415637ecc$var$currentOptions.parseMode === "sfc" ? 2 : 0;
    $4b1afda415637ecc$var$tokenizer.inXML = $4b1afda415637ecc$var$currentOptions.ns === 1 || $4b1afda415637ecc$var$currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
        $4b1afda415637ecc$var$tokenizer.delimiterOpen = $4b1afda415637ecc$var$toCharCodes(delimiters[0]);
        $4b1afda415637ecc$var$tokenizer.delimiterClose = $4b1afda415637ecc$var$toCharCodes(delimiters[1]);
    }
    const root = $4b1afda415637ecc$var$currentRoot = $4b1afda415637ecc$export$882461b6382ed46c([], input);
    $4b1afda415637ecc$var$tokenizer.parse($4b1afda415637ecc$var$currentInput);
    root.loc = $4b1afda415637ecc$var$getLoc(0, input.length);
    root.children = $4b1afda415637ecc$var$condenseWhitespace(root.children);
    $4b1afda415637ecc$var$currentRoot = null;
    return root;
}
function $4b1afda415637ecc$var$cacheStatic(root, context) {
    $4b1afda415637ecc$var$walk(root, void 0, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    !!$4b1afda415637ecc$var$getSingleElementRoot(root));
}
function $4b1afda415637ecc$var$getSingleElementRoot(root) {
    const children = root.children.filter((x)=>x.type !== 3);
    return children.length === 1 && children[0].type === 1 && !$4b1afda415637ecc$export$45f38ad7fffc9b53(children[0]) ? children[0] : null;
}
function $4b1afda415637ecc$var$walk(node, parent, context, doNotHoistNode = false, inFor = false) {
    const { children: children } = node;
    const toCache = [];
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.type === 1 && child.tagType === 0) {
            const constantType = doNotHoistNode ? 0 : $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
            if (constantType > 0) {
                if (constantType >= 2) {
                    child.codegenNode.patchFlag = -1;
                    toCache.push(child);
                    continue;
                }
            } else {
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13) {
                    const flag = codegenNode.patchFlag;
                    if ((flag === void 0 || flag === 512 || flag === 1) && $4b1afda415637ecc$var$getGeneratedPropsConstantType(child, context) >= 2) {
                        const props = $4b1afda415637ecc$var$getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        } else if (child.type === 12) {
            const constantType = doNotHoistNode ? 0 : $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
            if (constantType >= 2) {
                if (child.codegenNode.type === 14 && child.codegenNode.arguments.length > 0) child.codegenNode.arguments.push(-1 + ``);
                toCache.push(child);
                continue;
            }
        }
        if (child.type === 1) {
            const isComponent = child.tagType === 1;
            if (isComponent) context.scopes.vSlot++;
            $4b1afda415637ecc$var$walk(child, node, context, false, inFor);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11) $4b1afda415637ecc$var$walk(child, node, context, child.children.length === 1, true);
        else if (child.type === 9) for(let i2 = 0; i2 < child.branches.length; i2++)$4b1afda415637ecc$var$walk(child.branches[i2], node, context, child.branches[i2].children.length === 1, inFor);
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
        if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && (0, $8POXm.isArray)(node.codegenNode.children)) {
            node.codegenNode.children = getCacheExpression($4b1afda415637ecc$export$c887713da9895dbb(node.codegenNode.children));
            cachedAsArray = true;
        } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !(0, $8POXm.isArray)(node.codegenNode.children) && node.codegenNode.children.type === 15) {
            const slot = getSlotNode(node.codegenNode, "default");
            if (slot) {
                slot.returns = getCacheExpression($4b1afda415637ecc$export$c887713da9895dbb(slot.returns));
                cachedAsArray = true;
            }
        } else if (node.tagType === 3 && parent && parent.type === 1 && parent.tagType === 1 && parent.codegenNode && parent.codegenNode.type === 13 && parent.codegenNode.children && !(0, $8POXm.isArray)(parent.codegenNode.children) && parent.codegenNode.children.type === 15) {
            const slotName = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "slot", true);
            const slot = slotName && slotName.arg && getSlotNode(parent.codegenNode, slotName.arg);
            if (slot) {
                slot.returns = getCacheExpression($4b1afda415637ecc$export$c887713da9895dbb(slot.returns));
                cachedAsArray = true;
            }
        }
    }
    if (!cachedAsArray) for (const child of toCache)child.codegenNode = context.cache(child.codegenNode);
    function getCacheExpression(value) {
        const exp = context.cache(value);
        exp.needArraySpread = true;
        return exp;
    }
    function getSlotNode(node2, name) {
        if (node2.children && !(0, $8POXm.isArray)(node2.children) && node2.children.type === 15) {
            const slot = node2.children.properties.find((p)=>p.key === name || p.key.content === name);
            return slot && slot.value;
        }
    }
    if (toCache.length && context.transformHoist) context.transformHoist(children, context, node);
}
function $4b1afda415637ecc$export$7967f5197c38d72a(node, context) {
    const { constantCache: constantCache } = context;
    switch(node.type){
        case 1:
            if (node.tagType !== 0) return 0;
            const cached = constantCache.get(node);
            if (cached !== void 0) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13) return 0;
            if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") return 0;
            if (codegenNode.patchFlag === void 0) {
                let returnType2 = 3;
                const generatedPropsType = $4b1afda415637ecc$var$getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0) {
                    constantCache.set(node, 0);
                    return 0;
                }
                if (generatedPropsType < returnType2) returnType2 = generatedPropsType;
                for(let i = 0; i < node.children.length; i++){
                    const childType = $4b1afda415637ecc$export$7967f5197c38d72a(node.children[i], context);
                    if (childType === 0) {
                        constantCache.set(node, 0);
                        return 0;
                    }
                    if (childType < returnType2) returnType2 = childType;
                }
                if (returnType2 > 1) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 && p.name === "bind" && p.exp) {
                        const expType = $4b1afda415637ecc$export$7967f5197c38d72a(p.exp, context);
                        if (expType === 0) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                        if (expType < returnType2) returnType2 = expType;
                    }
                }
                if (codegenNode.isBlock) {
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                    }
                    context.removeHelper($4b1afda415637ecc$export$59578e14f90a15eb);
                    context.removeHelper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType2);
                return returnType2;
            } else {
                constantCache.set(node, 0);
                return 0;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
            return 0;
        case 5:
        case 12:
            return $4b1afda415637ecc$export$7967f5197c38d72a(node.content, context);
        case 4:
            return node.constType;
        case 8:
            let returnType = 3;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, $8POXm.isString)(child) || (0, $8POXm.isSymbol)(child)) continue;
                const childType = $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
                if (childType === 0) return 0;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        case 20:
            return 2;
        default:
            return 0;
    }
}
const $4b1afda415637ecc$var$allowHoistedHelperSet = /* @__PURE__ */ new Set([
    $4b1afda415637ecc$export$6382e3ed89de4e2a,
    $4b1afda415637ecc$export$b9d3780a9ab822b4,
    $4b1afda415637ecc$export$78c34c869683dd86,
    $4b1afda415637ecc$export$7046bb8d3c918928
]);
function $4b1afda415637ecc$var$getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !(0, $8POXm.isString)(value.callee) && $4b1afda415637ecc$var$allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4) return $4b1afda415637ecc$export$7967f5197c38d72a(arg, context);
        else if (arg.type === 14) return $4b1afda415637ecc$var$getConstantTypeOfHelperCall(arg, context);
    }
    return 0;
}
function $4b1afda415637ecc$var$getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = $4b1afda415637ecc$var$getNodeProps(node);
    if (props && props.type === 15) {
        const { properties: properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key: key, value: value } = properties[i];
            const keyType = $4b1afda415637ecc$export$7967f5197c38d72a(key, context);
            if (keyType === 0) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4) valueType = $4b1afda415637ecc$export$7967f5197c38d72a(value, context);
            else if (value.type === 14) valueType = $4b1afda415637ecc$var$getConstantTypeOfHelperCall(value, context);
            else valueType = 0;
            if (valueType === 0) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function $4b1afda415637ecc$var$getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) return codegenNode.props;
}
function $4b1afda415637ecc$export$7438cb739e972616(root, { filename: filename = "", prefixIdentifiers: prefixIdentifiers = false, hoistStatic: hoistStatic = false, hmr: hmr = false, cacheHandlers: cacheHandlers = false, nodeTransforms: nodeTransforms = [], directiveTransforms: directiveTransforms = {}, transformHoist: transformHoist = null, isBuiltInComponent: isBuiltInComponent = (0, $8POXm.NOOP), isCustomElement: isCustomElement = (0, $8POXm.NOOP), expressionPlugins: expressionPlugins = [], scopeId: scopeId = null, slotted: slotted = true, ssr: ssr = false, inSSR: inSSR = false, ssrCssVars: ssrCssVars = ``, bindingMetadata: bindingMetadata = (0, $8POXm.EMPTY_OBJ), inline: inline = false, isTS: isTS = false, onError: onError = $4b1afda415637ecc$var$defaultOnError, onWarn: onWarn = $4b1afda415637ecc$var$defaultOnWarn, compatConfig: compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
        filename: // options
        filename,
        selfName: nameMatch && (0, $8POXm.capitalize)((0, $8POXm.camelize)(nameMatch[1])),
        prefixIdentifiers: prefixIdentifiers,
        hoistStatic: hoistStatic,
        hmr: hmr,
        cacheHandlers: cacheHandlers,
        nodeTransforms: nodeTransforms,
        directiveTransforms: directiveTransforms,
        transformHoist: transformHoist,
        isBuiltInComponent: isBuiltInComponent,
        isCustomElement: isCustomElement,
        expressionPlugins: expressionPlugins,
        scopeId: scopeId,
        slotted: slotted,
        ssr: ssr,
        inSSR: inSSR,
        ssrCssVars: ssrCssVars,
        bindingMetadata: bindingMetadata,
        inline: inline,
        isTS: isTS,
        onError: onError,
        onWarn: onWarn,
        compatConfig: compatConfig,
        root: // state
        root,
        helpers: /* @__PURE__ */ new Map(),
        components: /* @__PURE__ */ new Set(),
        directives: /* @__PURE__ */ new Set(),
        hoists: [],
        imports: [],
        cached: [],
        constantCache: /* @__PURE__ */ new WeakMap(),
        vForMemoKeyedNodes: /* @__PURE__ */ new WeakSet(),
        temps: 0,
        identifiers: /* @__PURE__ */ Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        grandParent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                context.currentNode = null;
                context.onNodeRemoved();
            } else if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: (0, $8POXm.NOOP),
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, $8POXm.isString)(exp)) exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(exp);
            context.hoists.push(exp);
            const identifier = $4b1afda415637ecc$export$ac2aa689b44cdd23(`_hoisted_${context.hoists.length}`, false, exp.loc, 2);
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false, inVOnce = false) {
            const cacheExp = $4b1afda415637ecc$export$4abd162ddf919697(context.cached.length, exp, isVNode, inVOnce);
            context.cached.push(cacheExp);
            return cacheExp;
        }
    };
    context.filters = /* @__PURE__ */ new Set();
    return context;
}
function $4b1afda415637ecc$export$51186ad6e864892a(root, options) {
    const context = $4b1afda415637ecc$export$7438cb739e972616(root, options);
    $4b1afda415637ecc$export$c9d429747c1011af(root, context);
    if (options.hoistStatic) $4b1afda415637ecc$var$cacheStatic(root, context);
    if (!options.ssr) $4b1afda415637ecc$var$createRootCodegen(root, context);
    root.helpers = /* @__PURE__ */ new Set([
        ...context.helpers.keys()
    ]);
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    root.filters = [
        ...context.filters
    ];
}
function $4b1afda415637ecc$var$createRootCodegen(root, context) {
    const { helper: helper } = context;
    const { children: children } = root;
    if (children.length === 1) {
        const singleElementRootChild = $4b1afda415637ecc$var$getSingleElementRoot(root);
        if (singleElementRootChild && singleElementRootChild.codegenNode) {
            const codegenNode = singleElementRootChild.codegenNode;
            if (codegenNode.type === 13) $4b1afda415637ecc$export$dc00c05f515bd739(codegenNode, context);
            root.codegenNode = codegenNode;
        } else root.codegenNode = children[0];
    } else if (children.length > 1) {
        let patchFlag = 64;
        root.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), void 0, root.children, patchFlag, void 0, void 0, true, void 0, false);
    }
}
function $4b1afda415637ecc$var$traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, $8POXm.isString)(child)) continue;
        context.grandParent = context.parent;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        $4b1afda415637ecc$export$c9d429747c1011af(child, context);
    }
}
function $4b1afda415637ecc$export$c9d429747c1011af(node, context) {
    context.currentNode = node;
    const { nodeTransforms: nodeTransforms } = context;
    const exitFns = [];
    for(let i2 = 0; i2 < nodeTransforms.length; i2++){
        const onExit = nodeTransforms[i2](node, context);
        if (onExit) {
            if ((0, $8POXm.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) return;
        else node = context.currentNode;
    }
    switch(node.type){
        case 3:
            if (!context.ssr) context.helper($4b1afda415637ecc$export$b2aae42fb0a19db3);
            break;
        case 5:
            if (!context.ssr) context.helper($4b1afda415637ecc$export$68f5914cce0a5680);
            break;
        // for container types, further traverse downwards
        case 9:
            for(let i2 = 0; i2 < node.branches.length; i2++)$4b1afda415637ecc$export$c9d429747c1011af(node.branches[i2], context);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            $4b1afda415637ecc$var$traverseChildren(node, context);
            break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function $4b1afda415637ecc$export$aee0887cf96094d7(name, fn) {
    const matches = (0, $8POXm.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1) {
            const { props: props } = node;
            if (node.tagType === 3 && props.some($4b1afda415637ecc$export$eaf8991bb8af8cbb)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 && matches(prop.name)) {
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const $4b1afda415637ecc$var$PURE_ANNOTATION = `/*@__PURE__*/`;
const $4b1afda415637ecc$var$aliasHelper = (s)=>`${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[s]}: _${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[s]}`;
function $4b1afda415637ecc$var$createCodegenContext(ast, { mode: mode = "function", prefixIdentifiers: prefixIdentifiers = mode === "module", sourceMap: sourceMap = false, filename: filename = `template.vue.html`, scopeId: scopeId = null, optimizeImports: optimizeImports = false, runtimeGlobalName: runtimeGlobalName = `Vue`, runtimeModuleName: runtimeModuleName = `vue`, ssrRuntimeModuleName: ssrRuntimeModuleName = "vue/server-renderer", ssr: ssr = false, isTS: isTS = false, inSSR: inSSR = false }) {
    const context = {
        mode: mode,
        prefixIdentifiers: prefixIdentifiers,
        sourceMap: sourceMap,
        filename: filename,
        scopeId: scopeId,
        optimizeImports: optimizeImports,
        runtimeGlobalName: runtimeGlobalName,
        runtimeModuleName: runtimeModuleName,
        ssrRuntimeModuleName: ssrRuntimeModuleName,
        ssr: ssr,
        isTS: isTS,
        inSSR: inSSR,
        source: ast.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: void 0,
        helper (key) {
            return `_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[key]}`;
        },
        push (code, newlineIndex = -2 /* None */ , node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push("\n" + `  `.repeat(n), 0 /* Start */ );
    }
    return context;
}
function $4b1afda415637ecc$export$80d376111cc09ad7(ast, options = {}) {
    const context = $4b1afda415637ecc$var$createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode: mode, push: push, prefixIdentifiers: prefixIdentifiers, indent: indent, deindent: deindent, newline: newline, scopeId: scopeId, ssr: ssr } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    $4b1afda415637ecc$var$genFunctionPreamble(ast, preambleContext);
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        "_ctx",
        "_push",
        "_parent",
        "_attrs"
    ] : [
        "_ctx",
        "_cache"
    ];
    const signature = args.join(", ");
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        if (hasHelpers) {
            push(`const { ${helpers.map($4b1afda415637ecc$var$aliasHelper).join(", ")} } = _Vue
`, -1 /* End */ );
            newline();
        }
    }
    if (ast.components.length) {
        $4b1afda415637ecc$var$genAssets(ast.components, "component", context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        $4b1afda415637ecc$var$genAssets(ast.directives, "directive", context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        $4b1afda415637ecc$var$genAssets(ast.filters, "filter", context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`
`, 0 /* Start */ );
        newline();
    }
    if (!ssr) push(`return `);
    if (ast.codegenNode) $4b1afda415637ecc$var$genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast: ast,
        code: context.code,
        preamble: ``,
        map: context.map ? context.map.toJSON() : void 0
    };
}
function $4b1afda415637ecc$var$genFunctionPreamble(ast, context) {
    const { ssr: ssr, prefixIdentifiers: prefixIdentifiers, push: push, newline: newline, runtimeModuleName: runtimeModuleName, runtimeGlobalName: runtimeGlobalName, ssrRuntimeModuleName: ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
        push(`const _Vue = ${VueBinding}
`, -1 /* End */ );
        if (ast.hoists.length) {
            const staticHelpers = [
                $4b1afda415637ecc$export$6db5bf2474139178,
                $4b1afda415637ecc$export$b22e7e78da20c982,
                $4b1afda415637ecc$export$b2aae42fb0a19db3,
                $4b1afda415637ecc$export$8890896270dfc293,
                $4b1afda415637ecc$export$1a493e4b98fdcf3
            ].filter((helper)=>helpers.includes(helper)).map($4b1afda415637ecc$var$aliasHelper).join(", ");
            push(`const { ${staticHelpers} } = _Vue
`, -1 /* End */ );
        }
    }
    $4b1afda415637ecc$var$genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function $4b1afda415637ecc$var$genAssets(assets, type, { helper: helper, push: push, newline: newline, isTS: isTS }) {
    const resolver = helper(type === "filter" ? $4b1afda415637ecc$export$2c190751e09c3969 : type === "component" ? $4b1afda415637ecc$export$28c52e95383d270 : $4b1afda415637ecc$export$7f3ccc2ef793ecce);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        const maybeSelfReference = id.endsWith("__self");
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${$4b1afda415637ecc$export$80505c1072df544f(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function $4b1afda415637ecc$var$genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push: push, newline: newline } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = `);
            $4b1afda415637ecc$var$genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function $4b1afda415637ecc$var$isText(n) {
    return (0, $8POXm.isString)(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
}
function $4b1afda415637ecc$var$genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    $4b1afda415637ecc$var$genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function $4b1afda415637ecc$var$genNodeList(nodes, context, multilines = false, comma = true) {
    const { push: push, newline: newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, $8POXm.isString)(node)) push(node, -3 /* Unknown */ );
        else if ((0, $8POXm.isArray)(node)) $4b1afda415637ecc$var$genNodeListAsArray(node, context);
        else $4b1afda415637ecc$var$genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(",");
                newline();
            } else comma && push(", ");
        }
    }
}
function $4b1afda415637ecc$var$genNode(node, context) {
    if ((0, $8POXm.isString)(node)) {
        context.push(node, -3 /* Unknown */ );
        return;
    }
    if ((0, $8POXm.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1:
        case 9:
        case 11:
            $4b1afda415637ecc$var$genNode(node.codegenNode, context);
            break;
        case 2:
            $4b1afda415637ecc$var$genText(node, context);
            break;
        case 4:
            $4b1afda415637ecc$var$genExpression(node, context);
            break;
        case 5:
            $4b1afda415637ecc$var$genInterpolation(node, context);
            break;
        case 12:
            $4b1afda415637ecc$var$genNode(node.codegenNode, context);
            break;
        case 8:
            $4b1afda415637ecc$var$genCompoundExpression(node, context);
            break;
        case 3:
            $4b1afda415637ecc$var$genComment(node, context);
            break;
        case 13:
            $4b1afda415637ecc$var$genVNodeCall(node, context);
            break;
        case 14:
            $4b1afda415637ecc$var$genCallExpression(node, context);
            break;
        case 15:
            $4b1afda415637ecc$var$genObjectExpression(node, context);
            break;
        case 17:
            $4b1afda415637ecc$var$genArrayExpression(node, context);
            break;
        case 18:
            $4b1afda415637ecc$var$genFunctionExpression(node, context);
            break;
        case 19:
            $4b1afda415637ecc$var$genConditionalExpression(node, context);
            break;
        case 20:
            $4b1afda415637ecc$var$genCacheExpression(node, context);
            break;
        case 21:
            $4b1afda415637ecc$var$genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22:
            break;
        case 23:
            break;
        case 24:
            break;
        case 25:
            break;
        case 26:
            break;
        /* v8 ignore start */ case 10:
            break;
        default:
    }
}
function $4b1afda415637ecc$var$genText(node, context) {
    context.push(JSON.stringify(node.content), -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genExpression(node, context) {
    const { content: content, isStatic: isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genInterpolation(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(`${helper($4b1afda415637ecc$export$68f5914cce0a5680)}(`);
    $4b1afda415637ecc$var$genNode(node.content, context);
    push(`)`);
}
function $4b1afda415637ecc$var$genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, $8POXm.isString)(child)) context.push(child, -3 /* Unknown */ );
        else $4b1afda415637ecc$var$genNode(child, context);
    }
}
function $4b1afda415637ecc$var$genExpressionAsPropertyKey(node, context) {
    const { push: push } = context;
    if (node.type === 8) {
        push(`[`);
        $4b1afda415637ecc$var$genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        const text = $4b1afda415637ecc$export$3cb8486ad206c65(node.content) ? node.content : JSON.stringify(node.content);
        push(text, -2 /* None */ , node);
    } else push(`[${node.content}]`, -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genComment(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(`${helper($4b1afda415637ecc$export$b2aae42fb0a19db3)}(${JSON.stringify(node.content)})`, -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genVNodeCall(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const { tag: tag, props: props, children: children, patchFlag: patchFlag, dynamicProps: dynamicProps, directives: directives, isBlock: isBlock, disableTracking: disableTracking, isComponent: isComponent } = node;
    let patchFlagString;
    if (patchFlag) patchFlagString = String(patchFlag);
    if (directives) push(helper($4b1afda415637ecc$export$a5e4c1729e50ed6d) + `(`);
    if (isBlock) push(`(${helper($4b1afda415637ecc$export$59578e14f90a15eb)}(${disableTracking ? `true` : ``}), `);
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    const callHelper = isBlock ? $4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, isComponent) : $4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, -2 /* None */ , node);
    $4b1afda415637ecc$var$genNodeList($4b1afda415637ecc$var$genNullableArgs([
        tag,
        props,
        children,
        patchFlagString,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        $4b1afda415637ecc$var$genNode(directives, context);
        push(`)`);
    }
}
function $4b1afda415637ecc$var$genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
function $4b1afda415637ecc$var$genCallExpression(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const callee = (0, $8POXm.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(callee + `(`, -2 /* None */ , node);
    $4b1afda415637ecc$var$genNodeList(node.arguments, context);
    push(`)`);
}
function $4b1afda415637ecc$var$genObjectExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    const { properties: properties } = node;
    if (!properties.length) {
        push(`{}`, -2 /* None */ , node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key: key, value: value } = properties[i];
        $4b1afda415637ecc$var$genExpressionAsPropertyKey(key, context);
        push(`: `);
        $4b1afda415637ecc$var$genNode(value, context);
        if (i < properties.length - 1) {
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function $4b1afda415637ecc$var$genArrayExpression(node, context) {
    $4b1afda415637ecc$var$genNodeListAsArray(node.elements, context);
}
function $4b1afda415637ecc$var$genFunctionExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent } = context;
    const { params: params, returns: returns, body: body, newline: newline, isSlot: isSlot } = node;
    if (isSlot) push(`_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[$4b1afda415637ecc$export$141e17a2b5200090]}(`);
    push(`(`, -2 /* None */ , node);
    if ((0, $8POXm.isArray)(params)) $4b1afda415637ecc$var$genNodeList(params, context);
    else if (params) $4b1afda415637ecc$var$genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, $8POXm.isArray)(returns)) $4b1afda415637ecc$var$genNodeListAsArray(returns, context);
        else $4b1afda415637ecc$var$genNode(returns, context);
    } else if (body) $4b1afda415637ecc$var$genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function $4b1afda415637ecc$var$genConditionalExpression(node, context) {
    const { test: test, consequent: consequent, alternate: alternate, newline: needNewline } = node;
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    if (test.type === 4) {
        const needsParens = !$4b1afda415637ecc$export$3cb8486ad206c65(test.content);
        needsParens && push(`(`);
        $4b1afda415637ecc$var$genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        $4b1afda415637ecc$var$genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    $4b1afda415637ecc$var$genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) context.indentLevel++;
    $4b1afda415637ecc$var$genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function $4b1afda415637ecc$var$genCacheExpression(node, context) {
    const { push: push, helper: helper, indent: indent, deindent: deindent, newline: newline } = context;
    const { needPauseTracking: needPauseTracking, needArraySpread: needArraySpread } = node;
    if (needArraySpread) push(`[...(`);
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
        indent();
        push(`${helper($4b1afda415637ecc$export$37cf1f9ab937c10d)}(-1`);
        if (node.inVOnce) push(`, true`);
        push(`),`);
        newline();
        push(`(`);
    }
    push(`_cache[${node.index}] = `);
    $4b1afda415637ecc$var$genNode(node.value, context);
    if (needPauseTracking) {
        push(`).cacheIndex = ${node.index},`);
        newline();
        push(`${helper($4b1afda415637ecc$export$37cf1f9ab937c10d)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
    if (needArraySpread) push(`)]`);
}
const $4b1afda415637ecc$var$prohibitedKeywordRE = new RegExp("\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b");
const $4b1afda415637ecc$var$stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
function $4b1afda415637ecc$var$validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace($4b1afda415637ecc$var$stripStringRE, "").match($4b1afda415637ecc$var$prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(46, node.loc, void 0, message));
    }
}
const $4b1afda415637ecc$export$7e9f01d2df839553 = (node, context)=>{
    if (node.type === 5) node.content = $4b1afda415637ecc$export$997045dce990ec35(node.content, context);
    else if (node.type === 1) {
        const memo = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "memo");
        for(let i = 0; i < node.props.length; i++){
            const dir = node.props[i];
            if (dir.type === 7 && dir.name !== "for") {
                const exp = dir.exp;
                const arg = dir.arg;
                if (exp && exp.type === 4 && !(dir.name === "on" && arg) && // key has been processed in transformFor(vMemo + vFor)
                !(memo && context.vForMemoKeyedNodes.has(node) && arg && arg.type === 4 && arg.content === "key")) dir.exp = $4b1afda415637ecc$export$997045dce990ec35(exp, context, // slot args must be processed as function params
                dir.name === "slot");
                if (arg && arg.type === 4 && !arg.isStatic) dir.arg = $4b1afda415637ecc$export$997045dce990ec35(arg, context);
            }
        }
    }
};
function $4b1afda415637ecc$export$997045dce990ec35(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
function $4b1afda415637ecc$export$123a9f8105e820ce(exp) {
    if ((0, $8POXm.isString)(exp)) return exp;
    else if (exp.type === 4) return exp.content;
    else return exp.children.map($4b1afda415637ecc$export$123a9f8105e820ce).join("");
}
const $4b1afda415637ecc$var$transformIf = $4b1afda415637ecc$export$aee0887cf96094d7(/^(?:if|else|else-if)$/, (node, dir, context)=>{
    return $4b1afda415637ecc$export$a01e2bc7b2f1a6e5(node, dir, context, (ifNode, branch, isRoot)=>{
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9) key += sibling.branches.length;
        }
        return ()=>{
            if (isRoot) ifNode.codegenNode = $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, key, context);
            else {
                const parentCondition = $4b1afda415637ecc$var$getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
function $4b1afda415637ecc$export$a01e2bc7b2f1a6e5(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(28, dir.loc));
        dir.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(`true`, false, loc);
    }
    if (dir.name === "if") {
        const branch = $4b1afda415637ecc$var$createIfBranch(node, dir);
        const ifNode = {
            type: 9,
            loc: $4b1afda415637ecc$var$cloneLoc(node.loc),
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && $4b1afda415637ecc$export$6d8f8b0d7fdfb5b0(sibling)) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9) {
                if ((dir.name === "else-if" || dir.name === "else") && sibling.branches[sibling.branches.length - 1].condition === void 0) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30, node.loc));
                context.removeNode();
                const branch = $4b1afda415637ecc$var$createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                $4b1afda415637ecc$export$c9d429747c1011af(branch, context);
                if (onExit) onExit();
                context.currentNode = null;
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30, node.loc));
            break;
        }
    }
}
function $4b1afda415637ecc$var$createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
        type: 10,
        loc: node.loc,
        condition: dir.name === "else" ? void 0 : dir.exp,
        children: isTemplateIf && !$4b1afda415637ecc$export$1199bc2a2b648c8c(node, "for") ? node.children : [
            node
        ],
        userKey: $4b1afda415637ecc$export$4ae65475e3513615(node, `key`),
        isTemplateIf: isTemplateIf
    };
}
function $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return $4b1afda415637ecc$export$374e02fb5bd90a4e(branch.condition, $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$b2aae42fb0a19db3), [
        '""',
        "true"
    ]));
    else return $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context);
}
function $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper: helper } = context;
    const keyProperty = $4b1afda415637ecc$export$45231d90c148ea74(`key`, $4b1afda415637ecc$export$ac2aa689b44cdd23(`${keyIndex}`, false, $4b1afda415637ecc$export$6c4f24c93c3e8659, 2));
    const { children: children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11) {
            const vnodeCall = firstChild.codegenNode;
            $4b1afda415637ecc$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64;
            return $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), $4b1afda415637ecc$export$ccb2e514379853a7([
                keyProperty
            ]), children, patchFlag, void 0, void 0, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = $4b1afda415637ecc$export$39e241985cd3e673(ret);
        if (vnodeCall.type === 13) $4b1afda415637ecc$export$dc00c05f515bd739(vnodeCall, context);
        $4b1afda415637ecc$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
        return ret;
    }
}
function $4b1afda415637ecc$var$isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6) {
        if (a.value.content !== b.value.content) return false;
    } else {
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function $4b1afda415637ecc$var$getParentCondition(node) {
    while(true){
        if (node.type === 19) {
            if (node.alternate.type === 19) node = node.alternate;
            else return node;
        } else if (node.type === 20) node = node.value;
    }
}
const $4b1afda415637ecc$var$transformFor = $4b1afda415637ecc$export$aee0887cf96094d7("for", (node, dir, context)=>{
    const { helper: helper, removeHelper: removeHelper } = context;
    return $4b1afda415637ecc$export$bb06c920f370c8cb(node, dir, context, (forNode)=>{
        const renderExp = $4b1afda415637ecc$export$2cdf8617f9d8e39d(helper($4b1afda415637ecc$export$3da0e5cd78c1870), [
            forNode.source
        ]);
        const isTemplate = $4b1afda415637ecc$export$f125a8a2b402ed89(node);
        const memo = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "memo");
        const keyProp = $4b1afda415637ecc$export$4ae65475e3513615(node, `key`, false, true);
        keyProp && keyProp.type;
        let keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? $4b1afda415637ecc$export$ac2aa689b44cdd23(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyExp ? $4b1afda415637ecc$export$45231d90c148ea74(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), void 0, renderExp, fragmentFlag, void 0, void 0, true, !isStableFragment, false, node.loc);
        return ()=>{
            var _a;
            let childBlock;
            const { children: children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
            const slotOutlet = $4b1afda415637ecc$export$45f38ad7fffc9b53(node) ? node : isTemplate && node.children.length === 1 && $4b1afda415637ecc$export$45f38ad7fffc9b53(node.children[0]) ? node.children[0] : null;
            if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) $4b1afda415637ecc$export$ec34add3fb2185f8(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) childBlock = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), keyProperty ? $4b1afda415637ecc$export$ccb2e514379853a7([
                keyProperty
            ]) : void 0, node.children, 64, void 0, void 0, true, void 0, false);
            else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) $4b1afda415637ecc$export$ec34add3fb2185f8(childBlock, keyProperty, context);
                const shouldUseBlock = !isStableFragment || childBlock.isBlockRequired === true;
                if (childBlock.isBlock !== shouldUseBlock) {
                    if (childBlock.isBlock) {
                        removeHelper($4b1afda415637ecc$export$59578e14f90a15eb);
                        removeHelper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                    } else removeHelper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = shouldUseBlock;
                if (childBlock.isBlock) {
                    helper($4b1afda415637ecc$export$59578e14f90a15eb);
                    helper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                } else {
                    helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
                    if (childBlock.needsPatch) childBlock.patchFlag = ((_a = childBlock.patchFlag) != null ? _a : 0) | 512;
                }
            }
            if (memo) {
                const loop = $4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(forNode.parseResult, [
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`_cached`)
                ]));
                loop.body = $4b1afda415637ecc$export$c3ad9e28586f1d07([
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `if (_cached && _cached.el`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString($4b1afda415637ecc$export$ae18cf0dc81df35a)}(_cached, _memo)) return _cached`
                    ]),
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `const _item = `,
                        childBlock
                    ]),
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`_item.memo = _memo`),
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`return _item`)
                ]);
                renderExp.arguments.push(loop, $4b1afda415637ecc$export$ac2aa689b44cdd23(`_cache`), $4b1afda415637ecc$export$ac2aa689b44cdd23(String(context.cached.length)));
                context.cached.push(null);
            } else renderExp.arguments.push($4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(forNode.parseResult), childBlock, true));
        };
    });
});
function $4b1afda415637ecc$export$bb06c920f370c8cb(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(31, dir.loc));
        return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(32, dir.loc));
        return;
    }
    $4b1afda415637ecc$var$finalizeForParseResult(parseResult, context);
    const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers, scopes: scopes } = context;
    const { source: source, value: value, key: key, index: index } = parseResult;
    const forNode = {
        type: 11,
        loc: dir.loc,
        source: source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult: parseResult,
        children: $4b1afda415637ecc$export$f125a8a2b402ed89(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
function $4b1afda415637ecc$var$finalizeForParseResult(result, context) {
    if (result.finalized) return;
    result.finalized = true;
}
function $4b1afda415637ecc$export$5796ae82f3e98f88({ value: value, key: key, index: index }, memoArgs = []) {
    return $4b1afda415637ecc$var$createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function $4b1afda415637ecc$var$createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2)=>arg || $4b1afda415637ecc$export$ac2aa689b44cdd23(`_`.repeat(i2 + 1), false));
}
const $4b1afda415637ecc$var$defaultFallback = $4b1afda415637ecc$export$ac2aa689b44cdd23(`undefined`, false);
const $4b1afda415637ecc$export$f0a2c7894e526c50 = (node, context)=>{
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
        const vSlot = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "slot");
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
const $4b1afda415637ecc$export$38b9212074cad7c2 = (node, context)=>{
    let vFor;
    if ($4b1afda415637ecc$export$f125a8a2b402ed89(node) && node.props.some($4b1afda415637ecc$export$eaf8991bb8af8cbb) && (vFor = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "for"))) {
        const result = vFor.forParseResult;
        if (result) {
            $4b1afda415637ecc$var$finalizeForParseResult(result, context);
            const { value: value, key: key, index: index } = result;
            const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const $4b1afda415637ecc$var$buildClientSlotFn = (props, _vForExp, children, loc)=>$4b1afda415637ecc$export$253e05bfd5b6c4c6(props, children, false, true, children.length ? children[0].loc : loc);
function $4b1afda415637ecc$export$8083554712300565(node, context, buildSlotFn = $4b1afda415637ecc$var$buildClientSlotFn) {
    context.helper($4b1afda415637ecc$export$141e17a2b5200090);
    const { children: children, loc: loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "slot", true);
    if (onComponentSlot) {
        const { arg: arg, exp: exp } = onComponentSlot;
        if (arg && !$4b1afda415637ecc$export$43d387e2d68b51dc(arg)) hasDynamicSlots = true;
        slotsProperties.push($4b1afda415637ecc$export$45231d90c148ea74(arg || $4b1afda415637ecc$export$ac2aa689b44cdd23("default", true), buildSlotFn(exp, void 0, children, loc)));
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!$4b1afda415637ecc$export$f125a8a2b402ed89(slotElement) || !(slotDir = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, "slot", true))) {
            if (slotElement.type !== 3) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(37, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = $4b1afda415637ecc$export$ac2aa689b44cdd23(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        let staticSlotName;
        if ($4b1afda415637ecc$export$43d387e2d68b51dc(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const vFor = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, "for");
        const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
        let vIf;
        let vElse;
        if (vIf = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, "if")) {
            hasDynamicSlots = true;
            dynamicSlots.push($4b1afda415637ecc$export$374e02fb5bd90a4e(vIf.exp, $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $4b1afda415637ecc$var$defaultFallback));
        } else if (vElse = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, /^else(?:-if)?$/, true)) {
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (!$4b1afda415637ecc$export$6d8f8b0d7fdfb5b0(prev)) break;
            }
            if (prev && $4b1afda415637ecc$export$f125a8a2b402ed89(prev) && $4b1afda415637ecc$export$1199bc2a2b648c8c(prev, /^(?:else-)?if$/)) {
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19)conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? $4b1afda415637ecc$export$374e02fb5bd90a4e(vElse.exp, $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $4b1afda415637ecc$var$defaultFallback) : $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30, vElse.loc));
        } else if (vFor) {
            hasDynamicSlots = true;
            const parseResult = vFor.forParseResult;
            if (parseResult) {
                $4b1afda415637ecc$var$finalizeForParseResult(parseResult, context);
                dynamicSlots.push($4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$3da0e5cd78c1870), [
                    parseResult.source,
                    $4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(parseResult), $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction), true)
                ]));
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(32, vFor.loc));
        } else {
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(38, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === "default") hasNamedDefaultSlot = true;
            }
            slotsProperties.push($4b1afda415637ecc$export$45231d90c148ea74(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children2)=>{
            const fn = buildSlotFn(props, void 0, children2, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return $4b1afda415637ecc$export$45231d90c148ea74(`default`, fn);
        };
        if (!hasTemplateSlots) slotsProperties.push(buildDefaultSlotProperty(void 0, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        !implicitDefaultChildren.every($4b1afda415637ecc$export$e27743005f03840)) {
            if (hasNamedDefaultSlot) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(39, implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(void 0, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 : $4b1afda415637ecc$var$hasForwardedSlots(node.children) ? 3 : 1;
    let slots = $4b1afda415637ecc$export$ccb2e514379853a7(slotsProperties.concat($4b1afda415637ecc$export$45231d90c148ea74(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    $4b1afda415637ecc$export$ac2aa689b44cdd23(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$6a6b6a5c860c238d), [
        slots,
        $4b1afda415637ecc$export$c887713da9895dbb(dynamicSlots)
    ]);
    return {
        slots: slots,
        hasDynamicSlots: hasDynamicSlots
    };
}
function $4b1afda415637ecc$var$buildDynamicSlot(name, fn, index) {
    const props = [
        $4b1afda415637ecc$export$45231d90c148ea74(`name`, name),
        $4b1afda415637ecc$export$45231d90c148ea74(`fn`, fn)
    ];
    if (index != null) props.push($4b1afda415637ecc$export$45231d90c148ea74(`key`, $4b1afda415637ecc$export$ac2aa689b44cdd23(String(index), true)));
    return $4b1afda415637ecc$export$ccb2e514379853a7(props);
}
function $4b1afda415637ecc$var$hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1:
                if (child.tagType === 2 || $4b1afda415637ecc$var$hasForwardedSlots(child.children)) return true;
                break;
            case 9:
                if ($4b1afda415637ecc$var$hasForwardedSlots(child.branches)) return true;
                break;
            case 10:
            case 11:
                if ($4b1afda415637ecc$var$hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
const $4b1afda415637ecc$var$directiveImportMap = /* @__PURE__ */ new WeakMap();
const $4b1afda415637ecc$export$5d90dc62c1c9e431 = (node, context)=>{
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) return;
        const { tag: tag, props: props } = node;
        const isComponent = node.tagType === 1;
        let vnodeTag = isComponent ? $4b1afda415637ecc$export$9871d2aaf4643d1d(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, $8POXm.isObject)(vnodeTag) && vnodeTag.callee === $4b1afda415637ecc$export$582a2287b73d3265;
        let vnodeProps;
        let vnodeChildren;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let needsPatch = false;
        let isBlockRequired = false;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === $4b1afda415637ecc$export$e74e82bc14ac4f98 || vnodeTag === $4b1afda415637ecc$export$2237d737f4a10705 || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math");
        if (props.length > 0) {
            const propsBuildResult = $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, void 0, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            needsPatch = propsBuildResult.needsPatch;
            isBlockRequired = propsBuildResult.isBlockRequired;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? $4b1afda415637ecc$export$c887713da9895dbb(directives.map((dir)=>$4b1afda415637ecc$export$6ff1db2f107c16cd(dir, context))) : void 0;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        if (node.children.length > 0) {
            if (vnodeTag === $4b1afda415637ecc$export$e9ff5bb5c39478ed) {
                shouldUseBlock = true;
                patchFlag |= 1024;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== $4b1afda415637ecc$export$e74e82bc14ac4f98 && // explained above.
            vnodeTag !== $4b1afda415637ecc$export$e9ff5bb5c39478ed;
            if (shouldBuildAsSlots) {
                const { slots: slots, hasDynamicSlots: hasDynamicSlots } = $4b1afda415637ecc$export$8083554712300565(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024;
            } else if (node.children.length === 1 && vnodeTag !== $4b1afda415637ecc$export$e74e82bc14ac4f98) {
                const child = node.children[0];
                const type = child.type;
                const hasDynamicTextChild = type === 5 || type === 8;
                if (hasDynamicTextChild && $4b1afda415637ecc$export$7967f5197c38d72a(child, context) === 0) patchFlag |= 1;
                if (hasDynamicTextChild || type === 2) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = $4b1afda415637ecc$var$stringifyDynamicPropNames(dynamicPropNames);
        const vnodeCall = node.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, vnodeTag, vnodeProps, vnodeChildren, patchFlag === 0 ? void 0 : patchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
        needsPatch = needsPatch && (patchFlag === 0 || patchFlag === 32);
        if (needsPatch) vnodeCall.needsPatch = true;
        if (isBlockRequired) vnodeCall.isBlockRequired = true;
    };
};
function $4b1afda415637ecc$export$9871d2aaf4643d1d(node, context, ssr = false) {
    let { tag: tag } = node;
    const isExplicitDynamic = $4b1afda415637ecc$var$isComponentTag(tag);
    const isProp = $4b1afda415637ecc$export$4ae65475e3513615(node, "is", false, true);
    if (isProp) {
        if (isExplicitDynamic || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context)) {
            let exp;
            if (isProp.type === 6) exp = isProp.value && $4b1afda415637ecc$export$ac2aa689b44cdd23(isProp.value.content, true);
            else {
                exp = isProp.exp;
                if (!exp) exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(`is`, false, isProp.arg.loc);
            }
            if (exp) return $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$582a2287b73d3265), [
                exp
            ]);
        } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) tag = isProp.value.content.slice(4);
    }
    const builtIn = $4b1afda415637ecc$export$69768c9b514a01e9(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    context.helper($4b1afda415637ecc$export$28c52e95383d270);
    context.components.add(tag);
    return $4b1afda415637ecc$export$80505c1072df544f(tag, `component`);
}
function $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag: tag, loc: elementLoc, children: children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let isBlockRequired = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg)=>{
        if (properties.length) {
            mergeArgs.push($4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc));
            properties = [];
        }
        if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = ()=>{
        if (context.scopes.vFor > 0) properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23("ref_for", true), $4b1afda415637ecc$export$ac2aa689b44cdd23("true")));
    };
    const analyzePatchFlag = ({ key: key, value: value })=>{
        if ($4b1afda415637ecc$export$43d387e2d68b51dc(key)) {
            const name = key.content;
            const isEventHandler = (0, $8POXm.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== "onclick" && // omit v-model handlers
            name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
            !(0, $8POXm.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, $8POXm.isReservedProp)(name)) hasVnodeHook = true;
            if (name === "ref") hasRef = true;
            if (isEventHandler && value.type === 14) value = value.arguments[0];
            if (value.type === 20 || (value.type === 4 || value.type === 8) && $4b1afda415637ecc$export$7967f5197c38d72a(value, context) > 0) return;
            if (name === "class") hasClassBinding = true;
            else if (name === "style") hasStyleBinding = true;
            else if (name !== "ref" && name !== "key" && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            if (isComponent && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (prop.type === 6) {
            const { loc: loc, name: name, nameLoc: nameLoc, value: value } = prop;
            let isStatic = true;
            if (name === "ref") {
                hasRef = true;
                pushRefVForMarker();
            }
            if (name === "is" && ($4b1afda415637ecc$var$isComponentTag(tag) || value && value.content.startsWith("vue:") || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23(name, true, nameLoc), $4b1afda415637ecc$export$ac2aa689b44cdd23(value ? value.content : "", isStatic, value ? value.loc : loc)));
        } else {
            const { name: name, arg: arg, exp: exp, loc: loc, modifiers: modifiers } = prop;
            const isVBind = name === "bind";
            const isVOn = name === "on";
            if (name === "slot") {
                if (!isComponent) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(40, loc));
                continue;
            }
            if (name === "once" || name === "memo") continue;
            if (name === "is" || isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "is") && ($4b1afda415637ecc$var$isComponentTag(tag) || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            if (isVOn && ssr) continue;
            if (isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "key")) shouldUseBlock = true;
            if (isVOn && hasChildren && arg && $4b1afda415637ecc$export$43d387e2d68b51dc(arg) && (0, $8POXm.camelize)(arg.content) === "vue:beforeUpdate") {
                shouldUseBlock = true;
                isBlockRequired = true;
            }
            if (isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "ref")) pushRefVForMarker();
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (isVBind) {
                        pushMergeArg();
                        if ($4b1afda415637ecc$var$isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER", context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        pushRefVForMarker();
                        pushMergeArg();
                        mergeArgs.push(exp);
                    } else pushMergeArg({
                        type: 14,
                        loc: loc,
                        callee: context.helper($4b1afda415637ecc$export$4bdbf33367525856),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(isVBind ? 34 : 35, loc));
                continue;
            }
            if (isVBind && modifiers.some((mod)=>mod.content === "prop")) patchFlag |= 32;
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                const { props: props2, needRuntime: needRuntime } = directiveTransform(prop, node, context);
                !ssr && props2.forEach(analyzePatchFlag);
                if (isVOn && arg && !$4b1afda415637ecc$export$43d387e2d68b51dc(arg)) pushMergeArg($4b1afda415637ecc$export$ccb2e514379853a7(props2, elementLoc));
                else properties.push(...props2);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, $8POXm.isSymbol)(needRuntime)) $4b1afda415637ecc$var$directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, $8POXm.isBuiltInDirective)(name)) {
                runtimeDirectives.push(prop);
                if (hasChildren) {
                    shouldUseBlock = true;
                    isBlockRequired = true;
                }
            }
        }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
        pushMergeArg();
        if (mergeArgs.length > 1) propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), mergeArgs, elementLoc);
        else propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = $4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc);
    if (hasDynamicKeys) patchFlag |= 16;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2;
        if (hasStyleBinding && !isComponent) patchFlag |= 4;
        if (dynamicPropNames.length) patchFlag |= 8;
        if (hasHydrationEventBinding) patchFlag |= 32;
    }
    const needsPatch = (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0);
    if (!shouldUseBlock && needsPatch) patchFlag |= 512;
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15:
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if ($4b1afda415637ecc$export$43d387e2d68b51dc(key)) {
                    if (key.content === "class") classKeyIndex = i;
                    else if (key.content === "style") styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            if (!hasDynamicKey) {
                if (classProp && !$4b1afda415637ecc$export$43d387e2d68b51dc(classProp.value)) classProp.value = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$6382e3ed89de4e2a), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17)) styleProp.value = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$b9d3780a9ab822b4), [
                    styleProp.value
                ]);
            } else propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$78c34c869683dd86), [
                propsExpression
            ]);
            break;
        case 14:
            break;
        default:
            propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$78c34c869683dd86), [
                $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$7046bb8d3c918928), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag: patchFlag,
        dynamicPropNames: dynamicPropNames,
        shouldUseBlock: shouldUseBlock,
        needsPatch: needsPatch,
        isBlockRequired: isBlockRequired
    };
}
function $4b1afda415637ecc$var$dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        if (prop.key.type === 8 || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === "style" || name === "class" || (0, $8POXm.isOn)(name)) $4b1afda415637ecc$var$mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function $4b1afda415637ecc$var$mergeAsArray(existing, incoming) {
    if (existing.value.type === 17) existing.value.elements.push(incoming.value);
    else existing.value = $4b1afda415637ecc$export$c887713da9895dbb([
        existing.value,
        incoming.value
    ], existing.loc);
}
function $4b1afda415637ecc$export$6ff1db2f107c16cd(dir, context) {
    const dirArgs = [];
    const runtime = $4b1afda415637ecc$var$directiveImportMap.get(dir);
    if (runtime) dirArgs.push(context.helperString(runtime));
    else {
        context.helper($4b1afda415637ecc$export$7f3ccc2ef793ecce);
        context.directives.add(dir.name);
        dirArgs.push($4b1afda415637ecc$export$80505c1072df544f(dir.name, `directive`));
    }
    const { loc: loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = $4b1afda415637ecc$export$ac2aa689b44cdd23(`true`, false, loc);
        dirArgs.push($4b1afda415637ecc$export$ccb2e514379853a7(dir.modifiers.map((modifier)=>$4b1afda415637ecc$export$45231d90c148ea74(modifier, trueExpression)), loc));
    }
    return $4b1afda415637ecc$export$c887713da9895dbb(dirArgs, dir.loc);
}
function $4b1afda415637ecc$var$stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
}
function $4b1afda415637ecc$var$isComponentTag(tag) {
    return tag === "component" || tag === "Component";
}
const $4b1afda415637ecc$var$transformSlotOutlet = (node, context)=>{
    if ($4b1afda415637ecc$export$45f38ad7fffc9b53(node)) {
        const { children: children, loc: loc } = node;
        const { slotName: slotName, slotProps: slotProps } = $4b1afda415637ecc$export$cab34cff437fc757(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = $4b1afda415637ecc$export$253e05bfd5b6c4c6([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen);
        node.codegenNode = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$a91e32c6b04aa348), slotArgs, loc);
    }
};
function $4b1afda415637ecc$export$cab34cff437fc757(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (p.value) {
                if (p.name === "name") slotName = JSON.stringify(p.value.content);
                else {
                    p.name = (0, $8POXm.camelize)(p.name);
                    nonNameProps.push(p);
                }
            }
        } else if (p.name === "bind" && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, "name")) {
            if (p.exp) slotName = p.exp;
            else if (p.arg && p.arg.type === 4) {
                const name = (0, $8POXm.camelize)(p.arg.content);
                slotName = p.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(name, false, p.arg.loc);
            }
        } else {
            if (p.name === "bind" && p.arg && $4b1afda415637ecc$export$43d387e2d68b51dc(p.arg)) p.arg.content = (0, $8POXm.camelize)(p.arg.content);
            nonNameProps.push(p);
        }
    }
    if (nonNameProps.length > 0) {
        const { props: props, directives: directives } = $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(36, directives[0].loc));
    }
    return {
        slotName: slotName,
        slotProps: slotProps
    };
}
const $4b1afda415637ecc$export$ff060d152244ee7b = (dir, node, context, augmentor)=>{
    const { loc: loc, modifiers: modifiers, arg: arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(35, loc));
    let eventName;
    if (arg.type === 4) {
        if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vue:")) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? // for non-element and vnode lifecycle event listeners, auto convert
            // it to camelCase. See issue #2249
            (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(rawName)) : // preserve case for plain element listeners that have uppercase
            // letters, as these may be custom elements' custom events
            `on:${rawName}`;
            eventName = $4b1afda415637ecc$export$ac2aa689b44cdd23(eventString, true, arg.loc);
        } else eventName = $4b1afda415637ecc$export$60ad01cd5cde5e50([
            `${context.helperString($4b1afda415637ecc$export$8687eaac3cd39ddd)}(`,
            arg,
            `)`
        ]);
    } else {
        eventName = arg;
        eventName.children.unshift(`${context.helperString($4b1afda415637ecc$export$8687eaac3cd39ddd)}(`);
        eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = void 0;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = $4b1afda415637ecc$export$9c8bdf9fab617ce4(exp);
        const isInlineStatement = !(isMemberExp || $4b1afda415637ecc$export$482164e6e5517986(exp));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) exp = $4b1afda415637ecc$export$60ad01cd5cde5e50([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            $4b1afda415637ecc$export$45231d90c148ea74(eventName, exp || $4b1afda415637ecc$export$ac2aa689b44cdd23(`() => {}`, false, loc))
        ]
    };
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) ret.props[0].value = context.cache(ret.props[0].value);
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
const $4b1afda415637ecc$export$2fa367e7c04d4515 = (dir, _node, context)=>{
    const { modifiers: modifiers, loc: loc } = dir;
    const arg = dir.arg;
    let { exp: exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) exp = void 0;
    if (arg.type !== 4) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = arg.content ? `${arg.content} || ""` : `""`;
    if (modifiers.some((mod)=>mod.content === "camel")) {
        if (arg.type === 4) {
            if (arg.isStatic) arg.content = (0, $8POXm.camelize)(arg.content);
            else arg.content = `${context.helperString($4b1afda415637ecc$export$3ebbf6981763e181)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString($4b1afda415637ecc$export$3ebbf6981763e181)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.some((mod)=>mod.content === "prop")) $4b1afda415637ecc$var$injectPrefix(arg, ".");
        if (modifiers.some((mod)=>mod.content === "attr")) $4b1afda415637ecc$var$injectPrefix(arg, "^");
    }
    return {
        props: [
            $4b1afda415637ecc$export$45231d90c148ea74(arg, exp)
        ]
    };
};
const $4b1afda415637ecc$var$injectPrefix = (arg, prefix)=>{
    if (arg.type === 4) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
const $4b1afda415637ecc$var$transformText = (node, context)=>{
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) return ()=>{
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($4b1afda415637ecc$export$1879817ac5c922b7(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if ($4b1afda415637ecc$export$1879817ac5c922b7(next)) {
                        if (!currentContainer) currentContainer = children[i] = $4b1afda415637ecc$export$60ad01cd5cde5e50([
                            child
                        ], child.loc);
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = void 0;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) return;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($4b1afda415637ecc$export$1879817ac5c922b7(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") callArgs.push(child);
                if (!context.ssr && $4b1afda415637ecc$export$7967f5197c38d72a(child, context) === 0) callArgs.push(1 + ``);
                children[i] = {
                    type: 12,
                    content: child,
                    loc: child.loc,
                    codegenNode: $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$8890896270dfc293), callArgs)
                };
            }
        }
    };
};
const $4b1afda415637ecc$var$seen$1 = /* @__PURE__ */ new WeakSet();
const $4b1afda415637ecc$var$transformOnce = (node, context)=>{
    if (node.type === 1 && $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "once", true)) {
        if ($4b1afda415637ecc$var$seen$1.has(node) || context.inVOnce || context.inSSR) return;
        $4b1afda415637ecc$var$seen$1.add(node);
        context.inVOnce = true;
        context.helper($4b1afda415637ecc$export$37cf1f9ab937c10d);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true, true);
        };
    }
};
const $4b1afda415637ecc$export$567db1f69abf4dcb = (dir, node, context)=>{
    const { exp: exp, arg: arg } = dir;
    if (!exp) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(41, dir.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    const rawExp = exp.loc.source.trim();
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(44, exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    if (bindingType === "literal-const" || bindingType === "setup-const") {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(45, exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    if (!expString.trim() || !$4b1afda415637ecc$export$9c8bdf9fab617ce4(exp) && true) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(42, exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    const propName = arg ? arg : $4b1afda415637ecc$export$ac2aa689b44cdd23("modelValue", true);
    const eventName = arg ? $4b1afda415637ecc$export$43d387e2d68b51dc(arg) ? `onUpdate:${(0, $8POXm.camelize)(arg.content)}` : $4b1afda415637ecc$export$60ad01cd5cde5e50([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = $4b1afda415637ecc$export$60ad01cd5cde5e50([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        $4b1afda415637ecc$export$45231d90c148ea74(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        $4b1afda415637ecc$export$45231d90c148ea74(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
        const modifiers = dir.modifiers.map((m)=>m.content).map((m)=>($4b1afda415637ecc$export$3cb8486ad206c65(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? $4b1afda415637ecc$export$43d387e2d68b51dc(arg) ? `${arg.content}Modifiers` : $4b1afda415637ecc$export$60ad01cd5cde5e50([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push($4b1afda415637ecc$export$45231d90c148ea74(modifiersKey, $4b1afda415637ecc$export$ac2aa689b44cdd23(`{ ${modifiers} }`, false, dir.loc, 2)));
    }
    return $4b1afda415637ecc$var$createTransformProps(props);
};
function $4b1afda415637ecc$var$createTransformProps(props = []) {
    return {
        props: props
    };
}
const $4b1afda415637ecc$var$validDivisionCharRE = /[\w).+\-_$\]]/;
const $4b1afda415637ecc$var$transformFilter = (node, context)=>{
    if (!$4b1afda415637ecc$var$isCompatEnabled("COMPILER_FILTERS", context)) return;
    if (node.type === 5) $4b1afda415637ecc$var$rewriteFilter(node.content, context);
    else if (node.type === 1) node.props.forEach((prop)=>{
        if (prop.type === 7 && prop.name !== "for" && prop.exp) $4b1afda415637ecc$var$rewriteFilter(prop.exp, context);
    });
};
function $4b1afda415637ecc$var$rewriteFilter(node, context) {
    if (node.type === 4) $4b1afda415637ecc$var$parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) $4b1afda415637ecc$var$parseFilter(child, context);
        else if (child.type === 8) $4b1afda415637ecc$var$rewriteFilter(child, context);
        else if (child.type === 5) $4b1afda415637ecc$var$rewriteFilter(child.content, context);
    }
}
function $4b1afda415637ecc$var$parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 39 && prev !== 92) inSingle = false;
        } else if (inDouble) {
            if (c === 34 && prev !== 92) inDouble = false;
        } else if (inTemplateString) {
            if (c === 96 && prev !== 92) inTemplateString = false;
        } else if (inRegex) {
            if (c === 47 && prev !== 92) inRegex = false;
        } else if (c === 124 && // pipe
        exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
            if (expression === void 0) {
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 34:
                    inDouble = true;
                    break;
                // "
                case 39:
                    inSingle = true;
                    break;
                // '
                case 96:
                    inTemplateString = true;
                    break;
                // `
                case 40:
                    paren++;
                    break;
                // (
                case 41:
                    paren--;
                    break;
                // )
                case 91:
                    square++;
                    break;
                // [
                case 93:
                    square--;
                    break;
                // ]
                case 123:
                    curly++;
                    break;
                // {
                case 125:
                    curly--;
                    break;
            }
            if (c === 47) {
                let j = i - 1;
                let p;
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== " ") break;
                }
                if (!p || !$4b1afda415637ecc$var$validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === void 0) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = $4b1afda415637ecc$var$wrapFilter(expression, filters[i], context);
        node.content = expression;
        node.ast = void 0;
    }
}
function $4b1afda415637ecc$var$wrapFilter(exp, filter, context) {
    context.helper($4b1afda415637ecc$export$2c190751e09c3969);
    const i = filter.indexOf("(");
    if (i < 0) {
        context.filters.add(filter);
        return `${$4b1afda415637ecc$export$80505c1072df544f(filter, "filter")}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${$4b1afda415637ecc$export$80505c1072df544f(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
}
const $4b1afda415637ecc$var$seen = /* @__PURE__ */ new WeakSet();
const $4b1afda415637ecc$var$transformMemo = (node, context)=>{
    if (node.type === 1) {
        const dir = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "memo");
        if (!dir || $4b1afda415637ecc$var$seen.has(node) || context.inSSR) return;
        $4b1afda415637ecc$var$seen.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
                if (node.tagType !== 1) $4b1afda415637ecc$export$dc00c05f515bd739(codegenNode, context);
                node.codegenNode = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$a0fd71f0f7cd2781), [
                    dir.exp,
                    $4b1afda415637ecc$export$253e05bfd5b6c4c6(void 0, codegenNode),
                    `_cache`,
                    String(context.cached.length)
                ]);
                context.cached.push(null);
            }
        };
    }
};
const $4b1afda415637ecc$export$4df7de08397f97e2 = (node, context)=>{
    if (node.type === 1) {
        for (const prop of node.props)if (prop.type === 7 && prop.name === "bind" && (!prop.exp || // #13930 :foo in in-DOM templates will be parsed into :foo="" by browser
        prop.exp.type === 4 && !prop.exp.content.trim()) && prop.arg) {
            const arg = prop.arg;
            if (arg.type !== 4 || !arg.isStatic) {
                context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(53, arg.loc));
                prop.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23("", true, arg.loc);
            } else {
                const propName = (0, $8POXm.camelize)(arg.content);
                if ($4b1afda415637ecc$export$187a93453b63d7b5.test(propName[0]) || // allow hyphen first char for https://github.com/vuejs/language-tools/pull/3424
                propName[0] === "-") prop.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(propName, false, arg.loc);
            }
        }
    }
};
function $4b1afda415637ecc$export$20c96dae9bab51d8(prefixIdentifiers) {
    return [
        [
            $4b1afda415637ecc$export$4df7de08397f97e2,
            $4b1afda415637ecc$var$transformOnce,
            $4b1afda415637ecc$var$transformIf,
            $4b1afda415637ecc$var$transformMemo,
            $4b1afda415637ecc$var$transformFor,
            $4b1afda415637ecc$var$transformFilter,
            $4b1afda415637ecc$var$transformSlotOutlet,
            $4b1afda415637ecc$export$5d90dc62c1c9e431,
            $4b1afda415637ecc$export$f0a2c7894e526c50,
            $4b1afda415637ecc$var$transformText
        ],
        {
            on: $4b1afda415637ecc$export$ff060d152244ee7b,
            bind: $4b1afda415637ecc$export$2fa367e7c04d4515,
            model: $4b1afda415637ecc$export$567db1f69abf4dcb
        }
    ];
}
function $4b1afda415637ecc$export$3243579822c486a0(source, options = {}) {
    const onError = options.onError || $4b1afda415637ecc$var$defaultOnError;
    const isModuleMode = options.mode === "module";
    if (options.prefixIdentifiers === true) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(48));
    else if (isModuleMode) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(49));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(50));
    if (options.scopeId && !isModuleMode) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(51));
    const resolvedOptions = (0, $8POXm.extend)({}, options, {
        prefixIdentifiers: prefixIdentifiers
    });
    const ast = (0, $8POXm.isString)(source) ? $4b1afda415637ecc$export$f5f219d5f09c81b5(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = $4b1afda415637ecc$export$20c96dae9bab51d8();
    $4b1afda415637ecc$export$51186ad6e864892a(ast, (0, $8POXm.extend)({}, resolvedOptions, {
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $8POXm.extend)({}, directiveTransforms, options.directiveTransforms || {})
    }));
    return $4b1afda415637ecc$export$80d376111cc09ad7(ast, resolvedOptions);
}
const $4b1afda415637ecc$export$54871af2607057e6 = {
    "DATA": "data",
    "PROPS": "props",
    "PROPS_ALIASED": "props-aliased",
    "SETUP_LET": "setup-let",
    "SETUP_CONST": "setup-const",
    "SETUP_REACTIVE_CONST": "setup-reactive-const",
    "SETUP_MAYBE_REF": "setup-maybe-ref",
    "SETUP_REF": "setup-ref",
    "OPTIONS": "options",
    "LITERAL_CONST": "literal-const"
};
const $4b1afda415637ecc$export$eb34aa2b2065da17 = ()=>({
        props: []
    });

});



parcelRegister("euiHy", function(module, exports) {

$parcel$export(module.exports, "ready", () => $a8c25fc1d0fb00ee$export$28ee1007e174a2a6);
$parcel$export(module.exports, "radian", () => $a8c25fc1d0fb00ee$export$e5766a6e1f6dda27);
$parcel$export(module.exports, "feet_to_m", () => $a8c25fc1d0fb00ee$export$115262a41e9e9ff8);
$parcel$export(module.exports, "yard_to_m", () => $a8c25fc1d0fb00ee$export$f8b91c55b9ffc950);
$parcel$export(module.exports, "meter", () => $a8c25fc1d0fb00ee$export$82334bbdfcebb57);
$parcel$export(module.exports, "CALCULATOR_VERSION", () => $a8c25fc1d0fb00ee$export$38a02781ba693e72);
$parcel$export(module.exports, "toScale", () => $a8c25fc1d0fb00ee$export$753928c79d691d2);
$parcel$export(module.exports, "SightSettings", () => $a8c25fc1d0fb00ee$export$a67d7d60341f978a);
$parcel$export(module.exports, "Mark", () => $a8c25fc1d0fb00ee$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "Marks", () => $a8c25fc1d0fb00ee$export$3f7130ac478166a9);
$parcel$export(module.exports, "Calculated", () => $a8c25fc1d0fb00ee$export$61903a0a253465ee);
$parcel$export(module.exports, "cutDists", () => $a8c25fc1d0fb00ee$export$7be63513d1b91454);
$parcel$export(module.exports, "angleToMark", () => $a8c25fc1d0fb00ee$export$49e649b44a1193d7);
$parcel$export(module.exports, "markToAngle", () => $a8c25fc1d0fb00ee$export$5e8872b587dab69c);
$parcel$export(module.exports, "markAtDistance", () => $a8c25fc1d0fb00ee$export$2cf7244cd730383f);
$parcel$export(module.exports, "roundToClick", () => $a8c25fc1d0fb00ee$export$bbd2f4177b79d62e);
$parcel$export(module.exports, "calc", () => $a8c25fc1d0fb00ee$export$42bfa9b2d4dad91a);
$parcel$export(module.exports, "estimateT", () => $a8c25fc1d0fb00ee$export$f26bb896e70025c8);
$parcel$export(module.exports, "estimateImpact", () => $a8c25fc1d0fb00ee$export$7feaa0dacc3f07c0);
$parcel$export(module.exports, "estimateAngle", () => $a8c25fc1d0fb00ee$export$8abb1b8e47892791);
$parcel$export(module.exports, "findImpact", () => $a8c25fc1d0fb00ee$export$808e14dd435d75e5);
$parcel$export(module.exports, "findAngle", () => $a8c25fc1d0fb00ee$export$830f5dd336a44564);
$parcel$export(module.exports, "calcOffset", () => $a8c25fc1d0fb00ee$export$20165527867cbf14);
$parcel$export(module.exports, "findVelocity", () => $a8c25fc1d0fb00ee$export$1fd04931c6a8a28);
$parcel$export(module.exports, "findVelocityAndDrag", () => $a8c25fc1d0fb00ee$export$5d75188dc744af15);
$parcel$export(module.exports, "maxHeight", () => $a8c25fc1d0fb00ee$export$dc0d8bd0b94f8570);
$parcel$export(module.exports, "calculateMark", () => $a8c25fc1d0fb00ee$export$fd77ea95ee0a1c83);
$parcel$export(module.exports, "marksToM", () => $a8c25fc1d0fb00ee$export$b42575bd57030c6f);
$parcel$export(module.exports, "levelMarksTable", () => $a8c25fc1d0fb00ee$export$fbd221a7e2e7f8dc);
$parcel$export(module.exports, "findCutDistance", () => $a8c25fc1d0fb00ee$export$8d956390dd96bda3);
$parcel$export(module.exports, "cutsGrid", () => $a8c25fc1d0fb00ee$export$a223e87a161632e3);
// wasm-bindgen's "web" target: plain sync function exports plus a default
// `init()` that instantiates the wasm binary. `ready` is that
// initialization, started immediately below — every entry point (see the
// various main.js files, scripts/generate_default_setup.mjs) awaits this
// once before doing anything else, so no call site past that point needs to
// know the numeric core is backed by wasm at all. Deliberately not a
// top-level `await` here: Parcel's optimizer (@parcel/optimizer-swc)
// rejects top-level await outright, so the wait has to be an explicit
// promise callers opt into instead.

var $dmymP = parcelRequire("dmymP");
const $a8c25fc1d0fb00ee$export$28ee1007e174a2a6 = (async ()=>{
    await (0, $dmymP.default)();
})();
let $a8c25fc1d0fb00ee$export$e5766a6e1f6dda27 = Math.PI / 180;
let $a8c25fc1d0fb00ee$export$115262a41e9e9ff8 = 0.3048;
let $a8c25fc1d0fb00ee$export$f8b91c55b9ffc950 = 0.9144;
let $a8c25fc1d0fb00ee$export$82334bbdfcebb57 = 1000;
const $a8c25fc1d0fb00ee$export$38a02781ba693e72 = 2;
function $a8c25fc1d0fb00ee$export$753928c79d691d2(unit) {
    if (unit == "m") return 1;
    else if (unit == "yd") return $a8c25fc1d0fb00ee$export$f8b91c55b9ffc950;
    else if (unit == "ft") return $a8c25fc1d0fb00ee$export$115262a41e9e9ff8;
    else throw new Error(`unknown unit ${unit}`);
}
class $a8c25fc1d0fb00ee$export$a67d7d60341f978a {
    eye_to_sight = 1020;
    arrow_to_eye = 110;
    vertical_tpi = 24;
    horizontal_tpi = 32;
    sight_scale = 10;
    clicks_per_turn = 20;
    sight_bar_spacing = 12.7;
    sight_bar_position = 1;
    // Epoch ms of the last edit, or null if these settings have never been
    // touched (a fresh setup's defaults) — fromJson's Object.assign leaves
    // this at its default for older saved data that predates the field.
    updated_at = null;
    toString() {
        return JSON.stringify(this);
    }
    static fromJson(json) {
        const m = new $a8c25fc1d0fb00ee$export$a67d7d60341f978a();
        return Object.assign(m, json);
    }
}
function $a8c25fc1d0fb00ee$var$isNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
class $a8c25fc1d0fb00ee$export$c9d15bcfc6d42044 {
    distance = 30;
    unit = 'm';
    mark = 2.0;
    sight_bar_position = 1;
    // Epoch ms of the last edit to this row, or null if it's never been
    // touched since creation (also null for older saved data that predates
    // this field — nothing to show in that case, not "just now").
    updated_at = null;
    constructor(d, u, m, b, updated_at = null){
        this.distance = d;
        this.unit = u;
        this.mark = m;
        this.sight_bar_position = b;
        this.updated_at = updated_at;
        if (!$a8c25fc1d0fb00ee$var$isNumber(d)) throw new Error(`Invalid mark distance ${d}`);
        if (!$a8c25fc1d0fb00ee$var$isNumber($a8c25fc1d0fb00ee$export$753928c79d691d2(u))) throw new Error(`Invalid mark unit ${u}`);
        if (!$a8c25fc1d0fb00ee$var$isNumber(m)) throw new Error(`Invalid mark mark ${m}`);
        if (!$a8c25fc1d0fb00ee$var$isNumber(b)) throw new Error(`Invalid mark bar position ${b}`);
    }
    inM() {
        return this.distance * $a8c25fc1d0fb00ee$export$753928c79d691d2(this.unit);
    }
    toString() {
        return JSON.stringify(this);
    }
    static fromJson(json) {
        return new $a8c25fc1d0fb00ee$export$c9d15bcfc6d42044(json.distance, json.unit, json.mark, json.sight_bar_position, json.updated_at ?? null);
    }
}
class $a8c25fc1d0fb00ee$export$3f7130ac478166a9 {
    marks = [];
    constructor(marks){
        this.marks = marks;
    }
    static fromJson(json) {
        return new $a8c25fc1d0fb00ee$export$3f7130ac478166a9(json.map((item)=>$a8c25fc1d0fb00ee$export$c9d15bcfc6d42044.fromJson(item)));
    }
}
class $a8c25fc1d0fb00ee$export$61903a0a253465ee {
    v = 0;
    drag = 0;
    offset = 0;
    fit = 1;
    calculator_version = $a8c25fc1d0fb00ee$export$38a02781ba693e72;
    constructor(v = 0, drag = 0, offset = 0, fit = 1, calculator_version = $a8c25fc1d0fb00ee$export$38a02781ba693e72){
        this.v = v;
        this.drag = drag;
        this.offset = offset;
        this.fit = fit;
        this.calculator_version = calculator_version;
    }
    // See CALCULATOR_VERSION's own comment — an exact match is the only thing
    // that means this file's math hasn't changed since this was computed.
    isFresh() {
        return this.calculator_version === $a8c25fc1d0fb00ee$export$38a02781ba693e72;
    }
    toString() {
        return JSON.stringify(this);
    }
    // Persisted (localStorage) and synced (server) under the field names this
    // class predates — calc_v/calc_c/calc_offset/calc_fit — so existing saved
    // setups keep working with no migration. Only the in-memory shape uses
    // the shorter names.
    toJSON() {
        return {
            calc_v: this.v,
            calc_c: this.drag,
            calc_offset: this.offset,
            calc_fit: this.fit,
            calculator_version: this.calculator_version
        };
    }
    static fromJson(json) {
        // calculator_version passed explicitly (not left to the constructor's
        // own default) even when absent — older saved data predating this
        // field must read as version 0 (definitely stale, triggering a
        // recompute), not silently inherit the current version by omission.
        return new $a8c25fc1d0fb00ee$export$61903a0a253465ee(json.calc_v, json.calc_c, json.calc_offset, json.calc_fit, json.calculator_version ?? 0);
    }
}
function $a8c25fc1d0fb00ee$export$7be63513d1b91454(d, cut_angle) {
    return $dmymP.cutDists(d, cut_angle);
}
function $a8c25fc1d0fb00ee$export$49e649b44a1193d7(sight_settings, sight_bar_position, a, d, cut_angle) {
    return $dmymP.angleToMark(sight_settings, sight_bar_position, a, d, cut_angle);
}
function $a8c25fc1d0fb00ee$export$5e8872b587dab69c(sight_settings, sight_bar_position, mark, d, cut_angle, tolerance = 1e-9, maxIter = 100) {
    return $dmymP.markToAngle(sight_settings, sight_bar_position, mark, d, cut_angle, tolerance, maxIter);
}
function $a8c25fc1d0fb00ee$export$2cf7244cd730383f(d, m, sight_settings, sight_bar_position) {
    return $dmymP.markAtDistance(d, m, sight_settings, sight_bar_position);
}
function $a8c25fc1d0fb00ee$export$bbd2f4177b79d62e(sight_settings, num) {
    return $dmymP.roundToClick(sight_settings, num);
}
function $a8c25fc1d0fb00ee$export$42bfa9b2d4dad91a(v, c, a, d, f) {
    const points = $dmymP.calcPath(v, c, a, d);
    for (const p of points){
        if (!f(p)) break;
    }
}
function $a8c25fc1d0fb00ee$export$f26bb896e70025c8(v, a, x) {
    return $dmymP.estimateT(v, a, x);
}
function $a8c25fc1d0fb00ee$export$7feaa0dacc3f07c0(v, c, a, d) {
    return $dmymP.estimateImpact(v, c, a, d);
}
function $a8c25fc1d0fb00ee$export$8abb1b8e47892791(v, c, d, cut_angle) {
    return $dmymP.estimateAngle(v, c, d, cut_angle);
}
function $a8c25fc1d0fb00ee$export$808e14dd435d75e5(v, c, a, d) {
    return $dmymP.findImpact(v, c, a, d);
}
function $a8c25fc1d0fb00ee$export$830f5dd336a44564(v, c, d, cut_angle, a_guess = $dmymP.estimateAngle(v, c, d, cut_angle)) {
    return $dmymP.findAngle(v, c, d, cut_angle, a_guess);
}
function $a8c25fc1d0fb00ee$export$20165527867cbf14(sight_settings, data, v, c) {
    return $dmymP.calcOffset(sight_settings, data, v, c);
}
function $a8c25fc1d0fb00ee$export$1fd04931c6a8a28(sight_settings, data, c, v_min, v_max) {
    const { v: v, drag: drag, offset: offset, fit: fit } = $dmymP.findVelocity(sight_settings, data, c, v_min, v_max);
    return new $a8c25fc1d0fb00ee$export$61903a0a253465ee(v, drag, offset, fit);
}
function $a8c25fc1d0fb00ee$export$5d75188dc744af15(sight_settings, data) {
    const { v: v, drag: drag, offset: offset, fit: fit } = $dmymP.findVelocityAndDrag(sight_settings, data);
    return new $a8c25fc1d0fb00ee$export$61903a0a253465ee(v, drag, offset, fit);
}
function $a8c25fc1d0fb00ee$export$dc0d8bd0b94f8570(v, c, d, cut_angle) {
    return $dmymP.maxHeight(v, c, d, cut_angle);
}
function $a8c25fc1d0fb00ee$export$fd77ea95ee0a1c83(sight_settings, sight_bar_position, calculated, cut_angle, d, a_guess = $dmymP.estimateAngle(calculated.v, calculated.drag, d, cut_angle)) {
    return $dmymP.calculateMark(sight_settings, sight_bar_position, calculated, cut_angle, d, a_guess);
}
function $a8c25fc1d0fb00ee$export$b42575bd57030c6f(marks) {
    var data = [];
    for(let i = 0; i < marks.length; i++)data.push({
        d: marks[i].inM(),
        m: marks[i].mark,
        s: marks[i].sight_bar_position
    });
    return data;
}
function $a8c25fc1d0fb00ee$export$fbd221a7e2e7f8dc(sight_settings, sight_bar_position, calculated) {
    return $dmymP.levelMarksTable(sight_settings, sight_bar_position, calculated);
}
function $a8c25fc1d0fb00ee$export$8d956390dd96bda3(sight_settings, sight_bar_position, calculated, cut_angle, d) {
    return $dmymP.findCutDistance(sight_settings, sight_bar_position, calculated, cut_angle, d);
}
function $a8c25fc1d0fb00ee$export$a223e87a161632e3(sight_settings, sight_bar_position, calculated, distances, angles) {
    return $dmymP.cutsGrid(sight_settings, sight_bar_position, calculated, distances, angles);
}

});
parcelRegister("dmymP", function(module, exports) {

$parcel$export(module.exports, "angleToMark", () => $9ba7fd1132ff41af$export$49e649b44a1193d7);
$parcel$export(module.exports, "calcOffset", () => $9ba7fd1132ff41af$export$20165527867cbf14);
$parcel$export(module.exports, "calcPath", () => $9ba7fd1132ff41af$export$6107164abd5a3a6a);
$parcel$export(module.exports, "calculateMark", () => $9ba7fd1132ff41af$export$fd77ea95ee0a1c83);
$parcel$export(module.exports, "cutDists", () => $9ba7fd1132ff41af$export$7be63513d1b91454);
$parcel$export(module.exports, "cutsGrid", () => $9ba7fd1132ff41af$export$a223e87a161632e3);
$parcel$export(module.exports, "estimateAngle", () => $9ba7fd1132ff41af$export$8abb1b8e47892791);
$parcel$export(module.exports, "estimateImpact", () => $9ba7fd1132ff41af$export$7feaa0dacc3f07c0);
$parcel$export(module.exports, "estimateT", () => $9ba7fd1132ff41af$export$f26bb896e70025c8);
$parcel$export(module.exports, "findAngle", () => $9ba7fd1132ff41af$export$830f5dd336a44564);
$parcel$export(module.exports, "findCutDistance", () => $9ba7fd1132ff41af$export$8d956390dd96bda3);
$parcel$export(module.exports, "findImpact", () => $9ba7fd1132ff41af$export$808e14dd435d75e5);
$parcel$export(module.exports, "findVelocity", () => $9ba7fd1132ff41af$export$1fd04931c6a8a28);
$parcel$export(module.exports, "findVelocityAndDrag", () => $9ba7fd1132ff41af$export$5d75188dc744af15);
$parcel$export(module.exports, "levelMarksTable", () => $9ba7fd1132ff41af$export$fbd221a7e2e7f8dc);
$parcel$export(module.exports, "markAtDistance", () => $9ba7fd1132ff41af$export$2cf7244cd730383f);
$parcel$export(module.exports, "markToAngle", () => $9ba7fd1132ff41af$export$5e8872b587dab69c);
$parcel$export(module.exports, "maxHeight", () => $9ba7fd1132ff41af$export$dc0d8bd0b94f8570);
$parcel$export(module.exports, "roundToClick", () => $9ba7fd1132ff41af$export$bbd2f4177b79d62e);
$parcel$export(module.exports, "default", () => $9ba7fd1132ff41af$export$2e2bcd8739ae039);
/* @ts-self-types="./calc_core.d.ts" */ /**
 * @param {any} settings
 * @param {number} sight_bar_position
 * @param {number} a
 * @param {number} d
 * @param {number} cut_angle
 * @returns {number}
 */ function $9ba7fd1132ff41af$export$49e649b44a1193d7(settings, sight_bar_position, a, d, cut_angle) {
    const ret = $9ba7fd1132ff41af$var$wasm.angleToMark(settings, sight_bar_position, a, d, cut_angle);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$20165527867cbf14(settings, data, v, c) {
    const ret = $9ba7fd1132ff41af$var$wasm.calcOffset(settings, data, v, c);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$6107164abd5a3a6a(v, c, a, d) {
    const ret = $9ba7fd1132ff41af$var$wasm.calcPath(v, c, a, d);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$fd77ea95ee0a1c83(settings, sight_bar_position, calculated, cut_angle, d, a_guess) {
    const ret = $9ba7fd1132ff41af$var$wasm.calculateMark(settings, sight_bar_position, calculated, cut_angle, d, !$9ba7fd1132ff41af$var$isLikeNone(a_guess), $9ba7fd1132ff41af$var$isLikeNone(a_guess) ? 0 : a_guess);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$7be63513d1b91454(d, cut_angle) {
    const ret = $9ba7fd1132ff41af$var$wasm.cutDists(d, cut_angle);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$a223e87a161632e3(settings, sight_bar_position, calculated, distances, angles) {
    const ret = $9ba7fd1132ff41af$var$wasm.cutsGrid(settings, sight_bar_position, calculated, distances, angles);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$8abb1b8e47892791(v, c, d, cut_angle) {
    const ret = $9ba7fd1132ff41af$var$wasm.estimateAngle(v, c, d, cut_angle);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$7feaa0dacc3f07c0(v, c, a, d) {
    const ret = $9ba7fd1132ff41af$var$wasm.estimateImpact(v, c, a, d);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$f26bb896e70025c8(v, a, x) {
    const ret = $9ba7fd1132ff41af$var$wasm.estimateT(v, a, x);
    return ret;
}
function $9ba7fd1132ff41af$export$830f5dd336a44564(v, c, d, cut_angle, a_guess) {
    const ret = $9ba7fd1132ff41af$var$wasm.findAngle(v, c, d, cut_angle, !$9ba7fd1132ff41af$var$isLikeNone(a_guess), $9ba7fd1132ff41af$var$isLikeNone(a_guess) ? 0 : a_guess);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$8d956390dd96bda3(settings, sight_bar_position, calculated, cut_angle, d) {
    const ret = $9ba7fd1132ff41af$var$wasm.findCutDistance(settings, sight_bar_position, calculated, cut_angle, d);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$808e14dd435d75e5(v, c, a, d) {
    const ret = $9ba7fd1132ff41af$var$wasm.findImpact(v, c, a, d);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$1fd04931c6a8a28(settings, data, c, v_min, v_max) {
    const ret = $9ba7fd1132ff41af$var$wasm.findVelocity(settings, data, c, v_min, v_max);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$5d75188dc744af15(settings, data) {
    const ret = $9ba7fd1132ff41af$var$wasm.findVelocityAndDrag(settings, data);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$fbd221a7e2e7f8dc(settings, sight_bar_position, calculated) {
    const ret = $9ba7fd1132ff41af$var$wasm.levelMarksTable(settings, sight_bar_position, calculated);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[0]);
}
function $9ba7fd1132ff41af$export$2cf7244cd730383f(d, m, settings, sight_bar_position) {
    const ret = $9ba7fd1132ff41af$var$wasm.markAtDistance(d, m, settings, sight_bar_position);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$5e8872b587dab69c(settings, sight_bar_position, mark, d, cut_angle, tolerance, max_iter) {
    const ret = $9ba7fd1132ff41af$var$wasm.markToAngle(settings, sight_bar_position, mark, d, cut_angle, !$9ba7fd1132ff41af$var$isLikeNone(tolerance), $9ba7fd1132ff41af$var$isLikeNone(tolerance) ? 0 : tolerance, $9ba7fd1132ff41af$var$isLikeNone(max_iter) ? Number.MAX_SAFE_INTEGER : max_iter >>> 0);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$dc0d8bd0b94f8570(v, c, d, cut_angle) {
    const ret = $9ba7fd1132ff41af$var$wasm.maxHeight(v, c, d, cut_angle);
    if (ret[2]) throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[1]);
    return ret[0];
}
function $9ba7fd1132ff41af$export$bbd2f4177b79d62e(settings, num) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = $9ba7fd1132ff41af$var$wasm.roundToClick(settings, num);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0;
            len1 = 0;
            throw $9ba7fd1132ff41af$var$takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return $9ba7fd1132ff41af$var$getStringFromWasm0(ptr1, len1);
    } finally{
        $9ba7fd1132ff41af$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}
function $9ba7fd1132ff41af$var$__wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_67e7344beaa85059: function(arg0, arg1) {
            const ret = Error($9ba7fd1132ff41af$var$getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_String_8564e559799eccda: function(arg0, arg1) {
            const ret = String(arg1);
            const ptr1 = $9ba7fd1132ff41af$var$passStringToWasm0(ret, $9ba7fd1132ff41af$var$wasm.__wbindgen_malloc, $9ba7fd1132ff41af$var$wasm.__wbindgen_realloc);
            const len1 = $9ba7fd1132ff41af$var$WASM_VECTOR_LEN;
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_boolean_get_7a12af2b3f899c5a: function(arg0) {
            const v = arg0;
            const ret = typeof v === 'boolean' ? v : undefined;
            return $9ba7fd1132ff41af$var$isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_0e68cf47c9cbd9b0: function(arg0, arg1) {
            const ret = $9ba7fd1132ff41af$var$debugString(arg1);
            const ptr1 = $9ba7fd1132ff41af$var$passStringToWasm0(ret, $9ba7fd1132ff41af$var$wasm.__wbindgen_malloc, $9ba7fd1132ff41af$var$wasm.__wbindgen_realloc);
            const len1 = $9ba7fd1132ff41af$var$WASM_VECTOR_LEN;
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_in_50072d4d6e45c193: function(arg0, arg1) {
            const ret = arg0 in arg1;
            return ret;
        },
        __wbg___wbindgen_is_function_fcda5e3902d732fe: function(arg0) {
            const ret = typeof arg0 === 'function';
            return ret;
        },
        __wbg___wbindgen_is_object_edb6b15aa3afe12e: function(arg0) {
            const val = arg0;
            const ret = typeof val === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_undefined_8c687d0b90d5b524: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_3c30021c243b64cd: function(arg0, arg1) {
            const ret = arg0 == arg1;
            return ret;
        },
        __wbg___wbindgen_number_get_1dc732b810cb937c: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof obj === 'number' ? obj : undefined;
            $9ba7fd1132ff41af$var$getDataViewMemory0().setFloat64(arg0 + 8, $9ba7fd1132ff41af$var$isLikeNone(ret) ? 0 : ret, true);
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 0, !$9ba7fd1132ff41af$var$isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_92ab86bb19cbc12f: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof obj === 'string' ? obj : undefined;
            var ptr1 = $9ba7fd1132ff41af$var$isLikeNone(ret) ? 0 : $9ba7fd1132ff41af$var$passStringToWasm0(ret, $9ba7fd1132ff41af$var$wasm.__wbindgen_malloc, $9ba7fd1132ff41af$var$wasm.__wbindgen_realloc);
            var len1 = $9ba7fd1132ff41af$var$WASM_VECTOR_LEN;
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $9ba7fd1132ff41af$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_throw_5d9e815e6fdf150f: function(arg0, arg1) {
            throw new Error($9ba7fd1132ff41af$var$getStringFromWasm0(arg0, arg1));
        },
        __wbg_call_269c5566fbede3eb: function() {
            return $9ba7fd1132ff41af$var$handleError(function(arg0, arg1) {
                const ret = arg0.call(arg1);
                return ret;
            }, arguments);
        },
        __wbg_done_cffed884d87aa22e: function(arg0) {
            const ret = arg0.done;
            return ret;
        },
        __wbg_get_6cf5a4d4d8ad3c5a: function() {
            return $9ba7fd1132ff41af$var$handleError(function(arg0, arg1) {
                const ret = Reflect.get(arg0, arg1);
                return ret;
            }, arguments);
        },
        __wbg_get_unchecked_363572bdd397d473: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_with_ref_key_6412cf3094599694: function(arg0, arg1) {
            const ret = arg0[arg1];
            return ret;
        },
        __wbg_instanceof_ArrayBuffer_d4ff01f8247925ae: function(arg0) {
            let result;
            try {
                result = arg0 instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_598adc0fef426aa8: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_5674713bb7b79043: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_iterator_22ddeb808cf55a6f: function() {
            const ret = Symbol.iterator;
            return ret;
        },
        __wbg_length_31bdaf014f5fbde2: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_4e1adc0d42e23620: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_new_1da3429bc3c4541c: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_bebc3f4757acf305: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_new_ffa92086ea89f79c: function() {
            const ret = new Array();
            return ret;
        },
        __wbg_next_95053e306b1c3aed: function(arg0) {
            const ret = arg0.next;
            return ret;
        },
        __wbg_next_f31ecb8646d2c605: function() {
            return $9ba7fd1132ff41af$var$handleError(function(arg0) {
                const ret = arg0.next();
                return ret;
            }, arguments);
        },
        __wbg_prototypesetcall_ae9f5e7459250748: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call($9ba7fd1132ff41af$var$getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_set_13d25b81ab403f5e: function(arg0, arg1, arg2) {
            arg0[arg1 >>> 0] = arg2;
        },
        __wbg_set_6be42768c690e380: function(arg0, arg1, arg2) {
            arg0[arg1] = arg2;
        },
        __wbg_value_c227f843d21da141: function(arg0) {
            const ret = arg0.value;
            return ret;
        },
        __wbindgen_generic_0000000000000001: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_generic_0000000000000002: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = $9ba7fd1132ff41af$var$getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = $9ba7fd1132ff41af$var$wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        }
    };
    return {
        __proto__: null,
        "./calc_core_bg.js": import0
    };
}
function $9ba7fd1132ff41af$var$addToExternrefTable0(obj) {
    const idx = $9ba7fd1132ff41af$var$wasm.__externref_table_alloc();
    $9ba7fd1132ff41af$var$wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}
function $9ba7fd1132ff41af$var$debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) return `${val}`;
    if (type == 'string') return `"${val}"`;
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) return 'Symbol';
        else return `Symbol(${description})`;
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) return `Function(${name})`;
        else return 'Function';
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) debug += $9ba7fd1132ff41af$var$debugString(val[0]);
        for(let i = 1; i < length; i++)debug += ', ' + $9ba7fd1132ff41af$var$debugString(val[i]);
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) className = builtInMatches[1];
    else // Failed to match the standard '[object ClassName]'
    return toString.call(val);
    if (className == 'Object') // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
        return 'Object(' + JSON.stringify(val) + ')';
    } catch (_) {
        return 'Object';
    }
    // errors
    if (val instanceof Error) return `${val.name}: ${val.message}\n${val.stack}`;
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
function $9ba7fd1132ff41af$var$getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $9ba7fd1132ff41af$var$getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}
let $9ba7fd1132ff41af$var$cachedDataViewMemory0 = null;
function $9ba7fd1132ff41af$var$getDataViewMemory0() {
    if ($9ba7fd1132ff41af$var$cachedDataViewMemory0 === null || $9ba7fd1132ff41af$var$cachedDataViewMemory0.buffer.detached === true || $9ba7fd1132ff41af$var$cachedDataViewMemory0.buffer.detached === undefined && $9ba7fd1132ff41af$var$cachedDataViewMemory0.buffer !== $9ba7fd1132ff41af$var$wasm.memory.buffer) $9ba7fd1132ff41af$var$cachedDataViewMemory0 = new DataView($9ba7fd1132ff41af$var$wasm.memory.buffer);
    return $9ba7fd1132ff41af$var$cachedDataViewMemory0;
}
function $9ba7fd1132ff41af$var$getStringFromWasm0(ptr, len) {
    return $9ba7fd1132ff41af$var$decodeText(ptr >>> 0, len);
}
let $9ba7fd1132ff41af$var$cachedUint8ArrayMemory0 = null;
function $9ba7fd1132ff41af$var$getUint8ArrayMemory0() {
    if ($9ba7fd1132ff41af$var$cachedUint8ArrayMemory0 === null || $9ba7fd1132ff41af$var$cachedUint8ArrayMemory0.byteLength === 0) $9ba7fd1132ff41af$var$cachedUint8ArrayMemory0 = new Uint8Array($9ba7fd1132ff41af$var$wasm.memory.buffer);
    return $9ba7fd1132ff41af$var$cachedUint8ArrayMemory0;
}
function $9ba7fd1132ff41af$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $9ba7fd1132ff41af$var$addToExternrefTable0(e);
        $9ba7fd1132ff41af$var$wasm.__wbindgen_exn_store(idx);
    }
}
function $9ba7fd1132ff41af$var$isLikeNone(x) {
    return x === undefined || x === null;
}
function $9ba7fd1132ff41af$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $9ba7fd1132ff41af$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $9ba7fd1132ff41af$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $9ba7fd1132ff41af$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $9ba7fd1132ff41af$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $9ba7fd1132ff41af$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $9ba7fd1132ff41af$var$cachedTextEncoder.encodeInto(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $9ba7fd1132ff41af$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
function $9ba7fd1132ff41af$var$takeFromExternrefTable0(idx) {
    const value = $9ba7fd1132ff41af$var$wasm.__wbindgen_externrefs.get(idx);
    $9ba7fd1132ff41af$var$wasm.__externref_table_dealloc(idx);
    return value;
}
let $9ba7fd1132ff41af$var$cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
});
$9ba7fd1132ff41af$var$cachedTextDecoder.decode();
const $9ba7fd1132ff41af$var$MAX_SAFARI_DECODE_BYTES = 2146435072;
let $9ba7fd1132ff41af$var$numBytesDecoded = 0;
function $9ba7fd1132ff41af$var$decodeText(ptr, len) {
    $9ba7fd1132ff41af$var$numBytesDecoded += len;
    if ($9ba7fd1132ff41af$var$numBytesDecoded >= $9ba7fd1132ff41af$var$MAX_SAFARI_DECODE_BYTES) {
        $9ba7fd1132ff41af$var$cachedTextDecoder = new TextDecoder('utf-8', {
            ignoreBOM: true,
            fatal: true
        });
        $9ba7fd1132ff41af$var$cachedTextDecoder.decode();
        $9ba7fd1132ff41af$var$numBytesDecoded = len;
    }
    return $9ba7fd1132ff41af$var$cachedTextDecoder.decode($9ba7fd1132ff41af$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
const $9ba7fd1132ff41af$var$cachedTextEncoder = new TextEncoder();
if (!('encodeInto' in $9ba7fd1132ff41af$var$cachedTextEncoder)) $9ba7fd1132ff41af$var$cachedTextEncoder.encodeInto = function(arg, view) {
    const buf = $9ba7fd1132ff41af$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
let $9ba7fd1132ff41af$var$WASM_VECTOR_LEN = 0;
let $9ba7fd1132ff41af$var$wasmModule, $9ba7fd1132ff41af$var$wasmInstance, $9ba7fd1132ff41af$var$wasm;
function $9ba7fd1132ff41af$var$__wbg_finalize_init(instance, module) {
    $9ba7fd1132ff41af$var$wasmInstance = instance;
    $9ba7fd1132ff41af$var$wasm = instance.exports;
    $9ba7fd1132ff41af$var$wasmModule = module;
    $9ba7fd1132ff41af$var$cachedDataViewMemory0 = null;
    $9ba7fd1132ff41af$var$cachedUint8ArrayMemory0 = null;
    $9ba7fd1132ff41af$var$wasm.__wbindgen_start();
    return $9ba7fd1132ff41af$var$wasm;
}
async function $9ba7fd1132ff41af$var$__wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (!module.ok) throw new Error(`failed to fetch Wasm: ${module.status} ${module.statusText} fetching '${module.url}'`);
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            const validResponse = expectedResponseType(module.type);
            if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
    function expectedResponseType(type) {
        switch(type){
            case 'basic':
            case 'cors':
            case 'default':
                return true;
        }
        return false;
    }
}
function $9ba7fd1132ff41af$export$2ec80ee76a9348bf(module) {
    if ($9ba7fd1132ff41af$var$wasm !== undefined) return $9ba7fd1132ff41af$var$wasm;
    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $9ba7fd1132ff41af$var$__wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $9ba7fd1132ff41af$var$__wbg_finalize_init(instance, module);
}

async function $9ba7fd1132ff41af$export$2e2bcd8739ae039(module_or_path) {
    if ($9ba7fd1132ff41af$var$wasm !== undefined) return $9ba7fd1132ff41af$var$wasm;
    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (module_or_path === undefined) module_or_path = new URL((parcelRequire("jD715")));
    const imports = $9ba7fd1132ff41af$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    const { instance: instance, module: module } = await $9ba7fd1132ff41af$var$__wbg_load(await module_or_path, imports);
    return $9ba7fd1132ff41af$var$__wbg_finalize_init(instance, module);
}

});
parcelRegister("jD715", function(module, exports) {
module.exports = import.meta.resolve("hMfnI");

});



parcelRegister("aCKYX", function(module, exports) {

$parcel$export(module.exports, "useAuth", () => $7bc1e5a75795e44f$export$1d39dc5b47e56ff0);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");

var $hYNgF = parcelRequire("hYNgF");

var $lTXzM = parcelRequire("lTXzM");
// A bearer token cached in localStorage rather than a cookie session — this
// app needs to know "am I logged in" without a network round trip (so it
// keeps working offline once a device has logged in at least once), which a
// token it can read synchronously satisfies directly. Login/register are
// entirely optional: every feature in the app already works with nothing
// here ever set, purely off localStorage — this module only ever adds
// sync on top, never gates anything.
const $7bc1e5a75795e44f$var$token = (0, $hYNgF.usePersisted)('auth-token', null);
const $7bc1e5a75795e44f$var$email = (0, $hYNgF.usePersisted)('auth-email', null);
// Cached alongside the token so the scanner page can gate itself without a
// network round trip on every render — refreshed by requestToken/
// updateProfile, and by refreshProfile() below for the case where
// score_sheet_scanner got granted server-side (a direct DB edit, see
// server/db.js) after this browser already logged in.
const $7bc1e5a75795e44f$var$scannerAccess = (0, $hYNgF.usePersisted)('auth-scanner-access', false);
const $7bc1e5a75795e44f$var$isLoggedIn = (0, $TusQn.computed)(()=>!!$7bc1e5a75795e44f$var$token.value);
async function $7bc1e5a75795e44f$var$requestToken(path, emailInput, password) {
    const res = await fetch(`${(0, $lTXzM.getServerUrl)()}${path}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: emailInput,
            password: password
        })
    });
    const body = await res.json().catch(()=>({}));
    if (!res.ok) throw new Error(body.error || 'Request failed.');
    $7bc1e5a75795e44f$var$token.value = body.token;
    $7bc1e5a75795e44f$var$email.value = body.email;
    $7bc1e5a75795e44f$var$scannerAccess.value = !!body.scanner_access;
}
function $7bc1e5a75795e44f$var$register(emailInput, password) {
    return $7bc1e5a75795e44f$var$requestToken('/register', emailInput, password);
}
function $7bc1e5a75795e44f$var$login(emailInput, password) {
    return $7bc1e5a75795e44f$var$requestToken('/login', emailInput, password);
}
// Local-only — clears the cached token/email but never touches server data
// or any locally-stored setup. Logging out just stops syncing.
function $7bc1e5a75795e44f$var$logout() {
    $7bc1e5a75795e44f$var$token.value = null;
    $7bc1e5a75795e44f$var$email.value = null;
    $7bc1e5a75795e44f$var$scannerAccess.value = false;
}
function $7bc1e5a75795e44f$var$authHeader() {
    return $7bc1e5a75795e44f$var$token.value ? {
        Authorization: `Bearer ${$7bc1e5a75795e44f$var$token.value}`
    } : {};
}
// currentPassword is always required server-side (see server/index.js's
// updateProfile) even though this call is already authenticated — changing
// the login credentials on a bearer token alone would mean a leaked/stale
// token is enough to lock the real owner out permanently.
async function $7bc1e5a75795e44f$var$updateProfile({ currentPassword: currentPassword, newEmail: newEmail, newPassword: newPassword }) {
    const res = await fetch(`${(0, $lTXzM.getServerUrl)()}/profile`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...$7bc1e5a75795e44f$var$authHeader()
        },
        body: JSON.stringify({
            currentPassword: currentPassword,
            newEmail: newEmail,
            newPassword: newPassword
        })
    });
    const body = await res.json().catch(()=>({}));
    if (!res.ok) throw new Error(body.error || 'Profile update failed.');
    $7bc1e5a75795e44f$var$token.value = body.token;
    $7bc1e5a75795e44f$var$email.value = body.email;
    $7bc1e5a75795e44f$var$scannerAccess.value = !!body.scanner_access;
}
// Same currentPassword requirement as updateProfile, for the same reason —
// this is the most destructive action in the app (permanently deletes the
// account and every setup synced to it), so a bare bearer token alone
// shouldn't be enough to trigger it. Only clears the local token/email/
// scannerAccess on success (same as logout()) — clearing the locally
// cached setups too is the caller's job (see account_widget.vue and
// profile.vue's onLogout/deleteAccount, which also call
// useSetups().replaceAllSetups and useSync().resetSyncState), since this
// module has no reason to know about setups.js/sync.js.
async function $7bc1e5a75795e44f$var$deleteAccount(currentPassword) {
    const res = await fetch(`${(0, $lTXzM.getServerUrl)()}/account`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            ...$7bc1e5a75795e44f$var$authHeader()
        },
        body: JSON.stringify({
            currentPassword: currentPassword
        })
    });
    const body = await res.json().catch(()=>({}));
    if (!res.ok) throw new Error(body.error || 'Account deletion failed.');
    $7bc1e5a75795e44f$var$logout();
}
// Best-effort refresh of email/scannerAccess for the current token — call
// this before gating on scannerAccess (e.g. on the scanner page mount) so a
// permission grant made after this browser last logged in takes effect
// without forcing a fresh login. Silently does nothing if logged out or the
// request fails (offline, expired token, etc.) — callers just keep using
// whatever was already cached.
async function $7bc1e5a75795e44f$var$refreshProfile() {
    if (!$7bc1e5a75795e44f$var$token.value) return;
    try {
        const res = await fetch(`${(0, $lTXzM.getServerUrl)()}/me`, {
            headers: $7bc1e5a75795e44f$var$authHeader()
        });
        if (!res.ok) return;
        const body = await res.json();
        $7bc1e5a75795e44f$var$email.value = body.email;
        $7bc1e5a75795e44f$var$scannerAccess.value = !!body.scanner_access;
    } catch  {
    // offline or unreachable — keep the cached values as-is
    }
}
function $7bc1e5a75795e44f$export$1d39dc5b47e56ff0() {
    return {
        isLoggedIn: $7bc1e5a75795e44f$var$isLoggedIn,
        email: $7bc1e5a75795e44f$var$email,
        scannerAccess: $7bc1e5a75795e44f$var$scannerAccess,
        register: $7bc1e5a75795e44f$var$register,
        login: $7bc1e5a75795e44f$var$login,
        logout: $7bc1e5a75795e44f$var$logout,
        authHeader: $7bc1e5a75795e44f$var$authHeader,
        updateProfile: $7bc1e5a75795e44f$var$updateProfile,
        deleteAccount: $7bc1e5a75795e44f$var$deleteAccount,
        refreshProfile: $7bc1e5a75795e44f$var$refreshProfile
    };
}

});
parcelRegister("hYNgF", function(module, exports) {

$parcel$export(module.exports, "readJSON", () => $d16e41d64e10ce0f$export$ce30717759bc230c);
$parcel$export(module.exports, "writeJSON", () => $d16e41d64e10ce0f$export$832cdf204000b2a9);
$parcel$export(module.exports, "usePersisted", () => $d16e41d64e10ce0f$export$1fe2ece51bb7f91e);
parcelRequire("dk7qG");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
function $d16e41d64e10ce0f$export$ce30717759bc230c(key, fallback) {
    try {
        const saved = localStorage.getItem(key);
        if (saved !== null) return JSON.parse(saved);
    } catch (e) {
        console.warn(`Failed to load '${key}' from localStorage:`, e);
    }
    return fallback;
}
function $d16e41d64e10ce0f$export$832cdf204000b2a9(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.warn(`Failed to save '${key}' to localStorage:`, e);
    }
}
function $d16e41d64e10ce0f$export$1fe2ece51bb7f91e(key, defaultValue, { validate: validate } = {}) {
    const loaded = $d16e41d64e10ce0f$export$ce30717759bc230c(key, defaultValue);
    const state = (0, $01W3b.ref)(validate && !validate(loaded) ? defaultValue : loaded);
    (0, $TusQn.watch)(state, (value)=>$d16e41d64e10ce0f$export$832cdf204000b2a9(key, value), {
        deep: true
    });
    return state;
}

});

parcelRegister("lTXzM", function(module, exports) {

$parcel$export(module.exports, "getServerUrl", () => $ff1cf29d3d4933e0$export$3c14a5a58c5a65d4);
// The app's own backend (server/index.js) is reachable at /api on the same
// origin as the static site — Caddy reverse-proxies it there in production
// (see Caddyfile), and the local Parcel dev server does the same locally
// (see .proxyrc.json), both stripping the /api prefix before forwarding so
// the server's own routes stay unprefixed (/register, /setups, ...).
//
// Same-origin on purpose: this used to be a separate DOMAIN:SCAN_SERVER_PORT
// origin, which meant every fetch here was cross-origin — subject to CORS,
// and to mixed-content blocking whenever the page's own protocol didn't
// match what the backend could actually serve (e.g. a locally-run backend,
// which never has TLS, reached from a page loaded over https for unrelated
// reasons). Routing through one origin makes that whole class of bug
// impossible rather than working around it.
function $ff1cf29d3d4933e0$export$3c14a5a58c5a65d4() {
    return '/api';
}

});


parcelRegister("gsNnp", function(module, exports) {

$parcel$export(module.exports, "touchActiveSetup", () => $bfc59006cf644cf7$export$9ec3b02a592cc8eb);
$parcel$export(module.exports, "onComputeFinished", () => $bfc59006cf644cf7$export$7b2b43591b51923);
$parcel$export(module.exports, "onSetupLoaded", () => $bfc59006cf644cf7$export$e9b8fd3cfc949772);
$parcel$export(module.exports, "backfillTimestamps", () => $bfc59006cf644cf7$export$ef1cad4434ac7a90);
$parcel$export(module.exports, "waitForComputeIdle", () => $bfc59006cf644cf7$export$b64fe267003a6582);
$parcel$export(module.exports, "loadSetup", () => $bfc59006cf644cf7$export$9bffcfc640df7813);
$parcel$export(module.exports, "exportSetupJson", () => $bfc59006cf644cf7$export$97cbd2ec45ae44d);
$parcel$export(module.exports, "getSetupCalc", () => $bfc59006cf644cf7$export$6d94635e6a828274);
$parcel$export(module.exports, "parseSetupImport", () => $bfc59006cf644cf7$export$4f79f7fa389a6d0a);
$parcel$export(module.exports, "applySetupData", () => $bfc59006cf644cf7$export$7a5e25a22635a354);
$parcel$export(module.exports, "useShared", () => $bfc59006cf644cf7$export$652eac7113c0e2dd);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $euiHy = parcelRequire("euiHy");

var $fUI42 = parcelRequire("fUI42");

var $hYNgF = parcelRequire("hYNgF");

var $bWZV2 = parcelRequire("bWZV2");
// Which setup `inputs`/`computedResult` currently mirror — null until
// loadSetup() below has run once. Set by loadSetup() rather than passed
// around, since the persistence watcher further down needs to know the
// current id at write time, and exportSetupJson()/applySetupData() need it
// to tell whether a given setup id is the "live" one (mirrored into the
// reactive `inputs`/`computedResult` below) or one that's only sitting in
// the store right now, not currently open for editing.
let $bfc59006cf644cf7$var$currentSetupId = null;
const $bfc59006cf644cf7$var$inputs = (0, $01W3b.reactive)({
    marks: [],
    sight_settings: new $euiHy.SightSettings(),
    // Free-text description of this setup. Deliberately left out of
    // snapshotInputs() below (the string undo/redo and isStale both compare
    // against) — it's persisted and synced like sight_settings/marks, but
    // never creates an undo step and never marks a compute stale. Its own
    // edit history lives in the setup log instead (see setup_log.js).
    description: ''
});
const $bfc59006cf644cf7$var$computedResult = (0, $01W3b.shallowRef)(new $euiHy.Calculated());
const $bfc59006cf644cf7$var$isStale = (0, $01W3b.ref)(true);
// The active setup's own single "last changed" timestamp — the one thing
// sync.js's last-write-wins comparison uses. Deliberately separate from
// sight_settings.updated_at/marks[].updated_at, which exist purely for the
// user's own "updated 3m ago" labels (input_sight_settings.vue/
// input_marks.vue) and don't cover everything that makes a setup "changed"
// anyway. One clear field beats deriving a sync timestamp by scanning
// scattered per-field ones every time.
const $bfc59006cf644cf7$var$setupUpdatedAt = (0, $01W3b.ref)(0);
function $bfc59006cf644cf7$export$9ec3b02a592cc8eb() {
    $bfc59006cf644cf7$var$setupUpdatedAt.value = Date.now();
}
// Set around a wholesale reload of `inputs` (loadSetup switching setups,
// applySetupData pulling in a remote/imported setup) — those already know
// and set the correct setupUpdatedAt themselves (the setup's own stored
// timestamp, or the remote's), so the auto-touch watcher below must not
// also stamp its own Date.now() over that just because inputs changed.
let $bfc59006cf644cf7$var$suppressAutoTouch = false;
// Notified once a compute genuinely finishes (not on every isStale/
// computedResult change — loadSetup/applySetupData also touch those when
// switching setups, which shouldn't trigger this). sync.js subscribes here
// to push a fresh result immediately rather than waiting out any debounce —
// unlike a burst of keystrokes, a finished compute is a single, discrete
// event with nothing more coming right behind it.
const $bfc59006cf644cf7$var$computeFinishedListeners = new Set();
function $bfc59006cf644cf7$export$7b2b43591b51923(fn) {
    $bfc59006cf644cf7$var$computeFinishedListeners.add(fn);
}
// Notified whenever loadSetup() replaces `inputs` wholesale (a setup
// switch, or the initial load on startup) — passed the setup id that just
// became active. setup_log.js subscribes here to reset its "last logged
// description" baseline per setup, so switching setups (or reloading the
// page) never looks like the user editing the description.
const $bfc59006cf644cf7$var$setupLoadedListeners = new Set();
function $bfc59006cf644cf7$export$e9b8fd3cfc949772(fn) {
    $bfc59006cf644cf7$var$setupLoadedListeners.add(fn);
}
// Excludes updated_at — this snapshot is compared for equality to decide
// isStale and undo/redo steps, both of which care only about the physical
// calibration values. Including updated_at would mark things stale (or
// create a bogus undo step) purely from a timestamp ticking over, with no
// actual value having changed.
function $bfc59006cf644cf7$var$snapshotInputs() {
    const { updated_at: updated_at, ...sightSettingsSansTimestamp } = $bfc59006cf644cf7$var$inputs.sight_settings;
    return JSON.stringify({
        sight_settings: sightSettingsSansTimestamp,
        marks: $bfc59006cf644cf7$var$inputs.marks.map(({ updated_at: updated_at, ...rest })=>rest)
    });
}
function $bfc59006cf644cf7$export$ef1cad4434ac7a90({ sight_settings: sight_settings, marks: marks }) {
    const now = Date.now();
    if (sight_settings.updated_at == null) sight_settings.updated_at = now;
    marks.forEach((m)=>{
        if (m.updated_at == null) m.updated_at = now;
    });
}
// The inputs as they were at the last successful compute — null if nothing
// has been computed yet this load. Reset by loadSetup() on every switch.
let $bfc59006cf644cf7$var$lastComputedSnapshot = null;
// isStale tracks whether the current inputs differ from the last successful
// compute — in both directions, so an edit that gets undone (typed away,
// then typed back to the original value) clears the stale flag again
// without needing another recompute. This is the only place isStale gets
// set from an input change; it used to also be forced true directly from
// each input's change handler, but that raced with this watcher depending
// on which ran last.
(0, $TusQn.watch)($bfc59006cf644cf7$var$inputs, ()=>{
    $bfc59006cf644cf7$var$isStale.value = $bfc59006cf644cf7$var$lastComputedSnapshot === null || $bfc59006cf644cf7$var$snapshotInputs() !== $bfc59006cf644cf7$var$lastComputedSnapshot;
}, {
    deep: true
});
// Centralizes "this setup changed" so editing components (input_sight_
// settings.vue, input_marks.vue) don't each need to remember to call
// touchActiveSetup() themselves — any deep change to inputs bumps it here,
// once, covering every field edit, add/remove-row, sort, and undo/redo
// alike. Suppressed only for the wholesale reloads (loadSetup,
// applySetupData) that already carry their own correct timestamp.
(0, $TusQn.watch)($bfc59006cf644cf7$var$inputs, ()=>{
    if (!$bfc59006cf644cf7$var$suppressAutoTouch) $bfc59006cf644cf7$export$9ec3b02a592cc8eb();
}, {
    deep: true
});
// The one place that writes the active setup's data back into the store —
// every other write (rename, a setup that isn't currently open) mutates
// store.value.setups[id] directly (see setups.js/applySetupData below)
// since there's no live mirror to keep in sync for those. calc is folded in
// right here as one more field of the same record, rather than a second,
// parallel write path (see git history for the getSetupCalc/applySetupCalc
// pair this replaced) — a setup's precomputed fit is just data belonging to
// that setup, same as its sight_settings/marks.
(0, $TusQn.watch)([
    $bfc59006cf644cf7$var$inputs,
    $bfc59006cf644cf7$var$isStale,
    $bfc59006cf644cf7$var$computedResult,
    $bfc59006cf644cf7$var$setupUpdatedAt
], ([newInputs, newIsStale, newComputedResult, newSetupUpdatedAt])=>{
    if (!$bfc59006cf644cf7$var$currentSetupId) return; // loadSetup() hasn't run yet
    const existing = (0, $fUI42.store).value.setups[$bfc59006cf644cf7$var$currentSetupId];
    (0, $fUI42.store).value.setups[$bfc59006cf644cf7$var$currentSetupId] = {
        name: existing?.name ?? 'Setup',
        sight_settings: newInputs.sight_settings,
        marks: newInputs.marks,
        description: newInputs.description,
        calc: newIsStale ? null : newComputedResult.toJSON(),
        updated_at: newSetupUpdatedAt,
        undo: existing?.undo ?? {
            stack: [],
            redo: []
        }
    };
}, {
    deep: true
} // watch nested changes (e.g., marks.push())
);
// ── Undo/redo over the calibration inputs (sight settings + marks) ──
//
// Snapshots are committed on a debounce rather than on every keystroke —
// v-model fires on every character typed, and nobody wants to press undo
// once per digit to get back one intended edit. Editing coalesces into a
// single step once the user pauses; add/remove-row and unit-toggle clicks
// each land as their own step since those aren't part of a typing burst.
const $bfc59006cf644cf7$var$UNDO_DEBOUNCE_MS = 600;
const $bfc59006cf644cf7$var$MAX_UNDO_HISTORY = 50;
let $bfc59006cf644cf7$var$undoStack = [];
let $bfc59006cf644cf7$var$redoStack = [];
let $bfc59006cf644cf7$var$undoDebounceTimer = null;
let $bfc59006cf644cf7$var$lastCommittedSnapshot = $bfc59006cf644cf7$var$snapshotInputs(); // reset by loadSetup() on every switch
const $bfc59006cf644cf7$var$canUndo = (0, $01W3b.ref)(false);
const $bfc59006cf644cf7$var$canRedo = (0, $01W3b.ref)(false);
function $bfc59006cf644cf7$var$applyInputsData(parsed) {
    // Parse both before touching `inputs` — a Mark validation failure partway
    // through shouldn't leave sight_settings overwritten but marks untouched.
    const newSightSettings = $euiHy.SightSettings.fromJson(parsed.sight_settings);
    const newMarks = $euiHy.Marks.fromJson(parsed.marks).marks;
    Object.assign($bfc59006cf644cf7$var$inputs.sight_settings, newSightSettings);
    $bfc59006cf644cf7$var$inputs.marks.splice(0, $bfc59006cf644cf7$var$inputs.marks.length, ...newMarks);
}
function $bfc59006cf644cf7$var$applySnapshot(json) {
    $bfc59006cf644cf7$var$applyInputsData(JSON.parse(json));
    $bfc59006cf644cf7$export$ef1cad4434ac7a90($bfc59006cf644cf7$var$inputs);
}
// Persisted inside the setup's own store record (store.value.setups[id].undo)
// so switching setups doesn't wipe history — undo/redo resume right where
// they were left for whichever setup you switch back to. Local-only,
// deliberately: exportSetupJson/applySetupData (the sync/file-export
// contract, see below) never touch this field, so it never leaves the
// browser.
function $bfc59006cf644cf7$var$saveUndoHistory() {
    if (!$bfc59006cf644cf7$var$currentSetupId) return;
    const record = (0, $fUI42.store).value.setups[$bfc59006cf644cf7$var$currentSetupId];
    if (record) record.undo = {
        stack: $bfc59006cf644cf7$var$undoStack,
        redo: $bfc59006cf644cf7$var$redoStack
    };
}
function $bfc59006cf644cf7$var$commitUndoStep() {
    const current = $bfc59006cf644cf7$var$snapshotInputs();
    if (current === $bfc59006cf644cf7$var$lastCommittedSnapshot) return;
    $bfc59006cf644cf7$var$undoStack.push($bfc59006cf644cf7$var$lastCommittedSnapshot);
    if ($bfc59006cf644cf7$var$undoStack.length > $bfc59006cf644cf7$var$MAX_UNDO_HISTORY) $bfc59006cf644cf7$var$undoStack.shift();
    $bfc59006cf644cf7$var$lastCommittedSnapshot = current;
    $bfc59006cf644cf7$var$redoStack = [];
    $bfc59006cf644cf7$var$canUndo.value = true;
    $bfc59006cf644cf7$var$canRedo.value = false;
    $bfc59006cf644cf7$var$saveUndoHistory();
}
(0, $TusQn.watch)($bfc59006cf644cf7$var$inputs, ()=>{
    clearTimeout($bfc59006cf644cf7$var$undoDebounceTimer);
    $bfc59006cf644cf7$var$undoDebounceTimer = setTimeout($bfc59006cf644cf7$var$commitUndoStep, $bfc59006cf644cf7$var$UNDO_DEBOUNCE_MS);
}, {
    deep: true
});
function $bfc59006cf644cf7$var$undo() {
    clearTimeout($bfc59006cf644cf7$var$undoDebounceTimer);
    // An edit still mid-debounce (not yet its own history entry) — undo just
    // discards it and drops back to the last settled state, rather than also
    // consuming a real history entry on top of that.
    const current = $bfc59006cf644cf7$var$snapshotInputs();
    if (current !== $bfc59006cf644cf7$var$lastCommittedSnapshot) {
        $bfc59006cf644cf7$var$redoStack.push(current);
        $bfc59006cf644cf7$var$applySnapshot($bfc59006cf644cf7$var$lastCommittedSnapshot);
        $bfc59006cf644cf7$var$canRedo.value = true;
        $bfc59006cf644cf7$var$canUndo.value = $bfc59006cf644cf7$var$undoStack.length > 0;
        $bfc59006cf644cf7$var$saveUndoHistory();
        return;
    }
    if ($bfc59006cf644cf7$var$undoStack.length === 0) return;
    const previous = $bfc59006cf644cf7$var$undoStack.pop();
    $bfc59006cf644cf7$var$redoStack.push($bfc59006cf644cf7$var$lastCommittedSnapshot);
    $bfc59006cf644cf7$var$applySnapshot(previous);
    $bfc59006cf644cf7$var$lastCommittedSnapshot = previous;
    $bfc59006cf644cf7$var$canUndo.value = $bfc59006cf644cf7$var$undoStack.length > 0;
    $bfc59006cf644cf7$var$canRedo.value = true;
    $bfc59006cf644cf7$var$saveUndoHistory();
}
function $bfc59006cf644cf7$var$redo() {
    clearTimeout($bfc59006cf644cf7$var$undoDebounceTimer);
    if ($bfc59006cf644cf7$var$redoStack.length === 0) return;
    const next = $bfc59006cf644cf7$var$redoStack.pop();
    $bfc59006cf644cf7$var$undoStack.push($bfc59006cf644cf7$var$lastCommittedSnapshot);
    $bfc59006cf644cf7$var$applySnapshot(next);
    $bfc59006cf644cf7$var$lastCommittedSnapshot = next;
    $bfc59006cf644cf7$var$canUndo.value = true;
    $bfc59006cf644cf7$var$canRedo.value = $bfc59006cf644cf7$var$redoStack.length > 0;
    $bfc59006cf644cf7$var$saveUndoHistory();
}
// Set when the main compute (velocity/drag/offset fit) fails. Unlike a
// toast, this has no timer — it stays up until the inputs are fixed and
// compute() succeeds again.
const $bfc59006cf644cf7$var$computeError = (0, $01W3b.ref)(null);
// True while a compute is actually running. calc.js's solver is fully
// synchronous, so once it starts it blocks the main thread until done —
// there's no "in progress" moment to observe from the outside. The only
// way to show a "computing" indicator at all is to flip this on and let
// the browser actually paint it *before* kicking off the blocking call.
const $bfc59006cf644cf7$var$isComputing = (0, $01W3b.ref)(false);
function $bfc59006cf644cf7$var$compute() {
    console.log('Calculating arrow flight');
    try {
        let data = $euiHy.marksToM($bfc59006cf644cf7$var$inputs.marks);
        // findVelocityAndDrag already returns the offset/fit for its converged
        // (v, c) — no separate calcOffset call needed to recover them.
        let result = $euiHy.findVelocityAndDrag($bfc59006cf644cf7$var$inputs.sight_settings, data);
        console.log(`Calculated v: ${result.v}, c: ${result.drag}, offset: ${result.offset}`);
        $bfc59006cf644cf7$var$computedResult.value = result;
        $bfc59006cf644cf7$var$lastComputedSnapshot = $bfc59006cf644cf7$var$snapshotInputs();
        $bfc59006cf644cf7$var$isStale.value = false;
        $bfc59006cf644cf7$var$computeError.value = null;
        // A fresh calc is as much a change to this setup as an edited field —
        // without this, syncing a compute that finished *after* the edit that
        // prompted it already got pushed would carry the same updated_at as
        // that earlier push, and the server's last-write-wins guard
        // (existing.updated_at >= incoming) would silently keep its old,
        // pre-compute calc instead of accepting the new one.
        $bfc59006cf644cf7$export$9ec3b02a592cc8eb();
        $bfc59006cf644cf7$var$computeFinishedListeners.forEach((fn)=>fn());
    } catch (error) {
        console.log('error computing everything:', error.message);
        console.log(error.stack);
        $bfc59006cf644cf7$var$computeError.value = error.message;
    }
}
const $bfc59006cf644cf7$export$889065de9c08789e = 0.25;
// In-memory copy of whatever getLevelMarksTable() last built or loaded —
// checked before localStorage so repeated calls within the same page load
// (e.g. Graph and Full Marks both opened back to back) don't even pay a
// JSON.parse. Cleared implicitly by simply never matching once the
// fingerprint moves on. (wasm also caches its own copy of this table, keyed
// the same way — see rust/calc-core/src/lib.rs — but that only saves
// rebuilding it in Rust; this still saves the serde-wasm-bindgen
// serialization a fresh wasm call would otherwise pay every time.)
let $bfc59006cf644cf7$var$levelTableCache = null; // { setupId, fingerprint, rows }
// Everything that could change what the table contains — matches the same
// sight_settings|sight_bar_position|calculated shape the per-panel caches
// this replaces already used as their own cache keys (Calculated's
// toString() covers v/drag/offset/fit together). cut_angle isn't part of
// it: this table is always cut_angle 0 by construction.
function $bfc59006cf644cf7$var$levelTableFingerprint() {
    return `${$bfc59006cf644cf7$var$inputs.sight_settings}|${$bfc59006cf644cf7$var$inputs.sight_settings.sight_bar_position}|${$bfc59006cf644cf7$var$computedResult.value}`;
}
function $bfc59006cf644cf7$var$levelTableStorageKey(setupId) {
    return (0, $bWZV2.scopedKey)('level-marks-table', setupId);
}
async function $bfc59006cf644cf7$export$c39d5ec3907345f3() {
    const setupId = $bfc59006cf644cf7$var$currentSetupId;
    const fingerprint = $bfc59006cf644cf7$var$levelTableFingerprint();
    if ($bfc59006cf644cf7$var$levelTableCache && $bfc59006cf644cf7$var$levelTableCache.setupId === setupId && $bfc59006cf644cf7$var$levelTableCache.fingerprint === fingerprint) return $bfc59006cf644cf7$var$levelTableCache.rows;
    const stored = (0, $hYNgF.readJSON)($bfc59006cf644cf7$var$levelTableStorageKey(setupId), null);
    if (stored && stored.fingerprint === fingerprint) {
        $bfc59006cf644cf7$var$levelTableCache = {
            setupId: setupId,
            fingerprint: fingerprint,
            rows: stored.rows
        };
        return stored.rows;
    }
    const sight_settings = $bfc59006cf644cf7$var$inputs.sight_settings;
    const sight_bar_position = sight_settings.sight_bar_position;
    const calculated = $bfc59006cf644cf7$var$computedResult.value;
    const rows = $euiHy.levelMarksTable(sight_settings, sight_bar_position, calculated);
    $bfc59006cf644cf7$var$levelTableCache = {
        setupId: setupId,
        fingerprint: fingerprint,
        rows: rows
    };
    (0, $hYNgF.writeJSON)($bfc59006cf644cf7$var$levelTableStorageKey(setupId), {
        fingerprint: fingerprint,
        rows: rows
    });
    return rows;
}
function $bfc59006cf644cf7$export$4191bae190cb9107(rows, distanceM) {
    if (rows.length === 0) return null;
    const idx = distanceM / $bfc59006cf644cf7$export$889065de9c08789e - 1; // rows[0] is at distance = LEVEL_TABLE_STEP
    if (idx < 0 || idx > rows.length - 1) return null;
    const i0 = Math.min(rows.length - 2, Math.floor(idx));
    const i1 = i0 + 1;
    const a = rows[i0], b = rows[i1];
    const frac = (distanceM - a.distance) / (b.distance - a.distance);
    const lerp = (key)=>a[key] + (b[key] - a[key]) * frac;
    return {
        distance: distanceM,
        mark: lerp('mark'),
        angle: lerp('angle'),
        fps: lerp('fps'),
        t: lerp('t'),
        drop: lerp('drop'),
        verticalMarks: lerp('verticalMarks'),
        horizontalMarks: lerp('horizontalMarks')
    };
}
// Wait for two animation frames: nextTick() only flushes Vue's virtual DOM
// into the real DOM, it doesn't guarantee the browser has actually painted
// it yet. One rAF fires before the next paint; a second one guarantees that
// paint has already happened by the time it fires.
function $bfc59006cf644cf7$var$nextPaint() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>requestAnimationFrame(resolve));
    });
}
async function $bfc59006cf644cf7$var$recompute() {
    if ($bfc59006cf644cf7$var$isComputing.value) return;
    // The setup this call was actually requested for — captured before the
    // waits below, since a setup switch (loadSetup) can happen while this is
    // pending. Without this check, a switch landing in that window would let
    // compute() run against whichever setup is current *by the time it fires*
    // instead of the one the user asked to recompute, and the persistence
    // watcher would silently attribute the result to that later setup —
    // dropping the original request rather than corrupting anything, but
    // leaving the setup the user actually clicked "Recompute" on still stale.
    const targetSetupId = $bfc59006cf644cf7$var$currentSetupId;
    $bfc59006cf644cf7$var$isComputing.value = true;
    await (0, $TusQn.nextTick)();
    await $bfc59006cf644cf7$var$nextPaint();
    if ($bfc59006cf644cf7$var$currentSetupId === targetSetupId) $bfc59006cf644cf7$var$compute();
    $bfc59006cf644cf7$var$isComputing.value = false;
}
function $bfc59006cf644cf7$export$b64fe267003a6582() {
    if (!$bfc59006cf644cf7$var$isComputing.value) return Promise.resolve();
    return new Promise((resolve)=>{
        const stop = (0, $TusQn.watch)($bfc59006cf644cf7$var$isComputing, (computing)=>{
            if (!computing) {
                stop();
                resolve();
            }
        });
    });
}
function $bfc59006cf644cf7$export$9bffcfc640df7813(setupId, fallbackName = 'Default') {
    clearTimeout($bfc59006cf644cf7$var$undoDebounceTimer);
    $bfc59006cf644cf7$var$currentSetupId = setupId;
    // Every id setups.js hands here should already have a record (createSetup/
    // applySetupData both populate one eagerly) — this fallback is just a
    // defensive backstop, not the everyday path it used to be.
    let record = (0, $fUI42.store).value.setups[setupId];
    if (!record) {
        record = (0, $fUI42.createDefaultRecord)(fallbackName);
        (0, $fUI42.store).value.setups[setupId] = record;
    }
    // Loading a setup's own already-correct timestamp must not itself count
    // as a fresh edit — see suppressAutoTouch's own comment. Cleared on
    // nextTick rather than synchronously right after, since the auto-touch
    // watcher below is deep and async: it wouldn't actually run (and see
    // this flag) until after this function has already returned.
    $bfc59006cf644cf7$var$suppressAutoTouch = true;
    $bfc59006cf644cf7$var$inputs.sight_settings = $euiHy.SightSettings.fromJson(record.sight_settings);
    $bfc59006cf644cf7$var$inputs.marks = $euiHy.Marks.fromJson(record.marks).marks;
    $bfc59006cf644cf7$var$inputs.description = record.description ?? '';
    const fresh = (0, $fUI42.isCalcFresh)(record.calc);
    $bfc59006cf644cf7$var$computedResult.value = fresh ? $euiHy.Calculated.fromJson(record.calc) : new $euiHy.Calculated();
    $bfc59006cf644cf7$var$isStale.value = !fresh;
    $bfc59006cf644cf7$var$setupUpdatedAt.value = record.updated_at ?? 0;
    $bfc59006cf644cf7$export$ef1cad4434ac7a90($bfc59006cf644cf7$var$inputs);
    $bfc59006cf644cf7$var$computeError.value = null;
    (0, $TusQn.nextTick)(()=>{
        $bfc59006cf644cf7$var$suppressAutoTouch = false;
    });
    // Switching setups (or loading one after login) never runs compute() here,
    // even when it loads stale — that's a synchronous, potentially slow solve
    // (calc.js's bisection search) that would block the switch itself on the
    // main thread, which is exactly backwards for something that should just
    // be swapping which setup's already-known data is on screen. A setup
    // pulled from the server or imported from a file now carries its sender's
    // own already-computed fit (see exportSetupJson/applySetupData), so this
    // is only ever actually stale for a setup that genuinely has never been
    // computed against these inputs by anyone — which surfaces as the
    // ordinary "click Recompute" prompt, same as any other stale edit.
    $bfc59006cf644cf7$var$lastComputedSnapshot = $bfc59006cf644cf7$var$isStale.value ? null : $bfc59006cf644cf7$var$snapshotInputs();
    $bfc59006cf644cf7$var$lastCommittedSnapshot = $bfc59006cf644cf7$var$snapshotInputs();
    $bfc59006cf644cf7$var$undoStack = record.undo?.stack ?? [];
    $bfc59006cf644cf7$var$redoStack = record.undo?.redo ?? [];
    $bfc59006cf644cf7$var$canUndo.value = $bfc59006cf644cf7$var$undoStack.length > 0;
    $bfc59006cf644cf7$var$canRedo.value = $bfc59006cf644cf7$var$redoStack.length > 0;
    $bfc59006cf644cf7$var$setupLoadedListeners.forEach((fn)=>fn(setupId));
}
function $bfc59006cf644cf7$export$97cbd2ec45ae44d(setupId) {
    const record = setupId === $bfc59006cf644cf7$var$currentSetupId ? {
        name: (0, $fUI42.store).value.setups[setupId]?.name,
        sight_settings: $bfc59006cf644cf7$var$inputs.sight_settings,
        marks: $bfc59006cf644cf7$var$inputs.marks,
        description: $bfc59006cf644cf7$var$inputs.description,
        updated_at: $bfc59006cf644cf7$var$setupUpdatedAt.value
    } : (0, $fUI42.store).value.setups[setupId];
    return JSON.stringify({
        name: record.name,
        sight_settings: record.sight_settings,
        marks: record.marks,
        description: record.description ?? '',
        updated_at: record.updated_at
    }, null, 2);
}
function $bfc59006cf644cf7$export$6d94635e6a828274(id) {
    if (id === $bfc59006cf644cf7$var$currentSetupId) return $bfc59006cf644cf7$var$isStale.value ? null : $bfc59006cf644cf7$var$computedResult.value.toJSON();
    return (0, $fUI42.store).value.setups[id]?.calc ?? null;
}
function $bfc59006cf644cf7$export$4f79f7fa389a6d0a(json) {
    let parsed;
    try {
        parsed = JSON.parse(json);
    } catch  {
        throw new Error('Not valid JSON.');
    }
    if (!parsed || typeof parsed !== 'object' || !parsed.sight_settings || !Array.isArray(parsed.marks)) throw new Error('Missing "sight_settings" or "marks" \u2014 this doesn\'t look like a sight marks export.');
    // Validate/normalize through the model classes — a bad Mark should
    // reject the whole import rather than land partially applied.
    return {
        sight_settings: $euiHy.SightSettings.fromJson(parsed.sight_settings),
        marks: $euiHy.Marks.fromJson(parsed.marks).marks,
        description: parsed.description ?? ''
    };
}
function $bfc59006cf644cf7$export$7a5e25a22635a354(setupId, { name: name, sight_settings: sight_settings, marks: marks, description: description, updated_at: updated_at, calc: calcValue } = {}) {
    if (setupId === $bfc59006cf644cf7$var$currentSetupId) {
        if (name != null) {
            const record = (0, $fUI42.store).value.setups[setupId];
            if (record) record.name = name;
        }
        // A caller passing its own updated_at (sync.js pulling a remote setup)
        // is handing us an authoritative timestamp to adopt as-is — the
        // auto-touch watcher must not then stamp its own Date.now() over it.
        // A plain file import (input_setups.vue) never passes one, and *should*
        // get a fresh touch here: it's a genuine new local change with nothing
        // else to date it by.
        const hasAuthoritativeTimestamp = updated_at != null;
        if (hasAuthoritativeTimestamp) $bfc59006cf644cf7$var$suppressAutoTouch = true;
        Object.assign($bfc59006cf644cf7$var$inputs.sight_settings, sight_settings);
        // marks may be plain JSON (sync.js pulling a remote setup straight off
        // the wire) rather than actual Mark instances — fromJson is idempotent
        // over already-hydrated Marks too, so normalizing unconditionally here
        // guarantees inputs.marks always has real instances with methods like
        // inM(), rather than only working by luck when a caller happened to
        // pre-hydrate (see the graph/inM() panel bug this was causing).
        $bfc59006cf644cf7$var$inputs.marks.splice(0, $bfc59006cf644cf7$var$inputs.marks.length, ...$euiHy.Marks.fromJson(marks).marks);
        $bfc59006cf644cf7$var$inputs.description = description ?? '';
        if (hasAuthoritativeTimestamp) {
            $bfc59006cf644cf7$var$setupUpdatedAt.value = updated_at;
            (0, $TusQn.nextTick)(()=>{
                $bfc59006cf644cf7$var$suppressAutoTouch = false;
            });
        }
        if (calcValue !== undefined) {
            if (calcValue != null) {
                // calcValue is always plain JSON here (sync.js's only caller passes
                // remote.data.calc straight off the wire) rather than an actual
                // Calculated instance — hydrate it the same way loadSetup does,
                // rather than assigning the raw object directly (see the marks
                // splice below, and the inM() bug that exact mistake caused before).
                $bfc59006cf644cf7$var$computedResult.value = $euiHy.Calculated.fromJson(calcValue);
                $bfc59006cf644cf7$var$lastComputedSnapshot = $bfc59006cf644cf7$var$snapshotInputs();
                $bfc59006cf644cf7$var$isStale.value = false;
            } else {
                $bfc59006cf644cf7$var$lastComputedSnapshot = null;
                $bfc59006cf644cf7$var$isStale.value = true;
            }
        }
        // The persistence watcher above mirrors inputs/isStale/computedResult/
        // setupUpdatedAt into store.value.setups[currentSetupId] on its own —
        // nothing to write into the store directly here.
        return;
    }
    const existing = (0, $fUI42.store).value.setups[setupId];
    (0, $fUI42.store).value.setups[setupId] = {
        name: name ?? existing?.name ?? 'Setup',
        sight_settings: sight_settings,
        marks: marks,
        description: description ?? existing?.description ?? '',
        calc: calcValue ?? null,
        updated_at: updated_at ?? existing?.updated_at ?? Date.now(),
        undo: existing?.undo ?? {
            stack: [],
            redo: []
        }
    };
}
function $bfc59006cf644cf7$export$652eac7113c0e2dd() {
    return {
        inputs: $bfc59006cf644cf7$var$inputs,
        computedResult: $bfc59006cf644cf7$var$computedResult,
        isStale: $bfc59006cf644cf7$var$isStale,
        computeError: $bfc59006cf644cf7$var$computeError,
        isComputing: $bfc59006cf644cf7$var$isComputing,
        recompute: $bfc59006cf644cf7$var$recompute,
        undo: $bfc59006cf644cf7$var$undo,
        redo: $bfc59006cf644cf7$var$redo,
        canUndo: $bfc59006cf644cf7$var$canUndo,
        canRedo: $bfc59006cf644cf7$var$canRedo,
        getLevelMarksTable: $bfc59006cf644cf7$export$c39d5ec3907345f3,
        lookupLevelMark: $bfc59006cf644cf7$export$4191bae190cb9107
    };
}

});
parcelRegister("fUI42", function(module, exports) {

$parcel$export(module.exports, "genId", () => $b95e4438797d8203$export$87d45d9755ebb726);
$parcel$export(module.exports, "isCalcFresh", () => $b95e4438797d8203$export$2676e25bd2f2a0a4);
$parcel$export(module.exports, "createDefaultRecord", () => $b95e4438797d8203$export$846ea92b7d4581da);
$parcel$export(module.exports, "store", () => $b95e4438797d8203$export$6f57813fe9f31bf9);
// The single localStorage entry every setup for this browser lives in — one
// key, instead of the old one-key-per-field-per-setup layout (setups-index,
// active-setup-id, and a separate setup:<id>:data/setup:<id>:undo-history
// pair for every setup — see migrate() below). state.js reads/writes the
// currently-active setup's record here on every edit; setups.js reads/
// writes it for create/rename/delete/list. Both are just mutations on the
// same reactive object, so any page that imports this module sees live,
// consistent data — unlike the old design, where a setup's data only
// became reactive/correct once state.js's loadSetup() had actually run at
// least once *on that specific page* (the separate /setups/ management
// page's own bundle never called it, which is what made rename/delete
// there unreliable).

var $hYNgF = parcelRequire("hYNgF");

var $euiHy = parcelRequire("euiHy");

var $jXSGI = parcelRequire("jXSGI");
const $b95e4438797d8203$var$STORE_KEY = 'setups-store';
function $b95e4438797d8203$export$87d45d9755ebb726() {
    return globalThis.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
}
function $b95e4438797d8203$export$2676e25bd2f2a0a4(calc) {
    return calc != null && calc.calculator_version === (0, $euiHy.CALCULATOR_VERSION);
}
function $b95e4438797d8203$export$846ea92b7d4581da(name) {
    const now = Date.now();
    return {
        name: name,
        sight_settings: {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jXSGI))).sight_settings,
            updated_at: now
        },
        marks: (0, (/*@__PURE__*/$parcel$interopDefault($jXSGI))).marks.map((m)=>({
                ...m,
                updated_at: now
            })),
        description: '',
        calc: {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jXSGI))).calc,
            calculator_version: (0, $euiHy.CALCULATOR_VERSION)
        },
        updated_at: now,
        undo: {
            stack: [],
            redo: []
        }
    };
}
// ── One-time migration from the old per-key-per-setup layout ──
//
// Old layout: 'setups-index' (an id array) + 'active-setup-id', and per id
// 'setup:<id>:data' / 'setup:<id>:undo-history' (see the old setup_keys.js's
// scopedKey — still used elsewhere for unrelated per-setup UI scratch state,
// see mark.vue/full_marks.vue/trajectory.vue, but no longer for this core
// data). Older still: a single flat 'sight_settings_and_marks' key from
// before multi-setup support existed at all — folded straight into the new
// shape here rather than through that old migration's own intermediate
// per-key form.
function $b95e4438797d8203$var$migrate() {
    if ((0, $hYNgF.readJSON)($b95e4438797d8203$var$STORE_KEY, null) !== null) return;
    const oldIndex = (0, $hYNgF.readJSON)('setups-index', null);
    if (oldIndex === null) {
        const legacy = (0, $hYNgF.readJSON)('sight_settings_and_marks', null);
        if (legacy !== null) {
            const id = $b95e4438797d8203$export$87d45d9755ebb726();
            (0, $hYNgF.writeJSON)($b95e4438797d8203$var$STORE_KEY, {
                activeId: id,
                setups: {
                    [id]: {
                        name: 'Default',
                        sight_settings: legacy.sight_settings,
                        marks: legacy.marks,
                        calc: null,
                        updated_at: Date.now(),
                        undo: {
                            stack: [],
                            redo: []
                        }
                    }
                }
            });
            localStorage.removeItem('sight_settings_and_marks');
            return;
        }
        // Truly fresh install — nothing to migrate, bootstrap one default setup.
        const id = $b95e4438797d8203$export$87d45d9755ebb726();
        (0, $hYNgF.writeJSON)($b95e4438797d8203$var$STORE_KEY, {
            activeId: id,
            setups: {
                [id]: $b95e4438797d8203$export$846ea92b7d4581da('Default')
            }
        });
        return;
    }
    // Defensive: a bug in an earlier build could in principle have pushed a
    // non-string entry into 'setups-index' (an object id would otherwise get
    // silently coerced to the literal key "[object Object]" below) — skip
    // anything that isn't a real id rather than migrating garbage forward.
    const validIds = oldIndex.filter((id)=>typeof id === 'string' && id.length > 0);
    const setups = {};
    for (const id of validIds){
        const data = (0, $hYNgF.readJSON)(`setup:${id}:data`, null);
        const undo = (0, $hYNgF.readJSON)(`setup:${id}:undo-history`, null);
        setups[id] = data ? {
            name: data.name ?? 'Setup',
            sight_settings: data.sight_settings,
            marks: data.marks,
            calc: (data.calculator_version ?? 0) === (0, $euiHy.CALCULATOR_VERSION) && data.calc != null ? {
                ...data.calc,
                calculator_version: (0, $euiHy.CALCULATOR_VERSION)
            } : null,
            updated_at: data.updated_at ?? 0,
            undo: undo ?? {
                stack: [],
                redo: []
            }
        } : $b95e4438797d8203$export$846ea92b7d4581da('Setup');
    }
    // Clean up every old per-id key regardless of validity — a garbage
    // entry's own setup:<id>:* keys (if it somehow had any) are just as
    // stale as a valid one's.
    for (const id of oldIndex){
        localStorage.removeItem(`setup:${id}:data`);
        localStorage.removeItem(`setup:${id}:undo-history`);
    }
    let activeId = (0, $hYNgF.readJSON)('active-setup-id', null);
    if (typeof activeId !== 'string' || !setups[activeId]) activeId = validIds[0];
    if (!activeId) {
        // Every entry in oldIndex was garbage — fall back to one fresh setup
        // rather than ending up with an empty store.
        activeId = $b95e4438797d8203$export$87d45d9755ebb726();
        setups[activeId] = $b95e4438797d8203$export$846ea92b7d4581da('Default');
    }
    (0, $hYNgF.writeJSON)($b95e4438797d8203$var$STORE_KEY, {
        activeId: activeId,
        setups: setups
    });
    localStorage.removeItem('setups-index');
    localStorage.removeItem('active-setup-id');
}
$b95e4438797d8203$var$migrate();
const $b95e4438797d8203$export$6f57813fe9f31bf9 = (0, $hYNgF.usePersisted)($b95e4438797d8203$var$STORE_KEY, {
    activeId: null,
    setups: {}
});

});
parcelRegister("jXSGI", function(module, exports) {
module.exports = JSON.parse("{\"sight_settings\":{\"eye_to_sight\":1020,\"arrow_to_eye\":110,\"vertical_tpi\":24,\"horizontal_tpi\":32,\"sight_scale\":10,\"clicks_per_turn\":20,\"sight_bar_spacing\":12.7,\"sight_bar_position\":1,\"updated_at\":null},\"marks\":[{\"distance\":30,\"unit\":\"m\",\"mark\":2,\"sight_bar_position\":1,\"updated_at\":null},{\"distance\":50,\"unit\":\"m\",\"mark\":4.5,\"sight_bar_position\":1,\"updated_at\":null},{\"distance\":70,\"unit\":\"m\",\"mark\":7.5,\"sight_bar_position\":1,\"updated_at\":null}],\"calc\":{\"calc_v\":68.5828515229382,\"calc_c\":0.00488908795318635,\"calc_offset\":-1.6894103675,\"calc_fit\":0.00020379168355622035,\"calculator_version\":2}}");

});


parcelRegister("bWZV2", function(module, exports) {

$parcel$export(module.exports, "scopedKey", () => $8b35244d72e5af88$export$a56e1ed2a64cd1ce);
// Namespaces a per-setup localStorage key off a setup id. Split out from
// setups.js so state.js can build its own storage key without importing
// setups.js (which itself imports state.js's loadSetup) — keeps that
// relationship one-directional instead of circular.
function $8b35244d72e5af88$export$a56e1ed2a64cd1ce(base, setupId) {
    return `setup:${setupId}:${base}`;
}

});


parcelRegister("gK4GT", function(module, exports) {

$parcel$export(module.exports, "onSetupChanged", () => $c30494bacf288c71$export$ee446fe90931a482);
$parcel$export(module.exports, "onSetupDeleted", () => $c30494bacf288c71$export$3c983637ada0c404);
$parcel$export(module.exports, "initSetups", () => $c30494bacf288c71$export$a358f2a2fd8c208d);
$parcel$export(module.exports, "useSetups", () => $c30494bacf288c71$export$145ff7f171c2b134);
$parcel$export(module.exports, "scopedKey", () => (parcelRequire("bWZV2")).scopedKey);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");

var $fUI42 = parcelRequire("fUI42");

var $bWZV2 = parcelRequire("bWZV2");

var $gsNnp = parcelRequire("gsNnp");
// Read-only, derived for display (the header dropdown's <select>, the
// Setups panel table) — store.value.setups is a plain reactive object now,
// so this is always live, on any page that imports this module, with no
// manual "please re-check localStorage" nudge needed (the old setupsVersion
// existed purely to work around a non-active setup's name living behind a
// plain, non-reactive localStorage read).
const $c30494bacf288c71$var$setups = (0, $TusQn.computed)(()=>Object.keys((0, $fUI42.store).value.setups).map((id)=>({
            id: id,
            name: (0, $fUI42.store).value.setups[id].name
        })));
const $c30494bacf288c71$var$activeSetupId = (0, $TusQn.computed)(()=>(0, $fUI42.store).value.activeId);
// The remaining per-setup keys that live outside the consolidated store —
// scratch UI state for the single-mark/full-marks/graph/trajectory forms
// (see mark.vue/full_marks.vue/graph.vue/trajectory.vue). Unrelated to a
// setup's actual sight_settings/marks/calc, so there's no reason to fold
// them into the synced record; they just need cleaning up alongside it.
function $c30494bacf288c71$var$deleteScopedStorage(id) {
    for (const base of [
        'mark-inputs',
        'full-marks-inputs',
        'graph-inputs',
        'trajectory-inputs',
        'sight-tape-inputs'
    ])localStorage.removeItem((0, $bWZV2.scopedKey)(base, id));
}
// fallbackName only matters the first time a brand new id is loaded (see
// createSetup) — an existing setup already has a real name in its own
// record, so ordinary switches never need it.
function $c30494bacf288c71$var$selectSetup(id, fallbackName) {
    if (id === (0, $fUI42.store).value.activeId) return;
    (0, $fUI42.store).value.activeId = id;
    (0, $gsNnp.loadSetup)(id, fallbackName);
}
// sync.js subscribes here to push a create/rename immediately rather than
// waiting out the typing-edit debounce — like a finished compute (see
// state.js's onComputeFinished), these are single, discrete actions, not a
// burst of keystrokes. Deliberately not reused for delete, which already
// has its own listener below with different (queue-if-offline) semantics.
const $c30494bacf288c71$var$changeListeners = new Set();
function $c30494bacf288c71$export$ee446fe90931a482(fn) {
    $c30494bacf288c71$var$changeListeners.add(fn);
}
function $c30494bacf288c71$var$createSetup(name) {
    const id = (0, $fUI42.genId)();
    (0, $fUI42.store).value.setups[id] = (0, $fUI42.createDefaultRecord)(name);
    $c30494bacf288c71$var$selectSetup(id, name);
    $c30494bacf288c71$var$changeListeners.forEach((fn)=>fn(id));
    return id;
}
// Renames a setup by id — a plain mutation on the store, the same for the
// active setup or any other one (no more "live inputs vs. raw localStorage"
// branch: the store IS the reactive source of truth either way now).
// updated_at is bumped directly, unconditionally, rather than only via
// touchActiveSetup() — this file's own `store` is reactive on *every* page
// that imports it, but state.js's live mirror (and the persistence watcher
// that would otherwise carry a touchActiveSetup() bump into the store) only
// exists where loadSetup() has actually run, which the separate /setups/
// management page's bundle never does (see its main.js). touchActiveSetup()
// is still called too, best-effort, for whichever page *does* have the live
// mirror open (the calculator page) — purely so a later, unrelated
// persistence-watcher write (e.g. from a recompute) doesn't overwrite this
// setup's record using its own now-stale copy of setupUpdatedAt.
function $c30494bacf288c71$var$renameSetup(id, name) {
    const record = (0, $fUI42.store).value.setups[id];
    record.name = name;
    record.updated_at = Date.now();
    if (id === (0, $fUI42.store).value.activeId) (0, $gsNnp.touchActiveSetup)();
    $c30494bacf288c71$var$changeListeners.forEach((fn)=>fn(id));
}
// sync.js subscribes here (rather than sync.js importing this file's
// deleteSetup directly and this file importing sync.js, which would be
// circular) so a local delete can be pushed to the server without this file
// knowing anything about fetch/auth. { silent: true } skips the
// notification — used when sync.js itself is the one driving the deletion (a
// setup that vanished from another device), so it doesn't turn around and
// try to delete-on-server something the server already doesn't have.
const $c30494bacf288c71$var$deleteListeners = new Set();
function $c30494bacf288c71$export$3c983637ada0c404(fn) {
    $c30494bacf288c71$var$deleteListeners.add(fn);
}
function $c30494bacf288c71$var$deleteSetup(id, { silent: silent = false } = {}) {
    const ids = Object.keys((0, $fUI42.store).value.setups);
    if (ids.length <= 1) return false; // always keep at least one setup around
    if (!(id in (0, $fUI42.store).value.setups)) return false;
    delete (0, $fUI42.store).value.setups[id];
    $c30494bacf288c71$var$deleteScopedStorage(id);
    if ((0, $fUI42.store).value.activeId === id) $c30494bacf288c71$var$selectSetup(Object.keys((0, $fUI42.store).value.setups)[0]);
    if (!silent) $c30494bacf288c71$var$deleteListeners.forEach((fn)=>fn(id));
    return true;
}
function $c30494bacf288c71$export$a358f2a2fd8c208d() {
    if (!((0, $fUI42.store).value.activeId in (0, $fUI42.store).value.setups)) (0, $fUI42.store).value.activeId = Object.keys((0, $fUI42.store).value.setups)[0] ?? null;
    (0, $gsNnp.loadSetup)((0, $fUI42.store).value.activeId);
}
// Wipes every local setup and replaces the whole index in one go — used
// when switching identity (login, register, logout; see sync.js's
// loadFreshAfterLogin and account_widget.vue's onLogout), where nothing
// from whatever this browser had locally before should carry over or get
// merged into the new state. `newIds` is just ids — callers are expected to
// have already written each new setup's own record (including its name,
// via state.js's applySetupData) before calling this; it only swaps which
// ids are known/active and loads whichever one ends up active. An empty
// `newIds` falls back to one bare bootstrap setup — the same shape a fresh
// install starts with — so the app always has something to show.
function $c30494bacf288c71$var$replaceAllSetups(newIds, activeId) {
    for (const id of Object.keys((0, $fUI42.store).value.setups))$c30494bacf288c71$var$deleteScopedStorage(id);
    if (newIds.length === 0) {
        const id = (0, $fUI42.genId)();
        (0, $fUI42.store).value.setups = {
            [id]: (0, $fUI42.createDefaultRecord)('Default')
        };
        (0, $fUI42.store).value.activeId = id;
    } else {
        const kept = {};
        for (const id of newIds)kept[id] = (0, $fUI42.store).value.setups[id];
        (0, $fUI42.store).value.setups = kept;
        (0, $fUI42.store).value.activeId = activeId;
    }
    (0, $gsNnp.loadSetup)((0, $fUI42.store).value.activeId);
}
function $c30494bacf288c71$export$145ff7f171c2b134() {
    return {
        setups: $c30494bacf288c71$var$setups,
        activeSetupId: $c30494bacf288c71$var$activeSetupId,
        createSetup: $c30494bacf288c71$var$createSetup,
        deleteSetup: $c30494bacf288c71$var$deleteSetup,
        selectSetup: $c30494bacf288c71$var$selectSetup,
        renameSetup: $c30494bacf288c71$var$renameSetup,
        replaceAllSetups: $c30494bacf288c71$var$replaceAllSetups
    };
}

});

parcelRegister("5xJ83", function(module, exports) {

$parcel$export(module.exports, "apiFetch", () => $40930a80e3207c3a$export$5341712c39afc62d);
$parcel$export(module.exports, "useSync", () => $40930a80e3207c3a$export$d85aed67e7fca1e6);
// Optional sync between localStorage and the server's per-user setups
// table — never required for the app to work (see auth.js), and never
// runs unless the caller is logged in via useAuth(). Kept separate from
// both setups.js (owns the setup index) and state.js (owns the live
// active-setup data) since this is a third, purely network-orchestration
// concern that shouldn't teach either of those about fetch/auth.
//
// The DB is treated as the source of truth once logged in: sync runs
// automatically on page load and whenever the browser regains connectivity
// (see account_widget.vue's onMounted/online handler), not just on login
// and the manual "Sync now" button — which itself only shows up when
// there's a local change to push (see hasLocalChanges below); a change
// made on another device is picked up automatically, so the fix for that
// is just reloading the page, not this button. Deletions propagate too —
// deleting a setup on one device deletes it everywhere else on their next
// sync — via knownServerState, a persisted { [id]: updated_at } record of
// what this browser last saw on the server: anything whose id drops out of
// the server's list between syncs is treated as deleted, and anything this
// device deletes locally is queued (pendingDeletes, also persisted so it
// survives being offline across a reload) and pushed as soon as a sync can
// reach the server. Still whole-setup last-write-wins for edits, not a
// merge: if both sides changed the same setup since the last sync, one of
// the two edits is lost.
//
// The one exception to all of the above is the login/register transition
// itself (see loadFreshAfterLogin below): whatever this browser had
// locally right before authenticating is never merged into, or pushed
// onto, the account just logged into — it's discarded, and the account's
// own setups replace it outright. Regular syncAll()'s pull-then-push only
// takes over from the next sync onward, once the local and server state
// are known to belong to the same identity.
//
// Beyond page-load/reconnect/button, a logged-in session also auto-syncs
// after any local edit. Only raw sight_settings/marks typing goes through a
// debounce (see scheduleAutoSync below) — 100ms of quiet, just enough to
// coalesce a fast typist's individual keystrokes into one request, not a
// deliberate delay. Every other trigger (a finished compute, a rename,
// create, or delete, logging out) is a single discrete action with nothing
// else coming right behind it, so each pushes immediately via syncNow()
// instead of waiting out that debounce. This all reuses syncAll() itself,
// so every path is automatically subject to the same guards (logged-in
// check, first-sync ordering) and never throws back to a watcher or blocks
// editing, no matter how it goes.
//
// Every one of those triggers — the debounce, page load, reconnect, a
// delete's immediate push, the best-effort sync before logging out — is
// automated, not something the user directly asked for right now, so none
// of them ever produce a toast: syncAll()'s `silent` param (true by
// default) suppresses feedback for both success and failure alike. Only an
// explicit action gets to report its own outcome — the "Sync now" button
// (see account_widget.vue's onSync) passes `silent: false` and shows
// "Sync complete."/a failure message every time it's pressed, and
// loadFreshAfterLogin (login/register) reports its own failure the same
// way when called directly rather than via syncAll's fallback below.
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $gK4GT = parcelRequire("gK4GT");

var $aCKYX = parcelRequire("aCKYX");

var $gsNnp = parcelRequire("gsNnp");

var $lTXzM = parcelRequire("lTXzM");

var $hYNgF = parcelRequire("hYNgF");

var $boWEz = parcelRequire("boWEz");
const { pushToast: $40930a80e3207c3a$var$pushToast } = (0, $boWEz.useToasts)();
// { [setupId]: updated_at } this browser last confirmed the server has, for
// the currently-logged-in account — used both to tell "deleted on the
// server since last time" apart from "created locally, never pushed yet"
// (pullAll), and to tell "has local edits since last sync" for the
// "Sync now" button's visibility (hasLocalChanges below). Cleared on
// logout (see resetSyncState) so switching accounts on one browser can't
// misread the new account's setups against the old account's history.
const $40930a80e3207c3a$var$knownServerState = (0, $hYNgF.usePersisted)('sync-known-server-state', {});
// Ids queued for a server-side DELETE — populated by the onSetupDeleted
// hook below, drained by flushPendingDeletes. Persisted so a deletion made
// while offline still reaches the server once a sync succeeds, even across
// a page reload in between.
const $40930a80e3207c3a$var$pendingDeletes = (0, $hYNgF.usePersisted)('sync-pending-deletes', []);
// Separate from knownServerState being non-empty: a brand new account with
// nothing saved yet legitimately pulls zero setups on its first sync, which
// would leave knownServerState looking exactly like "never synced" forever
// (see syncAll's guard) — this flag is the actual "has loadFreshAfterLogin
// run for the current login" marker, set regardless of how many setups
// came back.
const $40930a80e3207c3a$var$hasCompletedFirstSync = (0, $hYNgF.usePersisted)('sync-first-sync-done', false);
// Whether the most recent sync attempt (of any kind — pull, push, or a
// queued delete) succeeded — tracked here so it survives a reload, even
// though nothing currently gates a toast on it (see reportFailure below;
// every automated trigger is silent regardless of this flag's value).
const $40930a80e3207c3a$var$lastSyncOk = (0, $hYNgF.usePersisted)('sync-last-ok', true);
// Call this from every network-failure site in this file instead of
// pushToast directly — `silent` (threaded down from whatever triggered the
// sync; see the file header) is what decides whether the user actually
// sees it, not this flag's history.
function $40930a80e3207c3a$var$reportFailure(message, silent) {
    $40930a80e3207c3a$var$lastSyncOk.value = false;
    if (!silent) $40930a80e3207c3a$var$pushToast(message);
}
// Debounced auto-sync on every keystroke-level edit (see the file header).
// 100ms of quiet is enough to coalesce a fast typist's individual
// keystrokes into one request without needing to wait long enough to
// *feel* like a delay — sight_settings/marks fields are the one thing that
// still fires this rapidly; every other trigger (compute finishing,
// rename/create/delete, logout) goes straight to syncNow() below instead.
//
// Deliberately watches sight_settings/marks only, not all of `inputs` —
// description is edited freely without pushing anything until the user
// hits the Setup Description panel's own Save button (which calls syncAll
// directly), not on every keystroke like these two fields.
const $40930a80e3207c3a$var$AUTO_SYNC_DEBOUNCE_MS = 100;
let $40930a80e3207c3a$var$autoSyncTimer = null;
function $40930a80e3207c3a$var$scheduleAutoSync() {
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    if (!isLoggedIn.value) return; // skip the timer entirely for the common (guest) case
    clearTimeout($40930a80e3207c3a$var$autoSyncTimer);
    $40930a80e3207c3a$var$autoSyncTimer = setTimeout($40930a80e3207c3a$export$d1e86e2cf4ed4afc, $40930a80e3207c3a$var$AUTO_SYNC_DEBOUNCE_MS);
}
const { inputs: $40930a80e3207c3a$var$autoSyncInputs } = (0, $gsNnp.useShared)();
(0, $TusQn.watch)([
    ()=>$40930a80e3207c3a$var$autoSyncInputs.sight_settings,
    ()=>$40930a80e3207c3a$var$autoSyncInputs.marks
], $40930a80e3207c3a$var$scheduleAutoSync, {
    deep: true
});
// Cancels any pending debounced sync and runs one right now instead —
// used for discrete, one-off actions (a delete, a rename/create, a finished
// compute) that have nothing more coming right behind them, unlike a burst
// of keystrokes. Automated, so silent (the default) either way.
function $40930a80e3207c3a$var$syncNow() {
    clearTimeout($40930a80e3207c3a$var$autoSyncTimer);
    $40930a80e3207c3a$export$d1e86e2cf4ed4afc();
}
(0, $gK4GT.onSetupDeleted)((id)=>{
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    if (!isLoggedIn.value) return;
    if (!$40930a80e3207c3a$var$pendingDeletes.value.includes(id)) $40930a80e3207c3a$var$pendingDeletes.value.push(id);
    // Best-effort immediate push rather than waiting for the next scheduled
    // sync (page load / regained connectivity / manual button) — a delete is
    // the one edit users most want to see everywhere right away. Falls back
    // fine if this fails (offline, etc.): it's still queued above, and the
    // next successful sync picks it up.
    $40930a80e3207c3a$var$syncNow();
});
// A create or rename — see setups.js's onSetupChanged — is as discrete an
// action as a delete, so it gets the same immediate push rather than
// waiting out the typing-edit debounce above.
(0, $gK4GT.onSetupChanged)(()=>$40930a80e3207c3a$var$syncNow());
// A compute finishing (see state.js's onComputeFinished) is likewise a
// single discrete event, not a burst — push it immediately rather than
// making it wait out the same debounce as a still-in-progress typing edit.
(0, $gsNnp.onComputeFinished)(()=>$40930a80e3207c3a$var$syncNow());
function $40930a80e3207c3a$export$d6e0f64c04825ddd() {
    clearTimeout($40930a80e3207c3a$var$autoSyncTimer); // a pending auto-sync belongs to whatever identity is being left behind
    $40930a80e3207c3a$var$knownServerState.value = {};
    $40930a80e3207c3a$var$pendingDeletes.value = [];
    $40930a80e3207c3a$var$hasCompletedFirstSync.value = false;
    $40930a80e3207c3a$var$lastSyncOk.value = true;
}
// A setup's own last-write-wins timestamp (state.js's setupUpdatedAt,
// bumped by touchActiveSetup/setups.js's renameSetup) travels inside
// exportSetupJson's own output now, alongside its name — see that
// function's comment. This
// used to be derived here instead, by scanning sight_settings' and every
// mark's own updated_at (which exist purely for the user's own "updated 3m
// ago" labels, not for sync) and separately max'd against a setup-name
// timestamp; one clear field replaces both. `backfillTimestamps` is still
// called before a push so a setup that's never been made active locally
// (every per-field timestamp still null) doesn't ship nulls to the server —
// that's just display hygiene for whoever pulls it next, unrelated to the
// timestamp used for the conflict check itself.
// No AbortController/timeout here used to mean a request to an unreachable
// or hung backend (a dead dev-server proxy target, a stalled connection —
// unlike a plain connection refusal, which fetch rejects almost instantly)
// could sit unresolved indefinitely. Every sync attempt is already
// fire-and-forget from the caller's side (see the file header), so nothing
// upstream was literally frozen by this, but a sync that never resolves
// also never reports failure or gets a chance to retry — capping it here
// means the worst case is "one attempt takes up to 10s then fails/retries
// on the next trigger," not "silently stuck forever."
const $40930a80e3207c3a$var$API_FETCH_TIMEOUT_MS = 10000;
async function $40930a80e3207c3a$export$5341712c39afc62d(path, options = {}) {
    const { authHeader: authHeader, logout: logout } = (0, $aCKYX.useAuth)();
    const controller = new AbortController();
    const timeout = setTimeout(()=>controller.abort(), $40930a80e3207c3a$var$API_FETCH_TIMEOUT_MS);
    let res;
    try {
        res = await fetch(`${(0, $lTXzM.getServerUrl)()}${path}`, {
            ...options,
            signal: controller.signal,
            headers: {
                'Content-Type': 'application/json',
                ...authHeader(),
                ...options.headers || {}
            }
        });
    } catch (err) {
        if (err.name === 'AbortError') throw new Error(`Request to ${path} timed out.`);
        throw err;
    } finally{
        clearTimeout(timeout);
    }
    if (res.status === 401) {
        logout();
        $40930a80e3207c3a$export$d6e0f64c04825ddd();
        // Same reasoning as account_widget.vue's onLogout: a 401 means this
        // browser's session belongs to an identity that no longer checks out
        // (expired token, or the account itself is gone — e.g. the server's DB
        // was reset), so whatever setups are cached locally belong to that
        // stale identity too and must not survive into whatever logs in next.
        // Without this, registering a brand-new account right after a 401
        // would hand it someone else's (or a deleted account's) old setups via
        // registerAndKeepLocal, which just pushes setups.value[0] as-is.
        const { replaceAllSetups: replaceAllSetups } = (0, $gK4GT.useSetups)();
        replaceAllSetups([], null);
        throw new Error("Session expired \u2014 please log in again.");
    }
    const body = await res.json().catch(()=>({}));
    if (!res.ok) {
        const err = new Error(body.error || `Request to ${path} failed.`);
        err.status = res.status;
        throw err;
    }
    return body;
}
// Pushes every queued deletion. A 404 means the server already agrees it's
// gone (either it beat us to it, or it never made it there in the first
// place) — treated as success rather than an error. Returns whether every
// deletion in the queue is now confirmed gone (used by syncAll to decide
// whether this run counts as fully clean).
async function $40930a80e3207c3a$var$flushPendingDeletes(silent) {
    if (!$40930a80e3207c3a$var$pendingDeletes.value.length) return true;
    let allOk = true;
    const stillPending = [];
    for (const id of $40930a80e3207c3a$var$pendingDeletes.value)try {
        await $40930a80e3207c3a$export$5341712c39afc62d(`/setups/${encodeURIComponent(id)}`, {
            method: 'DELETE'
        });
    } catch (err) {
        if (err.status === 404) continue;
        stillPending.push(id);
        allOk = false;
        $40930a80e3207c3a$var$reportFailure(`Could not delete a setup on the server yet: ${err.message}`, silent);
    }
    $40930a80e3207c3a$var$pendingDeletes.value = stillPending;
    return allOk;
}
async function $40930a80e3207c3a$var$pullAll() {
    const { setups: setups, deleteSetup: deleteSetup } = (0, $gK4GT.useSetups)();
    const { setups: remoteSetups } = await $40930a80e3207c3a$export$5341712c39afc62d('/setups');
    const remoteIds = new Set(remoteSetups.map((s)=>s.id));
    // Anything we used to see on the server (as of our last successful sync)
    // but no longer do was deleted — by this device or another one logged
    // into the same account — so remove it here too. `silent: true` since
    // this deletion is already reflected server-side; no need to queue
    // another DELETE for it. deleteSetup itself keeps at least one setup
    // around, same guard as a local delete.
    for (const id of Object.keys($40930a80e3207c3a$var$knownServerState.value)){
        if (remoteIds.has(id)) continue;
        deleteSetup(id, {
            silent: true
        });
    }
    for (const remote of remoteSetups){
        // Don't let a pull resurrect something this device just deleted but
        // hasn't successfully told the server about yet.
        if ($40930a80e3207c3a$var$pendingDeletes.value.includes(remote.id)) continue;
        const isNew = !setups.value.some((s)=>s.id === remote.id);
        if (isNew) {
            // applySetupData registers a never-before-seen id on its own (it
            // upserts into the store rather than requiring the id to already
            // exist) without switching the active setup — a background pull
            // shouldn't yank the screen away from whatever the user is currently
            // looking at. `calc` carries over whatever fit the sending device had
            // already computed, so this setup doesn't need its own recompute the
            // first time it's switched to locally.
            (0, $gsNnp.applySetupData)(remote.id, {
                ...remote.data,
                name: remote.name,
                updated_at: remote.updated_at,
                calc: remote.data.calc ?? null
            });
            continue;
        }
        const localData = JSON.parse((0, $gsNnp.exportSetupJson)(remote.id));
        if (remote.updated_at > (localData.updated_at || 0)) (0, $gsNnp.applySetupData)(remote.id, {
            ...remote.data,
            name: remote.name,
            updated_at: remote.updated_at,
            calc: remote.data.calc ?? null
        });
    }
    return remoteSetups;
}
// Returns the server's own confirmed updated_at for this setup after the
// write — not just the value we sent — since the server may have kept an
// even newer value of its own instead of overwriting it (a `written:false`
// response, e.g. a race with another device's sync landing moments
// earlier); recording our own stale guess in that case would make
// hasLocalChanges wrongly think this setup still has unpushed local edits.
async function $40930a80e3207c3a$var$pushSetup(setup) {
    const { name: name, updated_at: updated_at, ...data } = JSON.parse((0, $gsNnp.exportSetupJson)(setup.id));
    (0, $gsNnp.backfillTimestamps)(data);
    // Riding along inside `data` (the server's one opaque JSON blob per
    // setup — see server/db.js) rather than folded into exportSetupJson
    // itself: this is a sync-only add-on, not part of the file export
    // format, so it comes from getSetupCalc instead (see its own comment).
    data.calc = (0, $gsNnp.getSetupCalc)(setup.id);
    const body = await $40930a80e3207c3a$export$5341712c39afc62d(`/setups/${encodeURIComponent(setup.id)}`, {
        method: 'PUT',
        body: JSON.stringify({
            name: name,
            data: data,
            updated_at: updated_at || 0
        })
    });
    return body.updated_at;
}
// Deletes first (so a delete this device already knows about never gets
// re-pushed by the step below), then pulls (so a setup that's newer on
// another device — or deleted there — is reconciled before this device's
// push would clobber or resurrect it), then pushes every remaining local
// setup. knownServerState is refreshed at the end to whatever we've just
// confirmed the server has, so the next sync's deletion diff (and
// hasLocalChanges' dirty check) are both accurate.
// Returns whether this run fully succeeded — callers that give explicit
// feedback for a manual trigger (see account_widget.vue's onSync) need this
// since syncAll deliberately never throws: every failure here is caught and
// reported via reportFailure internally rather than propagated, so
// `await syncAll()` alone can't tell a caller whether anything actually
// worked. `silent` defaults to true (every automated trigger — the
// debounced auto-sync, page load, reconnect, a delete's immediate push,
// the pre-logout attempt — calls this bare); only the "Sync now" button
// passes `{ silent: false }`.
//
// This is the actual work; exported `syncAll` below only decides whether to
// start a new run of this or join one already in flight.
async function $40930a80e3207c3a$var$runSyncAll(silent) {
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    if (!isLoggedIn.value) return true;
    // loadFreshAfterLogin hasn't run yet for whoever is logged in right now —
    // e.g. the very first sync ever on a fresh browser/profile, or resuming
    // an already-valid token after a resetSyncState (logout, a 401, deleting
    // the account) without going through the login form itself. setups.js
    // always has at least one local setup at this point (its own bootstrap
    // "Default", freshly created with blank values and null timestamps if
    // this is genuinely a first run) — treating that as a real local edit and
    // pushing it would create a spurious duplicate "Default" on the server,
    // and backfillTimestamps would stamp it "just now" on every such load
    // since it's never actually been touched. Defer to the same hard replace
    // loadFreshAfterLogin uses instead of merging: nothing local can be
    // meaningfully reconciled with the server yet, so don't try. (Not simply
    // "knownServerState is empty": a brand new account with nothing saved
    // yet legitimately pulls zero setups on its real first sync, which would
    // leave knownServerState looking exactly like "never synced" forever and
    // permanently block this device from ever pushing its first setup.)
    if (!$40930a80e3207c3a$var$hasCompletedFirstSync.value) return await $40930a80e3207c3a$export$a139480ce624735e(silent);
    // A compute can take multiple real seconds for some inputs — wait for it
    // to settle before reading anything to push, so a sync triggered mid-
    // compute (logout, the debounced auto-sync, "Sync now") doesn't push the
    // active setup's still-stale pre-compute value (see waitForComputeIdle's
    // own comment).
    await (0, $gsNnp.waitForComputeIdle)();
    let ranClean = true;
    if (!await $40930a80e3207c3a$var$flushPendingDeletes(silent)) ranClean = false;
    let remoteSetups;
    try {
        remoteSetups = await $40930a80e3207c3a$var$pullAll();
    } catch (err) {
        $40930a80e3207c3a$var$reportFailure(`Sync (pull) failed: ${err.message}`, silent);
        return false;
    }
    const { setups: setups } = (0, $gK4GT.useSetups)();
    const nowKnownState = {};
    for (const remote of remoteSetups)nowKnownState[remote.id] = remote.updated_at;
    for (const setup of setups.value){
        if (!isLoggedIn.value) break; // a 401 above already logged out — stop instead of repeating it per setup
        try {
            const updatedAt = await $40930a80e3207c3a$var$pushSetup(setup);
            nowKnownState[setup.id] = updatedAt;
        } catch (err) {
            ranClean = false;
            $40930a80e3207c3a$var$reportFailure(`Sync failed for "${setup.name}": ${err.message}`, silent);
        }
    }
    $40930a80e3207c3a$var$knownServerState.value = nowKnownState;
    if (ranClean) $40930a80e3207c3a$var$lastSyncOk.value = true;
    return ranClean;
}
// Coalesces overlapping SILENT/automated triggers — page-mount sync, the
// debounced auto-sync, a finished compute, onLogout's pre-sync, and
// syncAll's own !hasCompletedFirstSync fallback into loadFreshAfterLogin —
// into a single in-flight run rather than letting each one launch its own
// full pull-then-push-every-setup cycle. Without this, a slow pull (a flaky
// connection, a cold server) makes several of those triggers' round trips
// stack up strictly sequentially instead of overlapping, since none of them
// previously waited to see if a run was already underway — a single
// login/logout could end up serializing several multi-second cycles back to
// back. A non-silent call (the "Sync now" button; loadFreshAfterLogin's
// direct callers) never joins a silent run's outcome — that run already
// decided its own reportFailure/toast behavior using its own `silent`
// value, so joining it would either swallow or misattribute this call's
// feedback. It instead waits for any in-flight silent run to clear, then
// always executes its own dedicated pass.
let $40930a80e3207c3a$var$inFlightSilentSync = null;
// Mirrors "a silent run is currently in flight" into a reactive ref —
// `inFlightSilentSync` itself is a plain variable holding a Promise, which
// the UI can't watch. Distinct from `!hasCompletedFirstSync` alone: that
// flag stays false for as long as loadFreshAfterLogin hasn't succeeded,
// including *after* a failed attempt has already given up (a 10s fetch
// timeout, offline, a 500) — combining it with this flag is what tells "the
// post-login pull is actively in progress" apart from "it already tried and
// failed, and nothing is retrying it right now" (see isLoadingAfterLogin/
// loginSyncFailed below).
const $40930a80e3207c3a$var$isSilentSyncRunning = (0, $01W3b.ref)(false);
function $40930a80e3207c3a$export$d1e86e2cf4ed4afc({ silent: silent = true } = {}) {
    if (silent) {
        if (!$40930a80e3207c3a$var$inFlightSilentSync) {
            $40930a80e3207c3a$var$isSilentSyncRunning.value = true;
            $40930a80e3207c3a$var$inFlightSilentSync = $40930a80e3207c3a$var$runSyncAll(true).finally(()=>{
                $40930a80e3207c3a$var$inFlightSilentSync = null;
                $40930a80e3207c3a$var$isSilentSyncRunning.value = false;
            });
        }
        return $40930a80e3207c3a$var$inFlightSilentSync;
    }
    return ($40930a80e3207c3a$var$inFlightSilentSync ?? Promise.resolve()).then(()=>$40930a80e3207c3a$var$runSyncAll(false));
}
function $40930a80e3207c3a$export$33b23fc4eda3ad55() {
    $40930a80e3207c3a$export$d6e0f64c04825ddd();
    const { replaceAllSetups: replaceAllSetups } = (0, $gK4GT.useSetups)();
    replaceAllSetups([], null);
}
async function $40930a80e3207c3a$export$a139480ce624735e(silent = false) {
    $40930a80e3207c3a$export$d6e0f64c04825ddd();
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    if (!isLoggedIn.value) return true;
    let remoteSetups;
    try {
        ({ setups: remoteSetups } = await $40930a80e3207c3a$export$5341712c39afc62d('/setups'));
    } catch (err) {
        $40930a80e3207c3a$var$reportFailure(`Could not load your setups: ${err.message}`, silent);
        return false;
    }
    // Write each setup's data to storage before handing the new index over —
    // none of these ids can match whatever's currently "active" locally (they
    // belong to a different, just-authenticated account), so applySetupData
    // always takes its storage-write branch here, never the live-`inputs` one.
    for (const remote of remoteSetups)(0, $gsNnp.applySetupData)(remote.id, {
        ...remote.data,
        name: remote.name,
        updated_at: remote.updated_at,
        calc: remote.data.calc ?? null
    });
    const { replaceAllSetups: replaceAllSetups } = (0, $gK4GT.useSetups)();
    replaceAllSetups(remoteSetups.map((s)=>s.id), remoteSetups[0]?.id ?? null);
    const nowKnownState = {};
    for (const remote of remoteSetups)nowKnownState[remote.id] = remote.updated_at;
    $40930a80e3207c3a$var$knownServerState.value = nowKnownState;
    // Set even when remoteSetups is empty (a brand new account) — that's a
    // legitimate, fully-reconciled state too, not "still needs a first sync."
    $40930a80e3207c3a$var$hasCompletedFirstSync.value = true;
    $40930a80e3207c3a$var$lastSyncOk.value = true;
    return true;
}
function $40930a80e3207c3a$export$6b6d6fe2323c241c() {
    $40930a80e3207c3a$export$d6e0f64c04825ddd();
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    if (!isLoggedIn.value) return;
    $40930a80e3207c3a$var$hasCompletedFirstSync.value = true;
}
const $40930a80e3207c3a$export$b40ce323ba164fb1 = (0, $TusQn.computed)(()=>{
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    if (!isLoggedIn.value) return false;
    if ($40930a80e3207c3a$var$pendingDeletes.value.length > 0) return true;
    const { setups: setups } = (0, $gK4GT.useSetups)();
    return setups.value.some((setup)=>{
        const knownUpdatedAt = $40930a80e3207c3a$var$knownServerState.value[setup.id];
        if (knownUpdatedAt == null) return true;
        const data = JSON.parse((0, $gsNnp.exportSetupJson)(setup.id));
        return (data.updated_at || 0) > knownUpdatedAt;
    });
});
const $40930a80e3207c3a$export$61b5fcde7351f581 = (0, $TusQn.computed)(()=>{
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    return isLoggedIn.value && !$40930a80e3207c3a$var$hasCompletedFirstSync.value && $40930a80e3207c3a$var$isSilentSyncRunning.value;
});
const $40930a80e3207c3a$export$ba89e6afa06d6873 = (0, $TusQn.computed)(()=>{
    const { isLoggedIn: isLoggedIn } = (0, $aCKYX.useAuth)();
    return isLoggedIn.value && !$40930a80e3207c3a$var$hasCompletedFirstSync.value && !$40930a80e3207c3a$var$isSilentSyncRunning.value;
});
function $40930a80e3207c3a$export$d85aed67e7fca1e6() {
    return {
        syncAll: $40930a80e3207c3a$export$d1e86e2cf4ed4afc,
        resetSyncState: $40930a80e3207c3a$export$d6e0f64c04825ddd,
        hasLocalChanges: $40930a80e3207c3a$export$b40ce323ba164fb1,
        loadFreshAfterLogin: $40930a80e3207c3a$export$a139480ce624735e,
        registerAndKeepLocal: $40930a80e3207c3a$export$6b6d6fe2323c241c,
        discardLocalIdentity: $40930a80e3207c3a$export$33b23fc4eda3ad55,
        isLoadingAfterLogin: $40930a80e3207c3a$export$61b5fcde7351f581,
        loginSyncFailed: $40930a80e3207c3a$export$ba89e6afa06d6873
    };
}

});
parcelRegister("boWEz", function(module, exports) {

$parcel$export(module.exports, "useToasts", () => $84cf6ee9e522635f$export$c0652d2bc181de70);
parcelRequire("dk7qG");
var $01W3b = parcelRequire("01W3b");
const $84cf6ee9e522635f$var$toasts = (0, $01W3b.ref)([]);
let $84cf6ee9e522635f$var$nextId = 0;
const $84cf6ee9e522635f$var$DEFAULT_DURATION = 5000;
function $84cf6ee9e522635f$export$c0652d2bc181de70() {
    function pushToast(message, { duration: duration = $84cf6ee9e522635f$var$DEFAULT_DURATION, variant: variant = 'error' } = {}) {
        const id = $84cf6ee9e522635f$var$nextId++;
        $84cf6ee9e522635f$var$toasts.value.push({
            id: id,
            message: message,
            variant: variant
        });
        setTimeout(()=>{
            $84cf6ee9e522635f$var$toasts.value = $84cf6ee9e522635f$var$toasts.value.filter((t)=>t.id !== id);
        }, duration);
        return id;
    }
    return {
        toasts: $84cf6ee9e522635f$var$toasts,
        pushToast: pushToast
    };
}

});


parcelRegister("k8U8h", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $eaa018bbb4042908$export$93d4e7f90805808f);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");

var $hYNgF = parcelRequire("hYNgF");
const $eaa018bbb4042908$var$themes = [
    {
        id: 'range',
        label: 'Range'
    },
    {
        id: 'precision',
        label: 'Precision'
    },
    {
        id: 'field',
        label: 'Field'
    },
    {
        id: 'classic',
        label: 'Classic'
    },
    {
        id: 'dark',
        label: 'Dark'
    }
];
const $eaa018bbb4042908$var$currentTheme = (0, $hYNgF.usePersisted)('app-theme', 'range', {
    validate: (id)=>$eaa018bbb4042908$var$themes.some((t)=>t.id === id)
});
(0, $TusQn.watch)($eaa018bbb4042908$var$currentTheme, (id)=>{
    document.documentElement.setAttribute('data-theme', id);
}, {
    immediate: true
});
function $eaa018bbb4042908$var$setTheme(id) {
    $eaa018bbb4042908$var$currentTheme.value = id;
}
function $eaa018bbb4042908$export$93d4e7f90805808f() {
    return {
        themes: $eaa018bbb4042908$var$themes,
        currentTheme: $eaa018bbb4042908$var$currentTheme,
        setTheme: $eaa018bbb4042908$var$setTheme
    };
}

});

parcelRegister("5wYn9", function(module, exports) {

$parcel$export(module.exports, "default", () => $406ec59dc080b312$export$2e2bcd8739ae039);
let $406ec59dc080b312$var$script;




let $406ec59dc080b312$var$initialize = ()=>{
    $406ec59dc080b312$var$script = (parcelRequire("as5Aq"));
    if ($406ec59dc080b312$var$script.__esModule) $406ec59dc080b312$var$script = $406ec59dc080b312$var$script.default;
    $406ec59dc080b312$var$script.render = (parcelRequire("bn6ld")).render;
    $406ec59dc080b312$var$script.__cssModules = {};
    (parcelRequire("btAD7")).default($406ec59dc080b312$var$script);
    $406ec59dc080b312$var$script.__scopeId = 'data-v-8a60d7';
    $406ec59dc080b312$var$script.__file = "collapsable_panel.vue";
};
$406ec59dc080b312$var$initialize();
var $406ec59dc080b312$export$2e2bcd8739ae039 = $406ec59dc080b312$var$script;

});
parcelRegister("as5Aq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $79c0da4452dbfab0$export$2e2bcd8739ae039);
parcelRequire("dk7qG");
var $01W3b = parcelRequire("01W3b");

var $59JKe = parcelRequire("59JKe");
var $79c0da4452dbfab0$export$2e2bcd8739ae039 = {
    __name: 'collapsable_panel',
    props: {
        title: {
            type: String,
            required: true
        },
        open: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        },
        full_width: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'toggle'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        function toggle() {
            emit('toggle');
        }
        // Animate the body's height between 0 and its natural content height on
        // open/close, rather than the instant v-if snap.
        const { beforeEnter: beforeEnter, enter: enter, afterEnter: afterEnter, beforeLeave: beforeLeave, leave: leave, afterLeave: afterLeave } = (0, $59JKe.useHeightTransition)();
        const __returned__ = {
            props: props,
            emit: emit,
            toggle: toggle,
            beforeEnter: beforeEnter,
            enter: enter,
            afterEnter: afterEnter,
            beforeLeave: beforeLeave,
            leave: leave,
            afterLeave: afterLeave,
            ref: $01W3b.ref,
            get useHeightTransition () {
                return 0, $59JKe.useHeightTransition;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("59JKe", function(module, exports) {

$parcel$export(module.exports, "useHeightTransition", () => $3c1146ef7719c4bc$export$1668017c0059bc7d);
// Vue <Transition> hooks that animate an element's height between 0 and its
// natural content height, for enter/leave of elements whose content height
// isn't known ahead of time. Height is measured via scrollHeight at
// transition time and cleared again once the transition ends so it doesn't
// clip content that changes afterwards.
//
// Duration scales with that measured height rather than being one fixed
// value — a short panel (e.g. Calculated) and a tall one (Graph, Trajectory,
// up to 80vh) were both animating in the same fixed 0.2s, which for the tall
// ones is fast enough that the height change barely reads as motion: it
// looks like the content just gets cut off/appears rather than sliding.
const $3c1146ef7719c4bc$var$MIN_DURATION_MS = 200;
const $3c1146ef7719c4bc$var$MAX_DURATION_MS = 450;
const $3c1146ef7719c4bc$var$DURATION_PER_PX_MS = 0.35;
function $3c1146ef7719c4bc$var$durationMsFor(heightPx) {
    return Math.min($3c1146ef7719c4bc$var$MAX_DURATION_MS, Math.max($3c1146ef7719c4bc$var$MIN_DURATION_MS, heightPx * $3c1146ef7719c4bc$var$DURATION_PER_PX_MS));
}
function $3c1146ef7719c4bc$export$1668017c0059bc7d() {
    function beforeEnter(el) {
        el.style.height = '0';
        el.style.overflow = 'hidden';
    }
    function enter(el) {
        const targetHeight = el.scrollHeight;
        el.style.transition = `height ${$3c1146ef7719c4bc$var$durationMsFor(targetHeight)}ms ease`;
        requestAnimationFrame(()=>{
            el.style.height = targetHeight + 'px';
        });
    }
    function afterEnter(el) {
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
    }
    function beforeLeave(el) {
        el.style.height = el.scrollHeight + 'px';
        el.style.overflow = 'hidden';
    }
    function leave(el) {
        const startHeight = el.scrollHeight;
        el.style.transition = `height ${$3c1146ef7719c4bc$var$durationMsFor(startHeight)}ms ease`;
        requestAnimationFrame(()=>{
            el.style.height = '0';
        });
    }
    function afterLeave(el) {
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
    }
    return {
        beforeEnter: beforeEnter,
        enter: enter,
        afterEnter: afterEnter,
        beforeLeave: beforeLeave,
        leave: leave,
        afterLeave: afterLeave
    };
}

});


parcelRegister("bn6ld", function(module, exports) {

$parcel$export(module.exports, "render", () => $8476c2e6454531ab$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8476c2e6454531ab$var$_hoisted_1 = {
    class: "panel-clip"
};
const $8476c2e6454531ab$var$_hoisted_2 = [
    "tabindex",
    "role",
    "aria-expanded"
];
const $8476c2e6454531ab$var$_hoisted_3 = {
    key: 0,
    class: "panel-body"
};
function $8476c2e6454531ab$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8POXm.normalizeClass)([
            "panel",
            {
                compact: $props.compact,
                open: $props.open,
                fixed: $props.fixed,
                full_width: $props.full_width
            }
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $8476c2e6454531ab$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", {
                class: "panel-header",
                tabindex: $props.fixed ? undefined : 0,
                role: $props.fixed ? undefined : 'button',
                "aria-expanded": $props.fixed ? undefined : $props.open,
                onClick: _cache[0] || (_cache[0] = ($event)=>!$props.fixed && $setup.toggle()),
                onKeydown: [
                    _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)(($event)=>!$props.fixed && $setup.toggle(), [
                        "enter"
                    ])),
                    _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)(($event)=>!$props.fixed && $setup.toggle(), [
                        "prevent"
                    ]), [
                        "space"
                    ]))
                ]
            }, [
                (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($props.title), 1),
                !$props.fixed ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                    key: 0,
                    class: (0, $8POXm.normalizeClass)([
                        "toggle-icon",
                        {
                            collapsed: !$props.open
                        }
                    ])
                }, "\u25BC", 2)) : (0, $TusQn.createCommentVNode)("", true)
            ], 40, $8476c2e6454531ab$var$_hoisted_2),
            (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                onBeforeEnter: $setup.beforeEnter,
                onEnter: $setup.enter,
                onAfterEnter: $setup.afterEnter,
                onBeforeLeave: $setup.beforeLeave,
                onLeave: $setup.leave,
                onAfterLeave: $setup.afterLeave
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        $props.open ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8476c2e6454531ab$var$_hoisted_3, [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                _: 3
            }, 8, [
                "onBeforeEnter",
                "onEnter",
                "onAfterEnter",
                "onBeforeLeave",
                "onLeave",
                "onAfterLeave"
            ])
        ])
    ], 2);
}

});

parcelRegister("btAD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $85aed113dfc49f88$export$2e2bcd8739ae039);
let $85aed113dfc49f88$var$NOOP = ()=>{};
var $85aed113dfc49f88$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lj2Xa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82da9cc420adbc5$export$2e2bcd8739ae039);
let $f82da9cc420adbc5$var$script;




let $f82da9cc420adbc5$var$initialize = ()=>{
    $f82da9cc420adbc5$var$script = (parcelRequire("bI4hj"));
    if ($f82da9cc420adbc5$var$script.__esModule) $f82da9cc420adbc5$var$script = $f82da9cc420adbc5$var$script.default;
    $f82da9cc420adbc5$var$script.render = (parcelRequire("40NNZ")).render;
    $f82da9cc420adbc5$var$script.__cssModules = {};
    (parcelRequire("No6Kb")).default($f82da9cc420adbc5$var$script);
    $f82da9cc420adbc5$var$script.__scopeId = 'data-v-98d0fc';
    $f82da9cc420adbc5$var$script.__file = "account_widget.vue";
};
$f82da9cc420adbc5$var$initialize();
var $f82da9cc420adbc5$export$2e2bcd8739ae039 = $f82da9cc420adbc5$var$script;

});
parcelRegister("bI4hj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $88671f54a9348abf$export$2e2bcd8739ae039);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $aCKYX = parcelRequire("aCKYX");

var $5xJ83 = parcelRequire("5xJ83");

var $gK4GT = parcelRequire("gK4GT");

var $boWEz = parcelRequire("boWEz");
var $88671f54a9348abf$export$2e2bcd8739ae039 = {
    __name: 'account_widget',
    setup (__props, { expose: __expose }) {
        __expose();
        const { isLoggedIn: isLoggedIn, email: email, logout: logout, scannerAccess: scannerAccess, refreshProfile: refreshProfile } = (0, $aCKYX.useAuth)();
        const { syncAll: syncAll, resetSyncState: resetSyncState, hasLocalChanges: hasLocalChanges } = (0, $5xJ83.useSync)();
        const { replaceAllSetups: replaceAllSetups } = (0, $gK4GT.useSetups)();
        const { pushToast: pushToast } = (0, $boWEz.useToasts)();
        // Two separate trigger/popover pairs — one for desktop (.account-widget,
        // where the setup selector/undo-redo already render inline elsewhere in
        // the bar, so its popover is just the account-specific items) and one
        // for phones (.mobile-widget, where everything collapses into this one
        // dropdown instead — see the template comment above it). Only one pair
        // is ever visually present at a time (CSS hides the other per
        // breakpoint), but both share the same `expanded` state and toggle(), so
        // opening/closing whichever is visible just works without the component
        // needing to know which breakpoint it's currently in.
        const root = (0, $01W3b.ref)(null);
        const mobileRoot = (0, $01W3b.ref)(null);
        const expanded = (0, $01W3b.ref)(false);
        const syncing = (0, $01W3b.ref)(false);
        const loggingOut = (0, $01W3b.ref)(false);
        function close() {
            expanded.value = false;
        }
        function toggle() {
            if (expanded.value) close();
            else expanded.value = true;
        }
        // `silent` (passed straight through to syncAll, see sync.js's file header)
        // suppresses ALL feedback, success or failure — background triggers (page
        // load, regained connectivity) shouldn't say anything either way. Only the
        // "Sync now" button itself calls this non-silent, so only a deliberate
        // click ever reports its own outcome — a truthful one, since syncAll()
        // never throws (it catches and reports its own failures internally) and
        // its return value, not a try/catch here, is what tells success from
        // failure; without checking it this used to claim "Sync complete." even
        // when the sync had just failed.
        async function onSync({ silent: silent = false } = {}) {
            syncing.value = true;
            try {
                const ok = await syncAll({
                    silent: silent
                });
                if (!silent && ok) pushToast('Sync complete.', {
                    variant: 'success'
                });
            } finally{
                syncing.value = false;
            }
        }
        async function onLogout() {
            loggingOut.value = true;
            try {
                // Best-effort: give any not-yet-pushed edit one last chance to reach
                // the server before resetSyncState()/replaceAllSetups() below wipe the
                // local bookkeeping (knownServerState, pendingDeletes) that syncAll
                // needs to even know what to push. Bare call, so silent by default
                // (see syncAll) — this is an automatic side effect of clicking Log
                // Out, not itself something to report; it never throws either way, so
                // logout proceeds regardless of whether it worked. The edit itself
                // isn't lost if it fails, only unsynced until logging back in.
                await syncAll();
            } finally{
                loggingOut.value = false;
            }
            logout();
            resetSyncState();
            // Same reasoning as loadFreshAfterLogin (see sync.js): local setups
            // belong to the account that was just logged out of, so they shouldn't
            // linger around for whoever (or whatever account) uses this browser
            // next. Falls back to one bare "Default" setup, same as a fresh install.
            replaceAllSetups([], null);
            close();
        }
        // Closing on an outside click is the behavior people expect from this kind
        // of corner dropdown — without it, the only way to dismiss is logging out
        // or syncing, which is a trap for anyone who opened it by mistake. Uses
        // composedPath() (the propagation path frozen at dispatch time) rather than
        // e.target: a click on a button that itself triggers a reactive re-render
        // can get its own element replaced in the DOM before this listener runs
        // (browsers run a microtask checkpoint between each individual listener
        // invocation during dispatch, and Vue's re-render is scheduled as a
        // microtask), which would make a plain root.value.contains(e.target) check
        // see a now-detached node and read false even though the click was
        // genuinely inside root. composedPath() isn't affected since it's computed
        // once, before any listener runs. Checks both root refs since only one is
        // ever visible per breakpoint, but both share `expanded`.
        function onDocumentClick(e) {
            if (!expanded.value) return;
            const path = e.composedPath();
            const insideDesktop = root.value && path.includes(root.value);
            const insideMobile = mobileRoot.value && path.includes(mobileRoot.value);
            if (!insideDesktop && !insideMobile) close();
        }
        // The DB is the source of truth once logged in — the app should reconcile
        // with it as soon as it reasonably can, not only when someone remembers to
        // press "Sync now": once on mount (covers "reload the page" as the
        // simplest way to pick up whatever changed elsewhere) and again any time
        // the browser regains connectivity after being offline.
        function onOnline() {
            if (isLoggedIn.value) onSync({
                silent: true
            });
        }
        (0, $TusQn.onMounted)(()=>{
            document.addEventListener('click', onDocumentClick);
            window.addEventListener('online', onOnline);
            if (isLoggedIn.value) onSync({
                silent: true
            });
            // Refreshes scannerAccess for the Score Sheet Scanner link below — lives
            // here (rather than only on the pages that show it) since this widget is
            // shared across every page, and scanner access can be granted server-side
            // (a direct DB edit) after this browser already logged in.
            refreshProfile();
        });
        (0, $TusQn.onUnmounted)(()=>{
            document.removeEventListener('click', onDocumentClick);
            window.removeEventListener('online', onOnline);
        });
        const __returned__ = {
            isLoggedIn: isLoggedIn,
            email: email,
            logout: logout,
            scannerAccess: scannerAccess,
            refreshProfile: refreshProfile,
            syncAll: syncAll,
            resetSyncState: resetSyncState,
            hasLocalChanges: hasLocalChanges,
            replaceAllSetups: replaceAllSetups,
            pushToast: pushToast,
            root: root,
            mobileRoot: mobileRoot,
            expanded: expanded,
            syncing: syncing,
            loggingOut: loggingOut,
            close: close,
            toggle: toggle,
            onSync: onSync,
            onLogout: onLogout,
            onDocumentClick: onDocumentClick,
            onOnline: onOnline,
            ref: $01W3b.ref,
            onMounted: $TusQn.onMounted,
            onUnmounted: $TusQn.onUnmounted,
            get useAuth () {
                return 0, $aCKYX.useAuth;
            },
            get useSync () {
                return 0, $5xJ83.useSync;
            },
            get useSetups () {
                return 0, $gK4GT.useSetups;
            },
            get useToasts () {
                return 0, $boWEz.useToasts;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("40NNZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $2ebdcbc75230a867$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $2ebdcbc75230a867$var$_hoisted_1 = {
    class: "account-bar"
};
const $2ebdcbc75230a867$var$_hoisted_2 = {
    class: "account-bar-center"
};
const $2ebdcbc75230a867$var$_hoisted_3 = {
    class: "account-bar-right"
};
const $2ebdcbc75230a867$var$_hoisted_4 = {
    class: "account-widget",
    ref: "root"
};
const $2ebdcbc75230a867$var$_hoisted_5 = {
    key: 0,
    href: "/login/",
    class: "btn-copy account-trigger"
};
const $2ebdcbc75230a867$var$_hoisted_6 = {
    key: 0,
    class: "account-popover"
};
const $2ebdcbc75230a867$var$_hoisted_7 = {
    class: "account-email"
};
const $2ebdcbc75230a867$var$_hoisted_8 = [
    "disabled"
];
const $2ebdcbc75230a867$var$_hoisted_9 = {
    key: 1,
    class: "btn-copy account-profile-link",
    href: "/score-sheet-scanner/"
};
const $2ebdcbc75230a867$var$_hoisted_10 = [
    "disabled"
];
const $2ebdcbc75230a867$var$_hoisted_11 = {
    class: "mobile-widget",
    ref: "mobileRoot"
};
const $2ebdcbc75230a867$var$_hoisted_12 = [
    "aria-expanded"
];
const $2ebdcbc75230a867$var$_hoisted_13 = {
    key: 0,
    class: "mobile-popover"
};
const $2ebdcbc75230a867$var$_hoisted_14 = {
    class: "mobile-popover-actions"
};
const $2ebdcbc75230a867$var$_hoisted_15 = {
    class: "mobile-popover-setup"
};
const $2ebdcbc75230a867$var$_hoisted_16 = {
    class: "mobile-popover-account"
};
const $2ebdcbc75230a867$var$_hoisted_17 = {
    class: "account-email"
};
const $2ebdcbc75230a867$var$_hoisted_18 = [
    "disabled"
];
const $2ebdcbc75230a867$var$_hoisted_19 = {
    key: 1,
    class: "btn-copy account-profile-link",
    href: "/score-sheet-scanner/"
};
const $2ebdcbc75230a867$var$_hoisted_20 = [
    "disabled"
];
const $2ebdcbc75230a867$var$_hoisted_21 = {
    key: 1,
    href: "/login/",
    class: "btn-copy account-profile-link"
};
function $2ebdcbc75230a867$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2ebdcbc75230a867$var$_hoisted_1, [
        _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("a", {
            href: "/",
            class: "app-title"
        }, "Sight Marks Calculator", -1)),
        (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_2, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_3, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "right"),
            (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_4, [
                !$setup.isLoggedIn ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", $2ebdcbc75230a867$var$_hoisted_5, "Log In")) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn-copy account-trigger",
                        onClick: $setup.toggle
                    }, [
                        ..._cache[2] || (_cache[2] = [
                            (0, $TusQn.createTextVNode)(" Profile ", -1),
                            (0, $TusQn.createElementVNode)("span", {
                                class: "caret"
                            }, "\u25BE", -1)
                        ])
                    ]),
                    $setup.expanded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2ebdcbc75230a867$var$_hoisted_6, [
                        (0, $TusQn.createElementVNode)("p", $2ebdcbc75230a867$var$_hoisted_7, (0, $8POXm.toDisplayString)($setup.email), 1),
                        $setup.hasLocalChanges ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: "btn-copy",
                            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.onSync()),
                            disabled: $setup.syncing
                        }, (0, $8POXm.toDisplayString)($setup.syncing ? "Syncing\u2026" : 'Sync now'), 9, $2ebdcbc75230a867$var$_hoisted_8)) : (0, $TusQn.createCommentVNode)("", true),
                        _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("a", {
                            class: "btn-copy account-profile-link",
                            href: "/profile/"
                        }, "Profile", -1)),
                        _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("a", {
                            class: "btn-copy account-profile-link",
                            href: "/setups/"
                        }, "Setups", -1)),
                        $setup.scannerAccess ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", $2ebdcbc75230a867$var$_hoisted_9, "Score Sheet Scanner")) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-delete",
                            onClick: $setup.onLogout,
                            disabled: $setup.loggingOut
                        }, (0, $8POXm.toDisplayString)($setup.loggingOut ? "Logging out\u2026" : 'Log Out'), 9, $2ebdcbc75230a867$var$_hoisted_10)
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ], 64))
            ], 512)
        ]),
        (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "mobile-toggle",
                onClick: $setup.toggle,
                "aria-expanded": $setup.expanded,
                "aria-label": "Menu"
            }, "\u2630", 8, $2ebdcbc75230a867$var$_hoisted_12),
            $setup.expanded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2ebdcbc75230a867$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_14, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
                (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_15, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "right")
                ]),
                (0, $TusQn.createElementVNode)("div", $2ebdcbc75230a867$var$_hoisted_16, [
                    $setup.isLoggedIn ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        (0, $TusQn.createElementVNode)("p", $2ebdcbc75230a867$var$_hoisted_17, (0, $8POXm.toDisplayString)($setup.email), 1),
                        $setup.hasLocalChanges ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: "btn-copy",
                            onClick: _cache[1] || (_cache[1] = ($event)=>$setup.onSync()),
                            disabled: $setup.syncing
                        }, (0, $8POXm.toDisplayString)($setup.syncing ? "Syncing\u2026" : 'Sync now'), 9, $2ebdcbc75230a867$var$_hoisted_18)) : (0, $TusQn.createCommentVNode)("", true),
                        _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("a", {
                            class: "btn-copy account-profile-link",
                            href: "/profile/"
                        }, "Profile", -1)),
                        _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("a", {
                            class: "btn-copy account-profile-link",
                            href: "/setups/"
                        }, "Setups", -1)),
                        $setup.scannerAccess ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", $2ebdcbc75230a867$var$_hoisted_19, "Score Sheet Scanner")) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-delete",
                            onClick: $setup.onLogout,
                            disabled: $setup.loggingOut
                        }, (0, $8POXm.toDisplayString)($setup.loggingOut ? "Logging out\u2026" : 'Log Out'), 9, $2ebdcbc75230a867$var$_hoisted_20)
                    ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", $2ebdcbc75230a867$var$_hoisted_21, "Log In"))
                ])
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ], 512)
    ]);
}

});

parcelRegister("No6Kb", function(module, exports) {

$parcel$export(module.exports, "default", () => $094747050c713d52$export$2e2bcd8739ae039);
let $094747050c713d52$var$NOOP = ()=>{};
var $094747050c713d52$export$2e2bcd8739ae039 = (script)=>{};

});



//# sourceMappingURL=app.f122056a.js.map
